var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Feb  4 21:54:21 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2012, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-Italic",
    horizAdvX: 598
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway",
    fontWeight: 400,
    fontStyle: "italic",
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 5 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 521,
    capHeight: 709,
    bbox: "-260 -224 1341 933",
    underlineThickness: 50,
    underlinePosition: -150,
    slope: -12,
    unicodeRange: "U+000D-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 562,
    d: "M130 467h-68l11 54h69l1 6q8 33 24 64.5t40 56t55 39t70 14.5q34 0 59.5 -8t42.5 -18q26 29 60 47t79 18q22 0 37 -4t26 -9.5t18 -11t12 -8.5l-30 -49q-8 7 -21 14.5t-42 7.5q-30 0 -53.5 -13t-41 -33t-29 -46t-16.5 -51l-3 -16h155l-11 -54h-156l-99 -467h-68l99 467 h-152l-99 -467h-68zM362 521q5 28 15 55t24 46q-13 12 -33.5 16t-36.5 4q-27 0 -47.5 -10t-35 -26.5t-24 -37t-13.5 -40.5l-1 -7h152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 484,
    d: "M130 467h-68l11 54h69l2 14q5 36 23 72.5t47 66t67 48t84 18.5q52 0 86 -17t49 -30l-41 -49q-14 15 -41 25.5t-62 10.5q-30 0 -54 -13t-42 -33t-30 -46t-17 -51l-3 -16h248l-111 -521h-68l99 467h-180l-99 -467h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 559,
    d: "M403 -6q-40 0 -60 21t-20 52q0 8 1 15.5t4 20.5l100 468q2 8 3 15.5t1 15.5q0 31 -18.5 54.5t-64.5 23.5q-28 0 -50.5 -11.5t-39.5 -31.5t-29 -46.5t-18 -56.5l-2 -13h102l-11 -54h-103l-99 -467h-68l99 467h-68l11 54h69l4 19q9 44 28 80.5t46 63t62.5 41.5t78.5 15 q72 0 107 -32t35 -85q0 -20 -4 -39l-99 -467q-2 -10 -2 -16q0 -17 9.5 -31.5t31.5 -14.5q17 0 35 4.5l26 6.5l-2 -56q-1 -1 -9.5 -3.5t-22 -5.5t-30.5 -5t-33 -2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 704,
    d: "M130 467h-68l11 54h69l1 6q7 31 23 62t40 56t55.5 40.5t70.5 15.5q34 0 59.5 -8t42.5 -18q28 29 65.5 47t85.5 18q24 0 45 -5t38.5 -12t30.5 -15.5t21 -14.5l-41 -49q-12 14 -40 25t-60 11t-56.5 -13t-42.5 -33t-30 -46t-17 -51l-3 -16h249l-111 -521h-68l99 467h-181 l-99 -467h-68l99 467h-152l-99 -467h-68zM362 521q5 26 15 54t24 47q-13 12 -33.5 16t-36.5 4q-27 0 -48 -10.5t-35.5 -27t-23.5 -37t-13 -39.5l-1 -7h152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 783,
    d: "M629 -6q-42 0 -62 20.5t-20 52.5q0 9 1 17.5t4 22.5l99 464q2 8 3 15.5t1 15.5q0 32 -18 55t-62 23q-30 0 -53 -12.5t-40 -33.5t-28.5 -48t-17.5 -56l-2 -9h102l-12 -54h-102l-99 -467h-68l99 467h-156l-99 -467h-68l99 467h-68l11 54h69l1 6q8 34 25.5 65.5t42.5 55.5 t56.5 38.5t69.5 14.5q35 0 57 -8t39 -18q29 31 66.5 48t85.5 17q72 0 107 -32.5t35 -84.5q0 -16 -5 -39l-99 -467q-2 -10 -2 -17q0 -17 9.5 -31t32.5 -14q8 0 18 1.5t19 4t15.5 4t7.5 1.5l-2 -56q0 -1 -9 -3.5t-22 -5.5t-29.5 -5t-31.5 -2zM365 521q7 29 15.5 57t19.5 45 q-13 12 -30 15.5t-33 3.5q-26 0 -47.5 -10t-38 -26t-26.5 -36.5t-14 -40.5l-1 -8h155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 249
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 248,
    d: "M75 228l103 489h68l-103 -489h-68zM26 0l24 112h69l-25 -112h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 287,
    d: "M112 522l41 194h60l-41 -194h-60zM205 522l42 194h59l-41 -194h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 652,
    d: "M648 457h-124l-86 -196h127l-11 -54h-140l-91 -207h-58l93 207h-177l-91 -207h-58l93 207h-107l11 54h121l85 196h-124l12 51h136l89 202h57l-90 -202h177l88 202h58l-90 -202h111zM381 261l87 196h-176l-86 -196h175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 594,
    d: "M546 577q-20 32 -60.5 53t-97.5 23l-56 -267q45 -10 82.5 -22.5t64 -31.5t41 -45.5t14.5 -63.5q0 -56 -21.5 -98.5t-59.5 -71t-89.5 -43.5t-110.5 -16l-21 -97h-36l21 98q-140 9 -222 102l47 57q24 -37 74 -64.5t117 -32.5l57 267q-45 12 -80 25t-59 30t-36 40.5 t-12 55.5q0 53 20.5 96t56.5 73.5t84.5 48.5t104.5 21l22 101h36l-21 -100q62 -2 107.5 -23.5t77.5 -58.5zM457 202q0 46 -36 70.5t-104 44.5l-56 -261q91 0 143.5 37.5t52.5 108.5zM179 497q0 -43 31 -65t94 -39l55 259q-95 -5 -137.5 -48t-42.5 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 688,
    d: "M211 433q-26 0 -47 9t-36 25t-23.5 37.5t-8.5 46.5q0 34 15 64.5t39.5 54t56.5 37t66 13.5q26 0 47 -9t36 -25t23.5 -38t8.5 -47q0 -34 -15 -64.5t-40 -53.5t-56.5 -36.5t-65.5 -13.5zM220 472q22 0 42.5 10.5t37 28t26.5 39.5t10 46q0 35 -20 59.5t-52 24.5 q-22 0 -42.5 -10.5t-37 -27.5t-26.5 -39t-10 -46q0 -35 20 -60t52 -25zM439 -10q-26 0 -47 9t-36.5 25t-24 38t-8.5 47q0 34 15 64.5t40 53.5t57 36.5t65 13.5q26 0 47 -9t36 -25t23.5 -37.5t8.5 -46.5q0 -34 -15 -64.5t-39.5 -54t-56 -37t-65.5 -13.5zM447 30q22 0 43 10 t37.5 27.5t26.5 39.5t10 46q0 35 -20.5 60t-52.5 25q-22 0 -43 -10.5t-37.5 -28t-26.5 -39.5t-10 -46q0 -35 20.5 -59.5t52.5 -24.5zM7 27l669 687l28 -30l-669 -688z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 671,
    d: "M408 104q-49 -54 -106 -84t-117 -30q-37 0 -67.5 12.5t-52.5 34t-34.5 52t-12.5 66.5q0 40 14.5 74.5t39.5 64t59.5 55.5t75.5 51q-30 46 -43 78.5t-13 61.5q0 37 17 69.5t45.5 57t66 38.5t78.5 14q54 0 96 -28t63 -77l-47 -42q-16 42 -48.5 68t-74.5 26q-26 0 -50 -9.5 t-42 -25.5t-29 -37t-11 -44t13 -53.5t48 -81.5l144 -206q26 44 44.5 96t29.5 111h160l-12 -55h-99q-16 -57 -38.5 -107.5t-51.5 -92.5l113 -161h-86zM199 46q48 0 93.5 27.5t85.5 75.5l-142 207q-70 -44 -110.5 -89.5t-40.5 -103.5q0 -55 32.5 -86t81.5 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 193,
    d: "M112 521l41 195h60l-41 -195h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 263,
    d: "M44 260q0 66 18 126.5t49 119t72.5 116t88.5 117.5l46 -25q-30 -35 -66 -86.5t-68 -111t-53.5 -124t-21.5 -125.5q0 -62 14 -137t40 -140l-56 -27q-29 69 -46 147t-17 150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 263,
    d: "M239 432q0 -62 -17 -121.5t-47 -117t-71.5 -115t-90.5 -115.5l-45 27q45 54 83 108.5t65 108.5t42 108.5t15 108.5q0 39 -4.5 80.5t-12 80.5t-17 72.5t-19.5 56.5l58 25q26 -72 43.5 -151.5t17.5 -155.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 313,
    d: "M135 546l54 62l-60 22l18 36l61 -26l13 73h41l-18 -73l73 26l2 -36l-70 -22l29 -62l-36 -22l-26 65l-55 -65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 414,
    d: "M372 383v-56h-124v-135h-63v135h-124v56h124v135h63v-135h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 222,
    d: "M4 -81l35 84h-23l20 95h65l-20 -95l-42 -84h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 405,
    d: "M51 241l13 63h278l-13 -63h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 188,
    d: "M2 0l21 98h58l-21 -98h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 599,
    d: "M651 710l-600 -710h-77l601 710h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 592,
    d: "M230 -10q-43 0 -77 17t-58 48t-36.5 73.5t-12.5 92.5q0 78 26 146.5t69 119.5t99.5 80.5t118.5 29.5q42 0 76 -17.5t58 -48t37 -73t13 -93.5q0 -78 -26 -146.5t-69.5 -119t-100 -80t-117.5 -29.5zM243 54q46 0 88 23.5t73.5 64.5t50 96.5t18.5 119.5q0 78 -33.5 126.5 t-93.5 48.5q-47 0 -89 -24t-73.5 -65t-50 -97t-18.5 -119q0 -78 33.5 -126t94.5 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 410,
    d: "M16 62h135l91 428q-11 -12 -32 -26t-46 -26t-50.5 -20t-44.5 -8l14 66q22 0 51 13t55.5 30t46.5 32t23 20h69l-108 -509h121l-13 -62h-325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 503,
    d: "M-17 0q7 34 19 69.5t35 69.5t60.5 65.5t96.5 57.5q58 25 97.5 47t64.5 43.5t36 44t11 49.5q0 29 -21.5 51.5t-75.5 22.5q-30 0 -58.5 -10t-52.5 -23.5t-42 -28t-28 -23.5l-30 51q7 6 27 22t49.5 32t67.5 28.5t82 12.5q38 0 67.5 -10.5t49 -28.5t29.5 -41.5t10 -50.5 q0 -43 -18 -75t-47.5 -56.5t-66.5 -43.5t-74 -36q-47 -21 -80 -41t-55.5 -41t-36 -44t-21.5 -51h328l-13 -62h-410v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 510,
    d: "M150 -147q-72 0 -120 30.5t-64 84.5l55 43q11 -44 46 -70t96 -26q84 0 134.5 46t50.5 126q0 54 -34.5 86t-102.5 32h-24l12 58h26q42 0 75.5 11.5t56.5 32t35.5 48.5t12.5 61q0 48 -31 73t-82 25q-54 0 -99.5 -25.5t-77.5 -70.5l-34 42q17 26 42.5 47.5t55.5 36.5 t64 23.5t69 8.5q77 0 121.5 -40.5t44.5 -106.5q0 -35 -12.5 -67.5t-34 -58.5t-51.5 -44t-65 -23q50 -9 77 -47t27 -94q0 -53 -20.5 -97.5t-57 -76.5t-85.5 -50t-106 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 527,
    d: "M287 51h-315l13 60l427 460h54l-98 -458h84l-13 -62h-84l-38 -178h-68zM307 113l75 351l-324 -351h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 526,
    d: "M157 -149q-72 0 -122 37t-66 99l52 34q16 -49 55.5 -79t93.5 -30q40 0 77.5 15.5t66 43.5t45.5 65t17 81q0 60 -35 97t-92 37q-44 0 -87.5 -20.5t-75.5 -59.5h-63q4 9 17 42t31 77.5t37.5 94t36 91t27.5 68.5t12 27h326l-14 -63h-275l-100 -255q30 28 68 43.5t80 15.5 q40 0 72.5 -13.5t56 -37.5t36.5 -57.5t13 -73.5q0 -61 -24.5 -112t-65 -88t-93 -58t-107.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 588,
    d: "M238 -10q-89 0 -139.5 59.5t-50.5 162.5q0 99 25.5 190t71.5 160.5t111 111t143 41.5q66 0 112 -35t61 -97l-52 -40q-10 51 -46 81.5t-89 30.5q-43 0 -84 -22.5t-75 -63t-59 -97.5t-36 -127q34 60 92.5 94.5t124.5 34.5q42 0 76.5 -15t58.5 -41.5t37.5 -62.5t13.5 -78 q0 -58 -25 -110t-66 -91.5t-94.5 -62.5t-110.5 -23zM251 50q40 0 79 17.5t69.5 47.5t49 69t18.5 82q0 32 -10 59.5t-28 48t-43.5 32.5t-56.5 12q-41 0 -79.5 -17.5t-69 -47.5t-49 -69t-18.5 -82q0 -32 10 -59.5t28.5 -48t44 -32.5t55.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 514,
    d: "M436 520h-360l13 63h469l-492 -710h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 570,
    d: "M217 -8q-44 0 -80 13.5t-61 37t-38.5 55.5t-13.5 69q0 42 16.5 76.5t42 61.5t56.5 45.5t61 29.5q-35 17 -58 49t-23 75q0 49 24 87t60.5 64.5t81.5 40.5t87 14q34 0 66 -10t57 -29t40 -47.5t15 -64.5q0 -33 -12.5 -60.5t-33.5 -50t-47.5 -40t-54.5 -28.5q43 -17 71.5 -57 t28.5 -94q0 -53 -24.5 -96.5t-64.5 -74.5t-91 -48.5t-105 -17.5zM233 53q34 0 69.5 12.5t64.5 35.5t47.5 55t18.5 71q0 29 -12 52t-31.5 39t-44.5 24.5t-51 8.5q-34 0 -69.5 -12.5t-64 -35.5t-47 -55t-18.5 -71q0 -29 11.5 -52t31 -39t44.5 -24.5t51 -8.5zM307 405 q27 0 57.5 9.5t56 28t42 45t16.5 60.5q0 24 -9.5 42.5t-26 31t-38.5 19.5t-47 7q-31 0 -61.5 -10t-55 -28.5t-39.5 -44.5t-15 -58q0 -24 10.5 -43t27.5 -32t38.5 -20t43.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 571,
    d: "M173 -155q-66 0 -112 35t-61 98l52 39q9 -51 45 -81t90 -30q43 0 84.5 22.5t76 63t59 97.5t33.5 127q-34 -60 -92.5 -95t-124.5 -35q-42 0 -76 15t-58.5 41.5t-38 62.5t-13.5 78q0 58 25 110t66 91.5t95 62.5t111 23q88 0 139 -59t51 -162q0 -99 -25.5 -190.5t-72 -161 t-111 -111t-142.5 -41.5zM242 142q41 0 80 17.5t69.5 47.5t49 69.5t18.5 82.5q0 31 -10 59t-28.5 48.5t-44 32.5t-56.5 12q-40 0 -79 -17.5t-69.5 -47.5t-49.5 -69.5t-19 -82.5q0 -32 10.5 -59.5t29 -48t44 -32.5t55.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 185,
    d: "M88 420l21 98h58l-21 -98h-58zM-1 0l22 98h57l-21 -98h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 190,
    d: "M90 420l20 98h58l-21 -98h-57zM-10 -81l34 84h-23l20 95h65l-20 -95l-42 -84h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 545,
    d: "M30 276l419 252v-73l-320 -196l320 -195v-75l-419 250v37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 471,
    d: "M79 194v49h301v-49h-301zM79 309v49h301v-49h-301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 545,
    d: "M496 239l-419 -250v75l320 195l-320 196v73l419 -252v-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 458,
    d: "M124 202q14 66 41.5 105t74.5 65q24 14 54 28t55.5 34.5t43 50t17.5 74.5q0 51 -30.5 77t-72.5 26q-25 0 -49.5 -8t-47 -21.5t-41.5 -32.5t-34 -40l-40 30q19 31 45.5 55t56 40.5t61 25t62.5 8.5t58.5 -9.5t48.5 -28t33 -47t12 -66.5q0 -50 -14 -84t-38 -58t-55 -41.5 t-64 -34.5q-19 -10 -37 -20.5t-33.5 -27t-28 -40.5t-20.5 -60h-58zM83 0l23 107h57l-22 -107h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 803,
    d: "M560 21q32 0 59 28t46.5 70t30 91t10.5 91q0 53 -17 101.5t-49.5 85.5t-80 59t-108.5 22q-74 0 -144 -32t-125 -87.5t-88.5 -129.5t-33.5 -158q0 -59 17.5 -109t49.5 -86.5t78.5 -57.5t103.5 -21q40 0 76.5 10t75.5 28l5 -32q-42 -20 -84.5 -30t-82.5 -10 q-60 0 -110.5 22.5t-87 63t-56.5 96.5t-20 123q0 63 18 120.5t48.5 107t72.5 89.5t90.5 68t100.5 43.5t104 15.5q66 0 118 -23.5t88.5 -64t56 -93.5t19.5 -111q0 -43 -11 -99.5t-34.5 -107t-60 -85.5t-87.5 -35q-29 0 -46 14.5t-17 49.5v13t2 15q-33 -32 -77 -52.5 t-89 -20.5q-35 0 -63.5 14t-48.5 38.5t-30.5 57t-10.5 70.5q0 53 20 102.5t53.5 87t77 60t90.5 22.5q51 0 85 -25.5t49 -67.5l18 88h45l-75 -351q-3 -14 -4 -23.5t-1 -15.5q0 -39 34 -39zM341 44q24 0 48.5 9t46.5 24.5t38.5 35.5t25.5 43l29 154q-15 53 -47.5 78t-74.5 25 q-35 0 -69 -17.5t-61 -47t-44 -69t-17 -84.5q0 -33 9.5 -60.5t26.5 -48t39.5 -31.5t49.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 641,
    d: "M175 710h326q30 0 52.5 -12.5t37.5 -32.5t22.5 -46t7.5 -54q0 -32 -10 -62.5t-28 -57t-43.5 -47.5t-55.5 -34q45 -15 68.5 -54t23.5 -90q0 -48 -20 -88t-52.5 -69.5t-74.5 -46t-87 -16.5h-318zM355 61q29 0 56.5 13.5t48.5 36t34 51t13 59.5q0 22 -6 42t-17.5 35 t-27.5 23.5t-37 8.5h-256l-57 -269h249zM405 387q28 0 54 13.5t46 35.5t32 50.5t12 59.5q0 43 -22 73t-61 30h-235l-56 -262h230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 656,
    d: "M294 -6q-59 0 -105 25.5t-77.5 67.5t-48 96t-16.5 111q0 73 30.5 147.5t84.5 135t128 99t162 38.5q91 0 145.5 -43t71.5 -112l-63 -34q-9 35 -26.5 59t-40.5 39t-50 21.5t-54 6.5q-70 0 -128.5 -32.5t-100.5 -84t-65.5 -114.5t-23.5 -123q0 -49 13.5 -92.5t38.5 -76.5 t61 -52t81 -19q28 0 59.5 7.5t62.5 24t60 41t52 59.5l52 -30q-25 -40 -60.5 -70.5t-76.5 -51.5t-84 -32t-82 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 690,
    d: "M175 710h230q66 0 115 -21t81 -58t47.5 -86.5t15.5 -106.5q0 -94 -31 -174.5t-86 -139t-130 -91.5t-163 -33h-230zM267 62q75 0 135.5 30t102.5 80.5t64.5 116.5t22.5 138q0 48 -12.5 89t-38 70t-63 45.5t-87.5 16.5h-160l-125 -586h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 582,
    d: "M175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 572,
    d: "M175 710h442l-13 -62h-373l-55 -261h315l-13 -58h-315l-70 -329h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 687,
    d: "M532 103q-115 -108 -237 -108q-58 0 -104 24.5t-78 66t-49 95t-17 111.5q0 80 33 156t88.5 135.5t127 95.5t149.5 36q49 0 87 -11.5t66 -32t45.5 -49t26.5 -62.5l-62 -36q-18 66 -64.5 97t-113.5 31q-64 0 -121 -31.5t-99.5 -82.5t-67.5 -114.5t-25 -127.5q0 -49 14 -92 t39.5 -75.5t61.5 -51.5t81 -19q57 0 115 28.5t119 89.5l26 119h-148l11 54h208l-74 -349h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 709,
    d: "M175 710h69l-67 -316h395l67 316h70l-151 -710h-70l71 332h-395l-71 -332h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 468,
    d: "M100 -11q-85 0 -137 44l31 56q17 -15 47.5 -26t71.5 -11q51 0 85.5 19.5t58.5 57.5t40.5 93.5t31.5 126.5l77 360h70l-77 -360q-17 -81 -38 -147.5t-54.5 -113.5t-83 -73t-123.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 615,
    d: "M175 709h69l-88 -412l455 413h78l-342 -312l205 -398h-78l-179 357l-155 -139l-47 -218h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 557,
    d: "M175 710h69l-138 -648h388l-13 -62h-457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 840,
    d: "M175 710h72l157 -486l364 486h72l-151 -710h-70l124 583l-338 -451h-41l-146 451l-125 -583h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 740,
    d: "M175 710h54l316 -591l125 590h69l-151 -709h-59l-313 580l-123 -580h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 722,
    d: "M296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90 t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 599,
    d: "M175 710h280q37 0 66.5 -15.5t49.5 -41.5t31 -59.5t11 -68.5q0 -48 -20 -95t-54 -84.5t-79 -60.5t-95 -23h-216l-56 -262h-69zM374 324q34 0 65 17t53.5 44.5t36 62.5t13.5 71q0 27 -7.5 50.5t-21.5 41t-33.5 27.5t-42.5 10h-206l-69 -324h212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 721,
    d: "M495 59q-46 -30 -96 -47t-103 -17q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129.5 96t151 36q60 0 106 -25t77.5 -66t47.5 -94t16 -110q0 -46 -11.5 -91t-32 -86.5t-49 -79t-63.5 -67.5l59 -96h-70zM310 58q42 0 81 13.5t74 37.5l-65 109 h69l42 -70q54 53 85.5 124t31.5 143q0 47 -13 90t-37.5 75.5t-60.5 52t-81 19.5q-66 0 -124 -32t-101.5 -83t-68.5 -115t-25 -128q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 628,
    d: "M24 0l151 710h285q37 0 67 -15.5t50 -41.5t31 -59.5t11 -68.5q0 -43 -16 -84.5t-43 -75.5t-63.5 -58.5t-77.5 -32.5l107 -274h-79l-102 262h-196l-56 -262h-69zM381 324q34 0 64.5 17t53 44.5t35.5 62t13 69.5q0 27 -7.5 50.5t-21 41.5t-33 28.5t-42.5 10.5h-212 l-69 -324h219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 585,
    d: "M241 -6q-159 0 -250 103l47 57q27 -41 83.5 -69.5t134.5 -28.5q91 0 144 37.5t53 108.5q0 26 -11.5 44.5t-34 33t-54.5 25t-74 21.5q-43 11 -76.5 23.5t-56.5 29.5t-35 40.5t-12 55.5q0 56 22.5 100.5t61.5 75.5t91.5 47.5t113.5 16.5q67 0 116.5 -21.5t82.5 -60.5 l-45 -56q-20 34 -64 55t-104 21q-52 0 -89.5 -12t-62 -33t-36 -49.5t-11.5 -61.5q0 -24 10 -41t30 -29.5t50 -22t70 -19.5q44 -11 80 -23.5t61.5 -31t39.5 -44.5t14 -63q0 -57 -22.5 -100t-61.5 -71.5t-91.5 -43t-113.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 582,
    d: "M328 648h-238l13 62h547l-13 -62h-239l-138 -648h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 724,
    d: "M298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5 t-104.5 -77.5t-138 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 648,
    d: "M97 710h73l106 -623l369 623h73l-430 -710h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 997,
    d: "M95 710h75l108 -629l195 321l-53 303h66l40 -252l149 252h66l-182 -303l59 -321l374 629h77l-437 -710h-60l-66 351l-216 -351h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 604,
    d: "M274 350l-182 360h79l153 -310l284 310h77l-335 -360l176 -350h-77l-147 300l-274 -300h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 607,
    d: "M257 266l-166 444h77l137 -382l300 382h76l-356 -446l-56 -264h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 596,
    d: "M-24 55l580 593h-446l13 62h528l-12 -55l-574 -593h447l-13 -62h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 251,
    d: "M14 -40l166 780h116l-12 -57h-53l-142 -666h54l-12 -57h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 534,
    d: "M184 710l262 -710h-76l-263 710h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 250,
    d: "M-25 -40l12 57h53l142 666h-53l12 57h116l-165 -780h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 541,
    d: "M52 303l198 407h58l197 -407h-60l-166 343l-169 -343h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 492,
    d: "M-14 -62l13 62h362l-13 -62h-362z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 213,
    d: "M67 730h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 592,
    d: "M254 -10q-63 0 -104.5 31.5t-58.5 79.5l-22 -101h-60l155 730h68l-68 -318q45 53 98 85.5t113 32.5q44 0 77 -18t55 -47.5t33 -68t11 -79.5q0 -65 -25.5 -124.5t-67 -104.5t-95 -71.5t-109.5 -26.5zM252 50q43 0 84 21.5t73 57t51 81.5t19 95q0 32 -9 62t-26 53 t-42.5 36.5t-58.5 13.5q-28 0 -55 -10.5t-51.5 -27.5t-46.5 -40.5t-41 -48.5l-36 -173q1 -26 13 -48t30.5 -38t43.5 -25t52 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 526,
    d: "M223 -10q-46 0 -83 17.5t-62.5 47.5t-39 70t-13.5 85q0 63 25 121t67.5 102.5t99 70.5t120.5 26q71 0 116.5 -33.5t59.5 -90.5l-70 -21q-12 40 -44 62.5t-77 22.5q-44 0 -84.5 -20t-72.5 -54t-51 -80t-19 -97q0 -36 10 -66.5t28 -53.5t43.5 -36t56.5 -13q24 0 48.5 7 t46.5 19.5t39.5 28.5t26.5 34l63 -20q-16 -28 -41 -51.5t-56 -41t-66 -27t-71 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M211 -10q-44 0 -78.5 17.5t-58.5 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92.5 72t109.5 27q62 0 103 -34.5t58 -83.5l68 318h68l-136 -641q-2 -10 -2 -12q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-24 0 -36.5 11.5t-12.5 28.5q0 7 2 19.5t9 43.5 q-40 -51 -96.5 -81t-110.5 -30zM239 50q24 0 52.5 10t55.5 27.5t48.5 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41.5t-43 28t-49 10q-45 0 -86 -22.5t-71.5 -58t-48.5 -80.5t-18 -90q0 -35 10 -65.5t29 -53.5t45 -36.5t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 534,
    d: "M226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7 t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 322,
    d: "M130 467h-68l11 54h69l2 14q7 48 25 86t43.5 64.5t57 40.5t65.5 14q29 0 54.5 -9t43.5 -24l-31 -49q-11 11 -29 17t-37 6q-45 0 -76.5 -37t-46.5 -107l-3 -16h135l-11 -54h-136l-144 -679h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 592,
    d: "M165 -223q-43 0 -75 8.5t-56 23.5t-40.5 37t-26.5 49l48 33q19 -50 62 -73.5t99 -23.5q36 0 70 10.5t62.5 31t49 52t29.5 73.5l22 103q-19 -25 -43 -45t-51 -34t-55 -21.5t-55 -7.5q-43 0 -76.5 17.5t-57 47t-35.5 68.5t-12 82q0 61 24 119t64.5 103t93.5 72.5t112 27.5 q64 0 103 -33.5t62 -84.5l23 109h60l-111 -523q-12 -55 -40 -96.5t-67 -69t-86 -41.5t-97 -14zM237 50q28 0 58 11t56 29.5t46 41.5t29 47l34 161q-4 28 -17 52t-31.5 41t-42.5 27t-50 10q-47 0 -88 -23t-71.5 -59.5t-48 -81t-17.5 -87.5q0 -35 10 -65.5t29 -53.5 t45.5 -36.5t58.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 559,
    d: "M164 730h68l-70 -327q42 59 101.5 93t120.5 34q64 0 91.5 -35.5t27.5 -97.5q0 -39 -11 -92l-64 -305h-68l62 291q9 43 9 76q0 101 -85 101q-27 0 -56 -11.5t-56.5 -31.5t-51 -47t-38.5 -59l-67 -319h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 213,
    d: "M119 521h68l-110 -521h-68zM164 730h68l-21 -100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 220,
    d: "M-103 -181q-32 0 -58 9t-43 30l43 46q11 -14 28.5 -19t35.5 -5q16 0 33 7t32 19.5t26 29.5t15 37l117 548h68l-116 -544q-8 -35 -26.5 -64t-43 -50t-54 -32.5t-57.5 -11.5zM170 730h68l-22 -100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 536,
    d: "M164 730h68l-76 -358q51 70 113 114.5t133 44.5q56 0 83 -28.5t27 -76.5q0 -65 -47.5 -117.5t-137.5 -82.5l117 -226h-74l-124 255q100 21 151.5 66t51.5 96q0 30 -17.5 44t-46.5 14q-33 0 -67.5 -15.5t-67.5 -43.5t-63.5 -67t-54.5 -87l-55 -262h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 264,
    d: "M107 -6q-37 0 -58 19t-21 54q0 6 1 13t3 15l134 635h68l-130 -612q-1 -5 -1.5 -9t-0.5 -9q0 -44 47 -44q11 0 26 3t29 8l-2 -55q-20 -8 -47.5 -13t-47.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 878,
    d: "M119 521h63l-26 -118q42 59 98.5 93t115.5 34q60 0 89.5 -35.5t29.5 -100.5q44 67 101.5 101.5t117.5 34.5q63 0 89.5 -34t26.5 -94q0 -43 -12 -97l-65 -305h-68l61 291q5 23 7.5 43.5t2.5 37.5q0 96 -79 96q-28 0 -55.5 -11t-52.5 -31t-46.5 -47.5t-37.5 -60.5l-67 -318 h-68l61 291q5 25 8 45.5t3 37.5q0 94 -79 94q-56 0 -108 -41t-85 -108l-67 -319h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 559,
    d: "M119 521h63l-26 -118q21 28 48.5 51.5t58 40.5t63.5 26t66 9q61 0 87 -33t26 -91q0 -23 -3.5 -47.5t-9.5 -53.5l-64 -305h-68l62 291q10 49 10 85q0 92 -78 92q-28 0 -58.5 -11t-59 -31t-52.5 -47.5t-40 -59.5l-67 -319h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 573,
    d: "M220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5 t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 593,
    d: "M120 521h60l-21 -101q40 49 95 79.5t112 30.5q43 0 77.5 -18t58.5 -48t36.5 -70t12.5 -83q0 -61 -23 -119t-63 -103t-92.5 -72t-110.5 -27q-63 0 -103.5 33.5t-58.5 84.5l-68 -321h-68zM256 50q45 0 86 22.5t71.5 58t48.5 80t18 89.5q0 35 -10 66t-29 54t-45 36.5 t-59 13.5q-24 0 -52.5 -10.5t-55.5 -28t-48.5 -41t-31.5 -49.5l-34 -160q5 -28 17.5 -52t31 -41.5t42 -27.5t50.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 592,
    d: "M198 -10q-42 0 -74.5 17.5t-54.5 46.5t-33.5 68t-11.5 82q0 64 25.5 123t67.5 104t96 72t111 27q58 0 100 -31.5t60 -79.5l21 102h61l-136 -643q-1 -4 -1.5 -6.5t-0.5 -4.5q0 -17 19 -18l-12 -59q-5 -1 -10.5 -1.5t-10.5 -0.5q-27 0 -43.5 11.5t-16.5 36.5q0 3 0.5 6 t1.5 7l55 259q-48 -58 -102 -88t-111 -30zM232 50q28 0 55 10t52 26.5t46.5 39t39.5 47.5l35 164q-2 27 -12.5 51t-28.5 42.5t-42 29t-51 10.5q-45 0 -87 -22.5t-74 -58.5t-51 -81.5t-19 -92.5q0 -34 9.5 -64t27 -52.5t43 -35.5t57.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 343,
    d: "M119 521h64l-27 -125q39 57 88.5 90.5t100.5 35.5q8 0 13.5 -0.5t10.5 -1.5l-13 -59q-65 -2 -121 -38t-90 -99l-68 -324h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 468,
    d: "M172 -10q-58 0 -109 20t-83 58l40 46q67 -72 162 -72q66 0 108.5 30.5t42.5 81.5q0 18 -8 30t-24 21.5t-40 17.5t-55 16q-36 10 -62.5 19.5t-44 21.5t-26.5 28.5t-9 39.5q0 43 18.5 77t49 57.5t71 35.5t84.5 12q57 0 99 -19.5t65 -51.5l-42 -40q-21 30 -57.5 45t-78.5 15 q-28 0 -54 -7t-45.5 -21t-31 -35t-11.5 -50q0 -32 25.5 -45.5t79.5 -27.5q81 -20 123.5 -45.5t42.5 -77.5q0 -39 -17 -72t-47.5 -57t-73 -37.5t-92.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 321,
    d: "M135 -6q-38 0 -62.5 18.5t-24.5 56.5q0 11 3 25l79 373h-69l12 54h68l38 176h68l-38 -176h114l-12 -54h-113l-72 -339q-2 -11 -3.5 -17t-1.5 -11q0 -23 14 -33t34 -10q27 0 50 9.5t30 13.5l6 -55q-13 -9 -46.5 -20t-73.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 569,
    d: "M159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23 t7.5 36q-46 -61 -108 -94.5t-127 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 491,
    d: "M58 521h71l64 -458q87 112 148 229t91 229h66q-75 -263 -284 -521h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 755,
    d: "M53 521h70l84 -458q40 48 74 97.5t63 100.5l-60 260h70l38 -173q22 45 38.5 88t28.5 85h65q-19 -65 -47 -129.5t-65 -129.5l43 -199q88 112 149.5 229t92.5 229h66q-77 -263 -287 -521h-73l-40 184q-29 -47 -62.5 -93t-72.5 -91h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 481,
    d: "M194 259l-133 262h73l102 -204l4 -15l11 14l190 205h73l-244 -262l133 -259h-73l-102 203l-6 14l-10 -13l-188 -204h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 489,
    d: "M-36 -169q31 5 53.5 12t40 20t33 32t34.5 48l33 49l-107 529h71l84 -458l41 67q43 70 73 123t51.5 97.5t36 85t26.5 85.5h67q-14 -48 -29 -89.5t-37.5 -88t-56 -104t-83.5 -136.5l-81 -129q-35 -55 -63.5 -92t-56 -60t-56.5 -33.5t-65 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 466,
    d: "M-26 46l419 424h-321l11 51h397l-9 -46l-417 -424h327l-12 -51h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 251,
    d: "M233 683l-56 -261q-2 -12 -11.5 -30t-27.5 -32q8 -9 11 -21t3 -24v-9t-1 -8l-58 -272h52l-12 -57h-93q-6 0 -11 4t-5 15q0 7 1 11l60 281q1 5 1 16q0 15 -6.5 26t-20.5 13l11 52q10 0 18.5 6t15 14t10.5 17.5t5 15.5l57 270q4 19 13.5 24.5t14.5 5.5h93l-12 -57h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 288,
    d: "M119 -130v905h60v-905h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 250,
    d: "M129 683l11 57h93q4 0 10.5 -4t6.5 -17q0 -6 -1 -9l-58 -270q-2 -8 -2 -13q0 -14 6 -27t22 -13l-11 -52q-19 -2 -32 -18.5t-17 -36.5l-59 -281q-4 -17 -13 -23.5t-16 -6.5h-93l12 57h53l58 272q2 11 11.5 29.5t26.5 32.5q-8 10 -11 21.5t-3 22.5q0 8 2 18l56 261h-52z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 492,
    d: "M51 241q1 5 9.5 21.5t23.5 34.5t37 32.5t51 14.5q22 0 40.5 -9t35.5 -20t34 -20t37 -9q19 0 33 7.5t23.5 16.5t14 17.5t4.5 10.5h42q0 -2 -8 -17.5t-24 -33t-39.5 -32t-54.5 -14.5q-24 0 -43 9t-36 20t-33 20t-34 9q-17 0 -30 -9t-22 -19.5t-13.5 -19.5t-4.5 -10h-43v0z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 249
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 247,
    d: "M197 487l-104 -489h-68l104 489h68zM245 715l-23 -112h-70l25 112h68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 540,
    d: "M176 -120l24 111q-41 3 -73 23t-53.5 50.5t-33 68.5t-11.5 78q0 56 21.5 110.5t60 98.5t90.5 73.5t113 35.5l25 116h36l-25 -116q70 -2 111 -34.5t57 -88.5l-70 -21q-13 41 -42 61t-69 22l-88 -417q18 1 40.5 8t44 18t39 27t26.5 35l63 -20q-18 -32 -46 -56.5 t-59.5 -40.5t-63.5 -24t-57 -8l-24 -110h-36zM99 218q0 -30 8 -57.5t22.5 -50t35.5 -37.5t48 -19l87 412q-43 -4 -80 -28t-64 -59.5t-42 -78t-15 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 478,
    d: "M68 372h88q-10 37 -20.5 71.5t-10.5 70.5q0 41 18 77.5t48 64t68.5 43.5t79.5 16q52 0 91.5 -28t59.5 -77l-48 -42q-14 42 -46 66t-71 24q-26 0 -51 -11t-44 -30.5t-30.5 -45.5t-11.5 -55q0 -35 11.5 -70t20.5 -74h170l-12 -54h-150q1 -5 1 -9v-8q0 -30 -5.5 -55.5 t-21 -53.5t-44.5 -61t-76 -77q36 9 71 9q20 0 36.5 -3t31.5 -6t30.5 -6t32.5 -3q19 0 39.5 4.5t48.5 13.5l6 -52q-55 -26 -110 -26q-21 0 -39.5 3.5t-36.5 8t-37 8.5t-41 4q-23 0 -52 -4.5t-55 -12.5l-7 50q51 44 83 77t51 61.5t26 55.5t7 58v12t-1 12h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 562,
    d: "M175 480q45 39 112 39q33 0 61.5 -10.5t51.5 -28.5l70 71l34 -33l-72 -72q17 -23 26 -51t9 -59q0 -30 -9.5 -58.5t-26.5 -51.5l73 -72l-30 -29l-74 69q-22 -18 -50.5 -28.5t-62.5 -10.5t-62.5 10.5t-51.5 28.5l-72 -69l-29 29l71 71q-36 50 -36 111q0 64 35 111l-70 71 l33 33zM164 335q0 -27 9.5 -51t26.5 -42t39 -28.5t48 -10.5q25 0 47.5 10.5t39.5 28.5t26.5 42.5t9.5 52.5t-9.5 52.5t-26.5 42.5t-39.5 28t-47.5 10q-26 0 -48 -10.5t-39 -28.5t-26.5 -43t-9.5 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 650,
    d: "M426 366h80l-10 -48h-107l-43 -54l-6 -27h139l-10 -48h-139l-40 -189h-70l40 189h-137l11 48h137l6 29l-19 52h-107l10 48h82l-130 344h76l136 -382l300 382h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 282,
    d: "M176 277v-407h-60v407h60zM176 775v-407h-60v407h60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 489,
    d: "M378 195q14 -10 20 -28.5t6 -42.5q0 -54 -23.5 -94t-58.5 -66t-76 -39t-77 -13q-33 0 -60 8.5t-48 21.5t-36.5 29t-26.5 32l54 42q27 -35 57.5 -51.5t70.5 -16.5q26 0 53 9t49 25.5t36 41t14 54.5q0 22 -9 35.5t-23.5 21.5t-32.5 11t-36 4q-71 4 -114 36.5t-43 95.5 q0 38 15.5 68.5t32.5 47.5q-13 11 -20.5 34t-7.5 51q0 45 21 82.5t54 64t73.5 41.5t79.5 15q36 0 62 -8t44 -21.5t30 -30.5t20 -35l-58 -25q-10 33 -42 45.5t-66 12.5q-26 0 -52.5 -9t-47.5 -26t-34.5 -41.5t-13.5 -54.5q0 -44 29.5 -61.5t74.5 -18.5q30 -1 59.5 -8t52 -22 t36.5 -38.5t14 -58.5q0 -37 -16 -69.5t-36 -50.5zM140 311q0 -38 20.5 -54t49.5 -22.5t59 -8.5t50 -11q19 14 32 38.5t13 50.5q0 23 -9.5 38.5t-25 25.5t-34 14t-36.5 4q-23 0 -43.5 3.5t-34.5 10.5q-16 -14 -28.5 -37.5t-12.5 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 319,
    d: "M63 633l21 94h58l-21 -94h-58zM207 633l20 94h57l-19 -94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 845,
    d: "M433 -7q-79 0 -146.5 27.5t-116.5 76t-76.5 114.5t-27.5 144q0 77 27.5 143t76.5 114t116.5 75.5t146.5 27.5t146.5 -27.5t117 -75.5t77.5 -114t28 -143q0 -78 -28 -144t-77.5 -114.5t-117 -76t-146.5 -27.5zM433 26q70 0 131 24t106 67t71 103t26 133q0 71 -25 131 t-70 104t-106 69t-133 25t-133 -25t-105.5 -68.5t-69.5 -104t-25 -130.5t25 -130t69.5 -104t105.5 -69t133 -25zM440 123q-45 0 -87.5 16.5t-74.5 46.5t-51.5 73t-19.5 96q0 42 14 84t42 75t70.5 54t100.5 21q66 0 117.5 -28.5t74.5 -82.5l-65 -21q-10 22 -25.5 36t-33.5 22 t-35.5 11t-32.5 3q-40 0 -69.5 -15.5t-49 -40t-29 -56t-9.5 -62.5q0 -41 15 -73.5t38 -54.5t51.5 -33.5t55.5 -11.5q18 0 38 5.5t38 15t32.5 23.5t22.5 32l65 -19q-7 -18 -23.5 -38.5t-41.5 -38t-57.5 -28.5t-70.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 414,
    d: "M167 346q-42 0 -67 26t-25 64q0 28 13 52t35.5 41t53 26.5t65.5 9.5q26 0 50 -4.5t42 -13.5l6 28q3 15 3 25q0 32 -19 50t-54 18q-50 0 -117 -41l-11 37q76 46 141 46q57 0 87.5 -26t30.5 -75q0 -21 -4 -40l-31 -143q-1 -3 -1 -8q0 -13 15 -14l-11 -52q-4 -1 -12 -1 q-20 0 -34 6.5t-14 23.5q0 4 1 12t3 18q-30 -32 -68 -48.5t-78 -16.5zM192 391q19 0 39.5 5.5t38 15t30 22t15.5 26.5l11 52q-17 9 -38.5 12.5t-43.5 3.5q-48 0 -80 -22t-32 -57q0 -25 16.5 -41.5t43.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 553,
    d: "M36 276l274 178l-12 -59l-210 -136l152 -134l-13 -59l-199 173zM249 276l275 178l-13 -59l-210 -136l153 -134l-13 -59l-199 173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 562,
    d: "M506 364l-52 -238h-58l37 176h-361l14 62h420z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 548,
    d: "M51 241l13 63h420l-13 -63h-420z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 845,
    d: "M433 -7q-79 0 -146.5 27.5t-116.5 76t-76.5 114.5t-27.5 144q0 77 27.5 143t76.5 114t116.5 75.5t146.5 27.5t146.5 -27.5t117 -75.5t77.5 -114t28 -143q0 -78 -28 -144t-77.5 -114.5t-117 -76t-146.5 -27.5zM433 25q70 0 131 24t106 67t70.5 103.5t25.5 134.5 q0 70 -25 130t-69.5 104t-105.5 69t-133 25t-132.5 -25t-104.5 -69t-69 -103.5t-25 -129.5q0 -71 24.5 -131t69 -104.5t105 -69.5t132.5 -25zM281 580h191q29 0 53.5 -12.5t42.5 -33t28 -46t10 -51.5q0 -49 -28 -87.5t-74 -47.5l111 -175h-58l-107 168h-117v-168h-52v453z M471 341q42 0 63 27.5t21 68.5q0 42 -24.5 68.5t-62.5 26.5h-135v-191h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 378,
    d: "M72 662l10 47h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 259,
    d: "M181 558q-29 0 -46.5 18t-17.5 47q0 19 8 37t21.5 32t31.5 23t39 9q29 0 46.5 -19t17.5 -48q0 -20 -8 -38t-22 -31.5t-32 -21.5t-38 -8zM190 597q18 0 35 15.5t17 36.5q0 17 -9 26t-24 9q-20 0 -36 -15t-16 -36q0 -17 9 -26.5t24 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 484,
    d: "M68 61v57h322v-57h-322zM390 393v-57h-130v-140h-62v140h-130v57h130v140h62v-140h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 374,
    d: "M59 407q8 39 21.5 67.5t33 50t45.5 37.5t59 28q26 10 53.5 19t50 21.5t36.5 30.5t14 45q0 26 -20 43.5t-62 17.5q-24 0 -44 -5.5t-37 -14t-29.5 -18t-21.5 -17.5l-23 31q5 5 19 16.5t36 23t51 20t64 8.5q60 0 88.5 -27t28.5 -69q0 -32 -12 -54.5t-34 -39.5t-51.5 -29.5 t-64.5 -24.5q-34 -11 -56 -25.5t-36 -30.5t-21 -31.5t-10 -29.5h226l-9 -43h-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 374,
    d: "M204 401q-58 0 -91 25t-40 64l34 29q0 -27 26 -50t80 -23q24 0 47 6t40 16.5t27.5 25t10.5 32.5q0 31 -33.5 48t-93.5 17h-22l8 41h22q67 0 105.5 19t38.5 57q0 29 -24.5 45.5t-62.5 16.5t-69.5 -15.5t-51.5 -40.5l-23 34q23 29 66 46t87 17q58 0 92.5 -27t34.5 -69 q0 -38 -28 -64.5t-80 -37.5q37 -6 57.5 -29.5t20.5 -55.5q0 -30 -15.5 -53.5t-41 -40t-57 -25t-64.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 212,
    d: "M74 620l-42 17l76 93h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    d: "M128 521h68l-63 -294q-10 -43 -10 -78q0 -99 87 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-92 -433q-2 -8 -2 -11q0 -17 20 -17l-14 -60q-30 0 -50.5 8.5t-20.5 31.5q0 5 3.5 28t10.5 50q-18 -27 -43 -50t-53.5 -40.5t-59 -27.5t-59.5 -10q-45 0 -68.5 23.5 t-28.5 61.5l-57 -287h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 579,
    d: "M64 418q0 66 23 119.5t65.5 92t102.5 59.5t135 21h231l-12 -54h-66l-157 -736h-59l66 311h-69l-66 -311h-60l67 311q-97 2 -149 51.5t-52 135.5zM124 431q0 -36 11.5 -62.5t32 -44.5t48.5 -27.5t60 -11.5l79 371q-54 0 -97 -17.5t-73 -47.5t-45.5 -71t-15.5 -89zM484 656 h-69l-80 -371h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 186,
    d: "M52 246l23 112h58l-23 -112h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 270,
    d: "M11 -126q11 -7 32.5 -12.5t46.5 -5.5q64 0 64 43q0 16 -11.5 22t-29.5 6q-20 0 -43 -4.5t-37 -9.5l76 105l30 -13l-45 -56q9 4 19 5t18 1q29 0 45 -12.5t16 -36.5q0 -38 -29.5 -60t-85.5 -22q-27 0 -50 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 260,
    d: "M273 451l-10 -45h-193l10 45h77l65 309q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l10 45q15 0 32.5 8t33 18t26 19t10.5 10h45l-77 -360h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 431,
    d: "M223 346q-33 0 -58.5 12t-43 32t-26.5 46.5t-9 56.5q0 43 17.5 82t46.5 69t68 48t82 18q33 0 58.5 -11.5t43 -31.5t27 -47t9.5 -57q0 -42 -17 -81t-46.5 -69.5t-68.5 -48.5t-83 -18zM233 395q28 0 54.5 13t47.5 35t33.5 51t12.5 61q0 45 -25 75.5t-66 30.5 q-27 0 -53.5 -13t-47.5 -34.5t-33.5 -51t-12.5 -62.5q0 -45 24.5 -75t65.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 553,
    d: "M498 239l-273 -173l12 59l209 134l-151 136l12 59l199 -178zM285 239l-274 -173l13 59l210 134l-152 136l12 59l198 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 786,
    d: "M609 103h-217l9 42l284 254h31l-54 -252h56l-10 -44h-55l-22 -103h-44zM620 147l40 191l-210 -191h170zM67 27l669 687l28 -30l-669 -688zM263 371l-10 -45h-193l10 45h77l65 309q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l10 45q15 0 32.5 8t33 18t26 19t10.5 10 h45l-77 -360h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 820,
    d: "M426 0q7 39 20.5 67.5t32.5 50.5t44.5 38t57.5 28q25 9 51.5 18t48 21.5t35.5 30.5t14 45q0 26 -19.5 44t-59.5 18q-24 0 -43.5 -5.5t-36 -14t-29 -18.5t-21.5 -18l-21 32q4 5 18 16t35 22.5t49.5 20t62.5 8.5q58 0 86 -27t28 -69q0 -32 -11 -54t-31.5 -39t-49.5 -30 t-65 -25q-33 -11 -55 -25.5t-35.5 -30t-20 -31.5t-9.5 -29h225l-9 -44h-292zM36 27l669 687l28 -30l-669 -688zM265 371l-10 -45h-193l10 45h77l65 309q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l10 45q15 0 32.5 8t33 18t26 19t10.5 10h45l-77 -360h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 797,
    d: "M189 321q-54 0 -90.5 23t-38.5 66l34 29q0 -13 6.5 -26t19.5 -23.5t32.5 -17t45.5 -6.5q25 0 48 6t40.5 16.5t28 25t10.5 32.5q0 31 -34 48t-93 17h-22l8 41h22q67 0 105.5 19.5t38.5 57.5q0 28 -25 44.5t-61 16.5q-39 0 -70.5 -15.5t-51.5 -40.5l-23 34q23 29 65.5 46 t88.5 17q57 0 91.5 -26.5t34.5 -68.5q0 -40 -28 -66t-80 -37q37 -6 57.5 -29.5t20.5 -55.5q0 -30 -15.5 -53.5t-40.5 -40t-57.5 -25t-66.5 -8.5zM617 103h-217l9 42l284 254h31l-54 -252h56l-10 -44h-55l-22 -103h-44zM628 147l40 191l-210 -191h170zM98 27l669 687l28 -30 l-669 -688z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 453,
    d: "M311 304q-14 -66 -41.5 -105t-74.5 -65q-24 -14 -54 -28t-55.5 -34.5t-43 -50t-17.5 -74.5q0 -51 30.5 -77t72.5 -26q25 0 49.5 8t47 21.5t41.5 32.5t34 40l40 -30q-20 -31 -46 -55t-55.5 -40.5t-61 -25t-62.5 -8.5t-58.5 9.5t-48.5 28t-33 47t-12 66.5q0 50 14 84t38 58 t55 41.5t64 34.5q19 10 37 20.5t33.5 27t28 40.5t20.5 60h58zM352 506l-23 -107h-57l22 107h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM354 917h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM431 807l-42 17l76 93h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM322 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM495 825q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5 t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM328 820l21 94h58l-21 -94h-58zM472 820l20 94h57l-19 -94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM372 839q0 35 26 56.5t61 21.5q27 0 42.5 -14.5t15.5 -38.5q0 -34 -25 -56t-62 -22q-27 0 -42.5 14.5t-15.5 38.5zM453 890q-18 0 -33 -13t-15 -33q0 -13 8.5 -22t22.5 -9 q17 0 33 13t16 33q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 923,
    d: "M503 710h459l-14 -62h-371l-53 -255h319l-14 -62h-319l-57 -269h379l-13 -62h-448l47 222h-244l-179 -222h-76zM427 284l73 342l-281 -342h208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 652,
    d: "M183 -126q11 -7 32.5 -12.5t46.5 -5.5q64 0 64 43q0 16 -11.5 22t-29.5 6q-20 0 -43 -4.5t-37 -9.5l59 83q-53 5 -94 32t-69.5 68t-43 92.5t-14.5 105.5q0 73 30.5 147.5t84.5 135t128 99t162 38.5q91 0 145.5 -43t71.5 -112l-63 -34q-9 35 -26.5 59t-40.5 39t-50 21.5 t-54 6.5q-70 0 -128.5 -32.5t-100.5 -84t-65.5 -114.5t-23.5 -123q0 -49 13.5 -92.5t38.5 -76.5t61 -52t81 -19q28 0 59.5 7.5t62.5 24t60 41t52 59.5l52 -30q-24 -38 -58 -68t-73 -51t-80.5 -32.5t-79.5 -12.5l-36 -46q9 4 19 5t18 1q29 0 45 -12.5t16 -36.5 q0 -38 -29.5 -60t-85.5 -22q-27 0 -50 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 582,
    d: "M175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454zM356 917h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 582,
    d: "M422 807l-42 17l76 93h71zM175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 582,
    d: "M313 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 582,
    d: "M320 820l21 94h58l-21 -94h-58zM464 820l20 94h57l-19 -94h-58zM175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM163 917h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM223 807l-42 17l76 93h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM115 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM130 820l21 94h58l-21 -94h-58zM274 820l20 94h57l-19 -94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 697,
    d: "M55 384h57l70 326h230q66 0 115 -21t81 -58t47.5 -86.5t15.5 -106.5q0 -94 -31 -174.5t-86 -139t-130 -91.5t-163 -33h-230l70 330h-58zM274 62q75 0 135.5 30t102.5 80.5t64.5 116.5t22.5 138q0 48 -12.5 89t-38 70t-63 45.5t-87.5 16.5h-160l-57 -264h161l-11 -54h-161 l-57 -268h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 740,
    d: "M175 710h54l316 -591l125 590h69l-151 -709h-59l-313 580l-123 -580h-69zM542 825q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16 t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 722,
    d: "M296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90 t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19zM422 917h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 722,
    d: "M471 807l-42 17l76 93h71zM296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58q66 0 123.5 32t101 83.5t68.5 115 t25 126.5q0 47 -13 90t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 722,
    d: "M362 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58 q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 722,
    d: "M296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90 t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19zM532 825q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5 q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 722,
    d: "M372 820l21 94h58l-21 -94h-58zM516 820l20 94h57l-19 -94h-58zM296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36z M310 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 468,
    d: "M392 151l-44 -43l-122 121l-121 -121l-43 44l120 120l-119 121l44 43l119 -120l121 121l43 -44l-120 -121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 722,
    d: "M713 710l-76 -90q30 -42 45.5 -93.5t15.5 -106.5q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36q-44 0 -80.5 13t-65.5 36l-37 -44h-77l73 86q-31 41 -47 93t-16 109q0 81 34 158t90.5 137t129 96t150.5 36q45 0 81.5 -14t65.5 -38l40 47h76zM117 294 q0 -43 10 -81.5t30 -69.5l394 465q-23 20 -51.5 31.5t-63.5 11.5q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5zM310 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 42 -10 79.5t-29 68.5l-393 -465q23 -19 51 -29.5t63 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 724,
    d: "M298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5 t-104.5 -77.5t-138 -29zM409 917h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 724,
    d: "M458 807l-42 17l76 93h71zM298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358 q-15 -72 -44 -137t-73.5 -113.5t-104.5 -77.5t-138 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 724,
    d: "M352 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358 h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5t-104.5 -77.5t-138 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 724,
    d: "M365 820l21 94h58l-21 -94h-58zM509 820l20 94h57l-19 -94h-58zM298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5 t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5t-104.5 -77.5t-138 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 607,
    d: "M257 266l-166 444h77l137 -382l300 382h76l-356 -446l-56 -264h-69zM395 807l-42 17l76 93h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 579,
    d: "M175 710h69l-30 -141h193q37 0 66.5 -15.5t50 -41.5t31 -59t10.5 -69q0 -48 -20 -95t-53.5 -84.5t-78.5 -60.5t-96 -23h-198l-26 -121h-69zM328 184q34 0 64.5 17t53.5 45t36 62t13 69q0 27 -7.5 50.5t-21.5 41t-33 28t-43 10.5h-189l-69 -323h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 529,
    d: "M177 57q51 1 93 13t72 35t46.5 58t16.5 81q0 57 -33.5 90.5t-93.5 33.5h-18l14 62h17q28 0 53.5 10.5t45 28.5t30.5 42.5t11 53.5q0 43 -27 66t-68 23q-31 0 -56.5 -11.5t-45 -32t-33 -47.5t-20.5 -58l-107 -505h-65l109 515q9 44 31 80.5t53 63t69.5 41t80.5 14.5 q33 0 60 -9.5t46.5 -27t30 -42t10.5 -53.5q0 -31 -11.5 -60.5t-31 -53.5t-44 -41.5t-49.5 -23.5q56 -13 84 -55.5t28 -99.5q0 -60 -23.5 -106t-65 -78.5t-98.5 -50t-125 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM281 730h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM350 620l-42 17l76 93h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM236 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM406 638q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5 t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM250 633l21 94h58l-21 -94h-58zM394 633l20 94h57l-19 -94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM283 652q0 35 26 56.5t61 21.5q27 0 42.5 -14.5t15.5 -38.5 q0 -34 -25 -56t-62 -22q-27 0 -42.5 14.5t-15.5 38.5zM364 703q-18 0 -33 -13t-15 -33q0 -13 8.5 -22t22.5 -9q17 0 33 13t16 33q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 887,
    d: "M134 -10q-33 0 -58.5 10.5t-43.5 28.5t-27 42t-9 52q0 41 19 75t52 59t77.5 38.5t95.5 13.5q33 0 64.5 -5.5t57.5 -14.5q8 26 18 46.5t14 44.5q0 43 -28.5 71t-82.5 28q-38 0 -81 -16t-91 -46l-13 45q56 34 105.5 51t97.5 17q60 0 98 -27t49 -77q42 47 96.5 75.5 t115.5 28.5q46 0 82.5 -16.5t62 -45.5t39.5 -68t14 -84q0 -32 -5.5 -51.5t-9.5 -28.5h-427q-1 -8 -1.5 -16.5t-0.5 -17.5q0 -35 10.5 -64.5t30 -50.5t46.5 -33t60 -12q24 0 49 7t47.5 19t41.5 29.5t32 38.5l56 -16q-18 -29 -44 -52.5t-57.5 -41t-66.5 -27t-71 -9.5 q-66 0 -112.5 31.5t-68.5 83.5q-23 -31 -53 -53t-62 -35.5t-63 -20t-55 -6.5zM161 42q27 0 57 8.5t57.5 23.5t48 34.5t28.5 41.5q-4 16 -4 41q0 14 1.5 28.5t3.5 26.5q-25 10 -54 15t-57 5q-39 0 -71.5 -9.5t-56.5 -26.5t-37.5 -41t-13.5 -53q0 -38 24 -66t74 -28zM789 282 q2 10 2.5 20.5t0.5 19.5q0 67 -37.5 111t-106.5 44q-38 0 -73 -14.5t-64.5 -40.5t-52 -62t-33.5 -78h364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 526,
    d: "M119 -126q11 -7 32.5 -12.5t46.5 -5.5q64 0 64 43q0 16 -11.5 22t-29.5 6q-20 0 -43 -4.5t-37 -9.5l56 79q-41 4 -72.5 23t-54 48t-34 67t-11.5 80q0 63 25 121t67.5 102.5t99 70.5t120.5 26q71 0 116.5 -33.5t59.5 -90.5l-70 -21q-12 40 -44 62.5t-77 22.5 q-44 0 -84.5 -20t-72.5 -54t-51 -80t-19 -97q0 -36 10 -66.5t28 -53.5t43.5 -36t56.5 -13q24 0 48.5 7t46.5 19.5t39.5 28.5t26.5 34l63 -20q-16 -27 -39.5 -50t-52.5 -39.5t-62 -27t-68 -11.5l-33 -42q9 4 19 5t18 1q29 0 45 -12.5t16 -36.5q0 -38 -29.5 -60t-85.5 -22 q-27 0 -50 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 534,
    d: "M226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7 t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5zM296 730h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 534,
    d: "M340 620l-42 17l76 93h71zM226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37 t63 -13.5q24 0 49 7t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 534,
    d: "M246 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14 q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 534,
    d: "M253 633l21 94h58l-21 -94h-58zM397 633l20 94h57l-19 -94h-58zM226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15 t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5 t-78 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 213,
    d: "M119 521h68l-110 -521h-68zM96 730h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 213,
    d: "M175 620l-42 17l76 93h71zM119 521h68l-110 -521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 213,
    d: "M62 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM119 521h68l-110 -521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 213,
    d: "M73 633l21 94h58l-21 -94h-58zM217 633l20 94h57l-19 -94h-58zM119 521h68l-110 -521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 579,
    d: "M554 683l-91 -52q44 -63 61.5 -131t17.5 -129q0 -88 -28.5 -158.5t-74.5 -120t-104 -76t-118 -26.5q-44 0 -80 15.5t-61.5 43t-40 64t-14.5 78.5q0 56 25 107.5t65.5 90.5t92.5 62t106 23q63 0 107.5 -32.5t58.5 -84.5q0 62 -13 123.5t-57 123.5l-117 -68l-15 31l111 63 q-41 48 -114 100h94q23 -17 42 -35t36 -38l96 56zM91 199q0 -31 10 -58t29 -47.5t44.5 -32t57.5 -11.5q42 0 82.5 18.5t71.5 49.5t50 71t19 83q0 31 -10.5 57.5t-29 46t-45 30.5t-57.5 11q-42 0 -82 -18t-71 -48t-50 -69.5t-19 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 559,
    d: "M119 521h63l-26 -118q21 28 48.5 51.5t58 40.5t63.5 26t66 9q61 0 87 -33t26 -91q0 -23 -3.5 -47.5t-9.5 -53.5l-64 -305h-68l62 291q10 49 10 85q0 92 -78 92q-28 0 -58.5 -11t-59 -31t-52.5 -47.5t-40 -59.5l-67 -319h-68zM393 638q-21 0 -35.5 6t-26.5 13.5t-24 14 t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 573,
    d: "M220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5 t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5zM291 730h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 573,
    d: "M349 620l-42 17l76 93h71zM220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50q42 0 83 20.5t73 55t52 80t20 96.5 q0 35 -10 66t-28.5 53.5t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 573,
    d: "M239 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50 q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 573,
    d: "M220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5 t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5zM410 638q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5 t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 573,
    d: "M254 633l21 94h58l-21 -94h-58zM398 633l20 94h57l-19 -94h-58zM220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27z M233 50q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 537,
    d: "M234 399v91h59v-91h-59zM234 74v90h59v-90h-59zM62 254v57h403v-57h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 573,
    d: "M77 53q-53 62 -53 155q0 63 25.5 121t68.5 102.5t99.5 71.5t117.5 27q35 0 65 -10.5t53 -29.5l31 33h46l-53 -56q54 -62 54 -156q0 -62 -25 -120t-68 -102.5t-99 -71.5t-118 -27q-36 0 -66.5 10.5t-53.5 29.5l-30 -31h-46zM233 50q42 0 83 20.5t73 55t52 80t20 96.5 q0 32 -9 61t-25 51l-280 -332q35 -32 86 -32zM94 216q0 -33 8.5 -61.5t24.5 -50.5l280 334q-17 15 -38.5 23.5t-46.5 8.5q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 569,
    d: "M159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23 t7.5 36q-46 -61 -108 -94.5t-127 -33.5zM270 730h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 569,
    d: "M326 620l-42 17l76 93h71zM159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5 t-12 28.5q0 3 0.5 8t2 14t4 23t7.5 36q-46 -61 -108 -94.5t-127 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 569,
    d: "M234 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5 t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23t7.5 36q-46 -61 -108 -94.5t-127 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 569,
    d: "M243 633l21 94h58l-21 -94h-58zM387 633l20 94h57l-19 -94h-58zM159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60 q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23t7.5 36q-46 -61 -108 -94.5t-127 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 489,
    d: "M-36 -169q31 5 53.5 12t40 20t33 32t34.5 48l33 49l-107 529h71l84 -458l41 67q43 70 73 123t51.5 97.5t36 85t26.5 85.5h67q-14 -48 -29 -89.5t-37.5 -88t-56 -104t-83.5 -136.5l-81 -129q-35 -55 -63.5 -92t-56 -60t-56.5 -33.5t-65 -12.5zM290 620l-42 17l76 93h71z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 577,
    d: "M160 710h69l-58 -276q35 42 80 70t104 28q45 0 79.5 -18t57 -47.5t34 -67.5t11.5 -78q0 -57 -22 -117t-62 -108.5t-95 -80t-121 -31.5q-62 0 -95.5 27t-47.5 63l-61 -287h-69zM251 47q43 0 82.5 21.5t69 57.5t47 82.5t17.5 96.5q0 34 -8.5 64t-25 52.5t-41 35.5t-56.5 13 q-27 0 -53 -10t-49 -26.5t-44 -38.5t-38 -47l-37 -176q-2 -5 -2 -8v-7q0 -22 11 -42t30 -35t44 -24t53 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 489,
    d: "M-36 -169q31 5 53.5 12t40 20t33 32t34.5 48l33 49l-107 529h71l84 -458l41 67q43 70 73 123t51.5 97.5t36 85t26.5 85.5h67q-14 -48 -29 -89.5t-37.5 -88t-56 -104t-83.5 -136.5l-81 -129q-35 -55 -63.5 -92t-56 -60t-56.5 -33.5t-65 -12.5zM192 633l21 94h58l-21 -94 h-58zM336 633l20 94h57l-19 -94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM304 849l10 47h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM229 662l10 47h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM438 851q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM352 664q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5 t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 651,
    d: "M491 -175q-30 7 -45 23t-15 38q0 28 22.5 55t72.5 59h-26l-39 222h-299l-132 -222h-75l431 710h60l128 -710q-55 -32 -77 -55t-22 -46q0 -30 42 -36zM457 277l-58 351l-211 -351h269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    d: "M397 -175q-30 7 -45 23t-15 38q0 29 23 56t74 59q-27 9 -27 36q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81t-111.5 -30q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13 q0 -16 19 -16l-13 -60q-55 -32 -77 -55t-22 -46q0 -30 42 -36zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 656,
    d: "M472 807l-42 17l76 93h71zM294 -6q-59 0 -105 25.5t-77.5 67.5t-48 96t-16.5 111q0 73 30.5 147.5t84.5 135t128 99t162 38.5q91 0 145.5 -43t71.5 -112l-63 -34q-9 35 -26.5 59t-40.5 39t-50 21.5t-54 6.5q-70 0 -128.5 -32.5t-100.5 -84t-65.5 -114.5t-23.5 -123 q0 -49 13.5 -92.5t38.5 -76.5t61 -52t81 -19q28 0 59.5 7.5t62.5 24t60 41t52 59.5l52 -30q-25 -40 -60.5 -70.5t-76.5 -51.5t-84 -32t-82 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 526,
    d: "M338 620l-42 17l76 93h71zM223 -10q-46 0 -83 17.5t-62.5 47.5t-39 70t-13.5 85q0 63 25 121t67.5 102.5t99 70.5t120.5 26q71 0 116.5 -33.5t59.5 -90.5l-70 -21q-12 40 -44 62.5t-77 22.5q-44 0 -84.5 -20t-72.5 -54t-51 -80t-19 -97q0 -36 10 -66.5t28 -53.5t43.5 -36 t56.5 -13q24 0 48.5 7t46.5 19.5t39.5 28.5t26.5 34l63 -20q-16 -28 -41 -51.5t-56 -41t-66 -27t-71 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 656,
    d: "M367 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM294 -6q-59 0 -105 25.5t-77.5 67.5t-48 96t-16.5 111q0 73 30.5 147.5t84.5 135t128 99t162 38.5q91 0 145.5 -43t71.5 -112l-63 -34q-9 35 -26.5 59t-40.5 39t-50 21.5t-54 6.5q-70 0 -128.5 -32.5t-100.5 -84 t-65.5 -114.5t-23.5 -123q0 -49 13.5 -92.5t38.5 -76.5t61 -52t81 -19q28 0 59.5 7.5t62.5 24t60 41t52 59.5l52 -30q-25 -40 -60.5 -70.5t-76.5 -51.5t-84 -32t-82 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 526,
    d: "M243 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM223 -10q-46 0 -83 17.5t-62.5 47.5t-39 70t-13.5 85q0 63 25 121t67.5 102.5t99 70.5t120.5 26q71 0 116.5 -33.5t59.5 -90.5l-70 -21q-12 40 -44 62.5t-77 22.5q-44 0 -84.5 -20t-72.5 -54t-51 -80t-19 -97 q0 -36 10 -66.5t28 -53.5t43.5 -36t56.5 -13q24 0 48.5 7t46.5 19.5t39.5 28.5t26.5 34l63 -20q-16 -28 -41 -51.5t-56 -41t-66 -27t-71 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 656,
    d: "M294 -6q-59 0 -105 25.5t-77.5 67.5t-48 96t-16.5 111q0 73 30.5 147.5t84.5 135t128 99t162 38.5q91 0 145.5 -43t71.5 -112l-63 -34q-9 35 -26.5 59t-40.5 39t-50 21.5t-54 6.5q-70 0 -128.5 -32.5t-100.5 -84t-65.5 -114.5t-23.5 -123q0 -49 13.5 -92.5t38.5 -76.5 t61 -52t81 -19q28 0 59.5 7.5t62.5 24t60 41t52 59.5l52 -30q-25 -40 -60.5 -70.5t-76.5 -51.5t-84 -32t-82 -11zM452 820l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 526,
    d: "M223 -10q-46 0 -83 17.5t-62.5 47.5t-39 70t-13.5 85q0 63 25 121t67.5 102.5t99 70.5t120.5 26q71 0 116.5 -33.5t59.5 -90.5l-70 -21q-12 40 -44 62.5t-77 22.5q-44 0 -84.5 -20t-72.5 -54t-51 -80t-19 -97q0 -36 10 -66.5t28 -53.5t43.5 -36t56.5 -13q24 0 48.5 7 t46.5 19.5t39.5 28.5t26.5 34l63 -20q-16 -28 -41 -51.5t-56 -41t-66 -27t-71 -9.5zM327 633l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 656,
    d: "M376 897l43 20l67 -63l94 63l34 -20l-112 -86h-50zM294 -6q-59 0 -105 25.5t-77.5 67.5t-48 96t-16.5 111q0 73 30.5 147.5t84.5 135t128 99t162 38.5q91 0 145.5 -43t71.5 -112l-63 -34q-9 35 -26.5 59t-40.5 39t-50 21.5t-54 6.5q-70 0 -128.5 -32.5t-100.5 -84 t-65.5 -114.5t-23.5 -123q0 -49 13.5 -92.5t38.5 -76.5t61 -52t81 -19q28 0 59.5 7.5t62.5 24t60 41t52 59.5l52 -30q-25 -40 -60.5 -70.5t-76.5 -51.5t-84 -32t-82 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 526,
    d: "M251 710l43 20l67 -63l94 63l34 -20l-112 -86h-50zM223 -10q-46 0 -83 17.5t-62.5 47.5t-39 70t-13.5 85q0 63 25 121t67.5 102.5t99 70.5t120.5 26q71 0 116.5 -33.5t59.5 -90.5l-70 -21q-12 40 -44 62.5t-77 22.5q-44 0 -84.5 -20t-72.5 -54t-51 -80t-19 -97 q0 -36 10 -66.5t28 -53.5t43.5 -36t56.5 -13q24 0 48.5 7t46.5 19.5t39.5 28.5t26.5 34l63 -20q-16 -28 -41 -51.5t-56 -41t-66 -27t-71 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 690,
    d: "M326 897l43 20l67 -63l94 63l34 -20l-112 -86h-50zM175 710h230q66 0 115 -21t81 -58t47.5 -86.5t15.5 -106.5q0 -94 -31 -174.5t-86 -139t-130 -91.5t-163 -33h-230zM267 62q75 0 135.5 30t102.5 80.5t64.5 116.5t22.5 138q0 48 -12.5 89t-38 70t-63 45.5t-87.5 16.5 h-160l-125 -586h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    d: "M636 637l76 93h72l-106 -110zM211 -10q-44 0 -78.5 17.5t-58.5 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92.5 72t109.5 27q62 0 103 -34.5t58 -83.5l68 318h68l-136 -641q-2 -10 -2 -12q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-24 0 -36.5 11.5 t-12.5 28.5q0 7 2 19.5t9 43.5q-40 -51 -96.5 -81t-110.5 -30zM239 50q24 0 52.5 10t55.5 27.5t48.5 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41.5t-43 28t-49 10q-45 0 -86 -22.5t-71.5 -58t-48.5 -80.5t-18 -90q0 -35 10 -65.5t29 -53.5t45 -36.5t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 697,
    d: "M55 384h57l70 326h230q66 0 115 -21t81 -58t47.5 -86.5t15.5 -106.5q0 -94 -31 -174.5t-86 -139t-130 -91.5t-163 -33h-230l70 330h-58zM274 62q75 0 135.5 30t102.5 80.5t64.5 116.5t22.5 138q0 48 -12.5 89t-38 70t-63 45.5t-87.5 16.5h-160l-57 -264h161l-11 -54h-161 l-57 -268h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    d: "M429 656h99l16 74h68l-16 -74h75l-9 -46h-76l-110 -521q-2 -10 -2 -12q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-24 0 -36.5 11.5t-12.5 28.5q0 7 2 19.5t9 43.5q-40 -51 -96.5 -81t-110.5 -30q-44 0 -78.5 17.5t-58.5 47.5t-36.5 69.5t-12.5 83.5 q0 62 24 120t64 103t92.5 72t109.5 27q62 0 103 -34.5t58 -83.5l42 198h-99zM239 50q24 0 52.5 10t55.5 27.5t48.5 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41.5t-43 28t-49 10q-45 0 -86 -22.5t-71.5 -58t-48.5 -80.5t-18 -90q0 -35 10 -65.5t29 -53.5t45 -36.5t59 -13.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 582,
    d: "M175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454zM289 849l10 47h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 534,
    d: "M226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7 t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5zM222 662l10 47h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 582,
    d: "M175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454zM420 851q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 534,
    d: "M226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7 t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5zM357 664q20 0 40 19t29 47h40q-5 -21 -16 -39.5 t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 582,
    d: "M175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454zM392 820l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 534,
    d: "M226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7 t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5zM327 633l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 582,
    d: "M175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-196q-55 -32 -77 -55t-22 -46q0 -30 42 -36l-26 -38q-30 7 -45 23t-15 38q0 28 22.5 55t72.5 59h-210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 534,
    d: "M182 -181q-30 7 -45 23t-15 38q0 27 21 53.5t69 56.5q-45 3 -80 21t-58.5 47.5t-36 68.5t-12.5 83q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14 q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7t47.5 19.5t41.5 30.5t32 40l56 -17q-32 -51 -86 -86t-116 -43q-53 -32 -74.5 -54.5t-21.5 -45.5q0 -30 42 -36zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43 q0 45 -33 65.5t-78 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 582,
    d: "M313 897l43 20l67 -63l94 63l34 -20l-112 -86h-50zM175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 534,
    d: "M252 710l43 20l67 -63l94 63l34 -20l-112 -86h-50zM226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14 q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 687,
    d: "M351 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM532 103q-115 -108 -237 -108q-58 0 -104 24.5t-78 66t-49 95t-17 111.5q0 80 33 156t88.5 135.5t127 95.5t149.5 36q49 0 87 -11.5t66 -32t45.5 -49t26.5 -62.5l-62 -36q-18 66 -64.5 97t-113.5 31q-64 0 -121 -31.5 t-99.5 -82.5t-67.5 -114.5t-25 -127.5q0 -49 14 -92t39.5 -75.5t61.5 -51.5t81 -19q57 0 115 28.5t119 89.5l26 119h-148l11 54h208l-74 -349h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 592,
    d: "M233 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM165 -223q-43 0 -75 8.5t-56 23.5t-40.5 37t-26.5 49l48 33q19 -50 62 -73.5t99 -23.5q36 0 70 10.5t62.5 31t49 52t29.5 73.5l22 103q-19 -25 -43 -45t-51 -34t-55 -21.5t-55 -7.5q-43 0 -76.5 17.5t-57 47 t-35.5 68.5t-12 82q0 61 24 119t64.5 103t93.5 72.5t112 27.5q64 0 103 -33.5t62 -84.5l23 109h60l-111 -523q-12 -55 -40 -96.5t-67 -69t-86 -41.5t-97 -14zM237 50q28 0 58 11t56 29.5t46 41.5t29 47l34 161q-4 28 -17 52t-31.5 41t-42.5 27t-50 10q-47 0 -88 -23 t-71.5 -59.5t-48 -81t-17.5 -87.5q0 -35 10 -65.5t29 -53.5t45.5 -36.5t58.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 687,
    d: "M532 103q-115 -108 -237 -108q-58 0 -104 24.5t-78 66t-49 95t-17 111.5q0 80 33 156t88.5 135.5t127 95.5t149.5 36q49 0 87 -11.5t66 -32t45.5 -49t26.5 -62.5l-62 -36q-18 66 -64.5 97t-113.5 31q-64 0 -121 -31.5t-99.5 -82.5t-67.5 -114.5t-25 -127.5q0 -49 14 -92 t39.5 -75.5t61.5 -51.5t81 -19q57 0 115 28.5t119 89.5l26 119h-148l11 54h208l-74 -349h-60zM467 851q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 592,
    d: "M165 -223q-43 0 -75 8.5t-56 23.5t-40.5 37t-26.5 49l48 33q19 -50 62 -73.5t99 -23.5q36 0 70 10.5t62.5 31t49 52t29.5 73.5l22 103q-19 -25 -43 -45t-51 -34t-55 -21.5t-55 -7.5q-43 0 -76.5 17.5t-57 47t-35.5 68.5t-12 82q0 61 24 119t64.5 103t93.5 72.5t112 27.5 q64 0 103 -33.5t62 -84.5l23 109h60l-111 -523q-12 -55 -40 -96.5t-67 -69t-86 -41.5t-97 -14zM237 50q28 0 58 11t56 29.5t46 41.5t29 47l34 161q-4 28 -17 52t-31.5 41t-42.5 27t-50 10q-47 0 -88 -23t-71.5 -59.5t-48 -81t-17.5 -87.5q0 -35 10 -65.5t29 -53.5 t45.5 -36.5t58.5 -13.5zM344 664q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 687,
    d: "M532 103q-115 -108 -237 -108q-58 0 -104 24.5t-78 66t-49 95t-17 111.5q0 80 33 156t88.5 135.5t127 95.5t149.5 36q49 0 87 -11.5t66 -32t45.5 -49t26.5 -62.5l-62 -36q-18 66 -64.5 97t-113.5 31q-64 0 -121 -31.5t-99.5 -82.5t-67.5 -114.5t-25 -127.5q0 -49 14 -92 t39.5 -75.5t61.5 -51.5t81 -19q57 0 115 28.5t119 89.5l26 119h-148l11 54h208l-74 -349h-60zM440 820l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 592,
    d: "M165 -223q-43 0 -75 8.5t-56 23.5t-40.5 37t-26.5 49l48 33q19 -50 62 -73.5t99 -23.5q36 0 70 10.5t62.5 31t49 52t29.5 73.5l22 103q-19 -25 -43 -45t-51 -34t-55 -21.5t-55 -7.5q-43 0 -76.5 17.5t-57 47t-35.5 68.5t-12 82q0 61 24 119t64.5 103t93.5 72.5t112 27.5 q64 0 103 -33.5t62 -84.5l23 109h60l-111 -523q-12 -55 -40 -96.5t-67 -69t-86 -41.5t-97 -14zM237 50q28 0 58 11t56 29.5t46 41.5t29 47l34 161q-4 28 -17 52t-31.5 41t-42.5 27t-50 10q-47 0 -88 -23t-71.5 -59.5t-48 -81t-17.5 -87.5q0 -35 10 -65.5t29 -53.5 t45.5 -36.5t58.5 -13.5zM311 633l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 687,
    d: "M225 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM532 103q-115 -108 -237 -108q-58 0 -104 24.5t-78 66t-49 95t-17 111.5q0 80 33 156t88.5 135.5t127 95.5t149.5 36q49 0 87 -11.5t66 -32t45.5 -49t26.5 -62.5l-62 -36q-18 66 -64.5 97t-113.5 31q-64 0 -121 -31.5 t-99.5 -82.5t-67.5 -114.5t-25 -127.5q0 -49 14 -92t39.5 -75.5t61.5 -51.5t81 -19q57 0 115 28.5t119 89.5l26 119h-148l11 54h208l-74 -349h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 592,
    d: "M397 740l-32 -74h20l-17 -76h-61l16 76l40 74h34zM165 -223q-43 0 -75 8.5t-56 23.5t-40.5 37t-26.5 49l48 33q19 -50 62 -73.5t99 -23.5q36 0 70 10.5t62.5 31t49 52t29.5 73.5l22 103q-19 -25 -43 -45t-51 -34t-55 -21.5t-55 -7.5q-43 0 -76.5 17.5t-57 47t-35.5 68.5 t-12 82q0 61 24 119t64.5 103t93.5 72.5t112 27.5q64 0 103 -33.5t62 -84.5l23 109h60l-111 -523q-12 -55 -40 -96.5t-67 -69t-86 -41.5t-97 -14zM237 50q28 0 58 11t56 29.5t46 41.5t29 47l34 161q-4 28 -17 52t-31.5 41t-42.5 27t-50 10q-47 0 -88 -23t-71.5 -59.5 t-48 -81t-17.5 -87.5q0 -35 10 -65.5t29 -53.5t45.5 -36.5t58.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 709,
    d: "M346 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM175 710h69l-67 -316h395l67 316h70l-151 -710h-70l71 332h-395l-71 -332h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 559,
    d: "M278 645l107 84h48l71 -84l-40 -21l-65 63l-89 -63zM164 730h68l-70 -327q42 59 101.5 93t120.5 34q64 0 91.5 -35.5t27.5 -97.5q0 -39 -11 -92l-64 -305h-68l62 291q9 43 9 76q0 101 -85 101q-27 0 -56 -11.5t-56.5 -31.5t-51 -47t-38.5 -59l-67 -319h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 719,
    d: "M107 589h47l26 121h70l-26 -121h395l26 121h69l-26 -121h48l-9 -39h-47l-117 -550h-69l70 332h-395l-70 -332h-70l117 550h-47zM578 394l33 156h-395l-33 -156h395z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 559,
    d: "M78 656h70l16 74h68l-16 -74h104l-9 -46h-105l-44 -207q42 59 101.5 93t120.5 34q64 0 91.5 -35.5t27.5 -97.5q0 -20 -3 -43t-8 -49l-64 -305h-68l62 291q9 45 9 76q0 101 -85 101q-27 0 -56 -11.5t-56.5 -31.5t-51 -47t-38.5 -59l-67 -319h-68l129 610h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM291 825q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31 t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 213,
    d: "M119 521h68l-110 -521h-68zM230 638q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31 t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM101 849l10 47h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 213,
    d: "M119 521h68l-110 -521h-68zM38 662l10 47h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM227 851q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 213,
    d: "M119 521h68l-110 -521h-68zM173 664q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709q-55 -32 -77 -55t-22 -46q0 -30 42 -36l-26 -38q-30 7 -45 23t-15 38q0 28 22.5 55t72.5 59h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 213,
    d: "M119 521h68l-110 -521q-55 -32 -77 -55t-22 -46q0 -30 42 -36l-26 -38q-30 7 -45 23t-15 38q0 28 22.5 55t72.5 59h-20zM164 730h68l-21 -100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM200 820l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 213,
    d: "M119 521h68l-110 -521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 713,
    d: "M175 709h69l-151 -709h-69zM345 -11q-85 0 -137 44l31 56q17 -15 47.5 -26t71.5 -11q51 0 85.5 19.5t58.5 57.5t40.5 93.5t31.5 126.5l77 360h70l-77 -360q-17 -81 -38 -147.5t-54.5 -113.5t-83 -73t-123.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 433,
    d: "M119 521h68l-110 -521h-68zM164 730h68l-21 -100h-68zM110 -181q-32 0 -58 9t-43 30l43 46q11 -14 28.5 -19t35.5 -5q16 0 33 7t32 19.5t26 29.5t15 37l117 548h68l-116 -544q-8 -35 -26.5 -64t-43 -50t-54 -32.5t-57.5 -11.5zM383 730h68l-22 -100h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 468,
    d: "M345 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM100 -11q-85 0 -137 44l31 56q17 -15 47.5 -26t71.5 -11q51 0 85.5 19.5t58.5 57.5t40.5 93.5t31.5 126.5l77 360h70l-77 -360q-17 -81 -38 -147.5t-54.5 -113.5t-83 -73t-123.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 213,
    d: "M-110 -181q-32 0 -57.5 9t-42.5 30l42 46q11 -14 28.5 -19t35.5 -5q16 0 33.5 7t32.5 19.5t26 29.5t15 37l116 548h68l-116 -544q-7 -35 -25.5 -64t-43.5 -50t-54.5 -32.5t-57.5 -11.5zM57 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 615,
    d: "M195 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM175 709h69l-88 -412l455 413h78l-342 -312l205 -398h-78l-179 357l-155 -139l-47 -218h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 536,
    d: "M143 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM164 730h68l-76 -358q51 70 113 114.5t133 44.5q56 0 83 -28.5t27 -76.5q0 -65 -47.5 -117.5t-137.5 -82.5l117 -226h-74l-124 255q100 21 151.5 66t51.5 96q0 30 -17.5 44t-46.5 14q-33 0 -67.5 -15.5t-67.5 -43.5 t-63.5 -67t-54.5 -87l-55 -262h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 508,
    d: "M119 521h68l-61 -287l336 286h75l-246 -213l145 -307h-74l-124 267l-127 -104l-34 -163h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 557,
    d: "M235 807l-42 17l76 93h71zM175 710h69l-138 -648h388l-13 -62h-457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 264,
    d: "M209 773l-42 17l76 93h71zM107 -6q-37 0 -58 19t-21 54q0 6 1 13t3 15l134 635h68l-130 -612q-1 -5 -1.5 -9t-0.5 -9q0 -44 47 -44q11 0 26 3t29 8l-2 -55q-20 -8 -47.5 -13t-47.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 557,
    d: "M185 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM175 710h69l-138 -648h388l-13 -62h-457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 264,
    d: "M33 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM107 -6q-37 0 -58 19t-21 54q0 6 1 13t3 15l134 635h68l-130 -612q-1 -5 -1.5 -9t-0.5 -9q0 -44 47 -44q11 0 26 3t29 8l-2 -55q-20 -8 -47.5 -13t-47.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 557,
    d: "M298 637l76 93h72l-106 -110zM175 710h69l-138 -648h388l-13 -62h-457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 255,
    d: "M269 637l76 93h72l-106 -110zM107 -6q-37 0 -58 19t-21 54q0 6 1 13t3 15l134 635h68l-130 -612q-1 -5 -1.5 -9t-0.5 -9q0 -44 47 -44q11 0 26 3t29 8l-2 -55q-20 -8 -47.5 -13t-47.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 557,
    d: "M175 710h69l-138 -648h388l-13 -62h-457zM329 348l23 112h58l-23 -112h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 300,
    d: "M107 -6q-37 0 -58 19t-21 54q0 6 1 13t3 15l134 635h68l-130 -612q-1 -5 -1.5 -9t-0.5 -9q0 -44 47 -44q11 0 26 3t29 8l-2 -55q-20 -8 -47.5 -13t-47.5 -5zM221 263l23 112h58l-23 -112h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 564,
    d: "M12 269l90 66l80 375h70l-67 -314l172 126l13 -39l-197 -145l-59 -276h387l-13 -62h-457l59 277l-65 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 282,
    d: "M17 328l96 67l71 335h68l-60 -279l100 70l15 -39l-127 -89l-55 -261q-2 -11 -3.5 -18.5t-1.5 -13.5q0 -44 47 -44q11 0 26.5 3t29.5 8l-2 -55q-20 -8 -48 -13t-48 -5q-38 0 -58.5 19t-20.5 53q0 14 3 29l51 242l-69 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 740,
    d: "M480 807l-42 17l76 93h71zM175 710h54l316 -591l125 590h69l-151 -709h-59l-313 580l-123 -580h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 559,
    d: "M373 620l-42 17l76 93h71zM119 521h63l-26 -118q21 28 48.5 51.5t58 40.5t63.5 26t66 9q61 0 87 -33t26 -91q0 -23 -3.5 -47.5t-9.5 -53.5l-64 -305h-68l62 291q10 49 10 85q0 92 -78 92q-28 0 -58.5 -11t-59 -31t-52.5 -47.5t-40 -59.5l-67 -319h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 740,
    d: "M239 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM175 710h54l316 -591l125 590h69l-151 -709h-59l-313 580l-123 -580h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 559,
    d: "M146 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM119 521h63l-26 -118q21 28 48.5 51.5t58 40.5t63.5 26t66 9q61 0 87 -33t26 -91q0 -23 -3.5 -47.5t-9.5 -53.5l-64 -305h-68l62 291q10 49 10 85q0 92 -78 92q-28 0 -58.5 -11t-59 -31t-52.5 -47.5t-40 -59.5 l-67 -319h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 740,
    d: "M372 897l43 20l67 -63l94 63l34 -20l-112 -86h-50zM175 710h54l316 -591l125 590h69l-151 -709h-59l-313 580l-123 -580h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 559,
    d: "M244 710l43 20l67 -63l94 63l34 -20l-112 -86h-50zM119 521h63l-26 -118q21 28 48.5 51.5t58 40.5t63.5 26t66 9q61 0 87 -33t26 -91q0 -23 -3.5 -47.5t-9.5 -53.5l-64 -305h-68l62 291q10 49 10 85q0 92 -78 92q-28 0 -58.5 -11t-59 -31t-52.5 -47.5t-40 -59.5l-67 -319 h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 559,
    d: "M-20 637l48 59l6 34h93l-106 -110zM119 521h63l-26 -118q21 28 48.5 51.5t58 40.5t63.5 26t66 9q61 0 87 -33t26 -91q0 -23 -3.5 -47.5t-9.5 -53.5l-64 -305h-68l62 291q10 49 10 85q0 92 -78 92q-28 0 -58.5 -11t-59 -31t-52.5 -47.5t-40 -59.5l-67 -319h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 736,
    d: "M396 -181q-31 0 -57 9t-43 30l43 46q11 -14 28 -19t35 -5q16 0 33.5 7t32.5 19.5t26 29.5t15 37l8 36l-301 570l-123 -579h-69l151 710h53l311 -588l125 587h70l-156 -734q-8 -35 -26.5 -63.5t-44 -49t-54.5 -32t-57 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 559,
    d: "M242 -181q-32 0 -58 9t-43 30l43 46q11 -14 28 -19t35 -5q16 0 33 7t32 19.5t26.5 29.5t15.5 37l68 318q10 49 10 85q0 92 -78 92q-28 0 -58.5 -11t-59 -31t-52.5 -47.5t-40 -59.5l-67 -319h-68l110 521h63l-26 -118q21 28 48.5 51.5t58 40.5t63.5 26t66 9q61 0 87 -33 t26 -91q0 -23 -3.5 -47.5t-9.5 -53.5l-69 -328q-7 -35 -25.5 -64t-44 -50t-54.5 -32.5t-57 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 722,
    d: "M343 849l10 47h275l-10 -47h-275zM296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58q66 0 123.5 32t101 83.5 t68.5 115t25 126.5q0 47 -13 90t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 573,
    d: "M223 662l10 47h275l-10 -47h-275zM220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50q42 0 83 20.5t73 55t52 80 t20 96.5q0 35 -10 66t-28.5 53.5t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 722,
    d: "M296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90 t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19zM472 851q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15 q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 573,
    d: "M220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5 t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5zM357 664q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 722,
    d: "M405 807l-33 17l73 93h63zM526 807l-32 17l73 93h62zM296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58 q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 573,
    d: "M278 620l-33 17l73 93h63zM399 620l-32 17l73 93h62zM220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50 q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1098,
    d: "M297 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q43 0 78 -14.5t61.5 -39.5t43.5 -59t25 -72l38 180h441l-14 -62h-371l-53 -255h319l-14 -62h-319l-57 -269h379l-13 -62h-449l39 180q-25 -39 -57 -73t-69.5 -59t-78 -39 t-82.5 -14zM309 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90t-37.5 75.5t-60 52t-80.5 19.5q-66 0 -124 -32t-101.5 -83t-68.5 -115t-25 -128q0 -47 12.5 -90t37 -75.5t60.5 -51.5t82 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 985,
    d: "M219 -10q-44 0 -80 16.5t-61.5 45.5t-39.5 68.5t-14 85.5q0 66 26 125t69.5 103t100 70t116.5 26q72 0 118.5 -44.5t56.5 -120.5q44 78 109 121.5t140 43.5q45 0 81 -15.5t61 -44.5t38 -70t13 -91q0 -35 -4 -51t-7 -22h-420q-2 -8 -2 -16.5v-16.5q0 -35 10.5 -64t30 -51 t46.5 -34t60 -12q25 0 50.5 7t48.5 19t41.5 29.5t30.5 38.5l55 -16q-19 -29 -46 -53t-58.5 -41t-66.5 -26.5t-69 -9.5q-71 0 -120 44.5t-66 118.5q-48 -76 -113 -119.5t-135 -43.5zM233 50q43 0 84 20.5t73 55t51.5 80.5t19.5 97q0 35 -10 65.5t-28 53t-43.5 35.5t-56.5 13 q-43 0 -84 -20.5t-73.5 -56t-52 -82t-19.5 -97.5q0 -35 10 -65t28 -52t43.5 -34.5t57.5 -12.5zM887 282q2 10 2 19v18q0 71 -39 114.5t-103 43.5q-36 0 -70 -14.5t-63 -40.5t-51 -62t-33 -78h357z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 628,
    d: "M404 809l-42 17l76 93h71zM24 0l151 710h285q37 0 67 -15.5t50 -41.5t31 -59.5t11 -68.5q0 -43 -16 -84.5t-43 -75.5t-63.5 -58.5t-77.5 -32.5l107 -274h-79l-102 262h-196l-56 -262h-69zM381 324q34 0 64.5 17t53 44.5t35.5 62t13 69.5q0 27 -7.5 50.5t-21 41.5 t-33 28.5t-42.5 10.5h-212l-69 -324h219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 343,
    d: "M254 620l-42 17l76 93h71zM119 521h64l-27 -125q39 57 88.5 90.5t100.5 35.5q8 0 13.5 -0.5t10.5 -1.5l-13 -59q-65 -2 -121 -38t-90 -99l-68 -324h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 628,
    d: "M183 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM24 0l151 710h285q37 0 67 -15.5t50 -41.5t31 -59.5t11 -68.5q0 -43 -16 -84.5t-43 -75.5t-63.5 -58.5t-77.5 -32.5l107 -274h-79l-102 262h-196l-56 -262h-69zM381 324q34 0 64.5 17t53 44.5t35.5 62t13 69.5 q0 27 -7.5 50.5t-21 41.5t-33 28.5t-42.5 10.5h-212l-69 -324h219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 343,
    d: "M-32 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM119 521h64l-27 -125q39 57 88.5 90.5t100.5 35.5q8 0 13.5 -0.5t10.5 -1.5l-13 -59q-65 -2 -121 -38t-90 -99l-68 -324h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 628,
    d: "M318 899l43 20l67 -63l94 63l34 -20l-112 -86h-50zM24 0l151 710h285q37 0 67 -15.5t50 -41.5t31 -59.5t11 -68.5q0 -43 -16 -84.5t-43 -75.5t-63.5 -58.5t-77.5 -32.5l107 -274h-79l-102 262h-196l-56 -262h-69zM381 324q34 0 64.5 17t53 44.5t35.5 62t13 69.5 q0 27 -7.5 50.5t-21 41.5t-33 28.5t-42.5 10.5h-212l-69 -324h219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 343,
    d: "M150 710l43 20l67 -63l94 63l34 -20l-112 -86h-50zM119 521h64l-27 -125q39 57 88.5 90.5t100.5 35.5q8 0 13.5 -0.5t10.5 -1.5l-13 -59q-65 -2 -121 -38t-90 -99l-68 -324h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 585,
    d: "M407 823l-42 17l76 93h71zM241 -6q-159 0 -250 103l47 57q27 -41 83.5 -69.5t134.5 -28.5q91 0 144 37.5t53 108.5q0 26 -11.5 44.5t-34 33t-54.5 25t-74 21.5q-43 11 -76.5 23.5t-56.5 29.5t-35 40.5t-12 55.5q0 56 22.5 100.5t61.5 75.5t91.5 47.5t113.5 16.5 q67 0 116.5 -21.5t82.5 -60.5l-45 -56q-20 34 -64 55t-104 21q-52 0 -89.5 -12t-62 -33t-36 -49.5t-11.5 -61.5q0 -24 10 -41t30 -29.5t50 -22t70 -19.5q44 -11 80 -23.5t61.5 -31t39.5 -44.5t14 -63q0 -57 -22.5 -100t-61.5 -71.5t-91.5 -43t-113.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 468,
    d: "M292 620l-42 17l76 93h71zM172 -10q-58 0 -109 20t-83 58l40 46q67 -72 162 -72q66 0 108.5 30.5t42.5 81.5q0 18 -8 30t-24 21.5t-40 17.5t-55 16q-36 10 -62.5 19.5t-44 21.5t-26.5 28.5t-9 39.5q0 43 18.5 77t49 57.5t71 35.5t84.5 12q57 0 99 -19.5t65 -51.5l-42 -40 q-21 30 -57.5 45t-78.5 15q-28 0 -54 -7t-45.5 -21t-31 -35t-11.5 -50q0 -32 25.5 -45.5t79.5 -27.5q81 -20 123.5 -45.5t42.5 -77.5q0 -39 -17 -72t-47.5 -57t-73 -37.5t-92.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 585,
    d: "M298 848l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM241 -6q-159 0 -250 103l47 57q27 -41 83.5 -69.5t134.5 -28.5q91 0 144 37.5t53 108.5q0 26 -11.5 44.5t-34 33t-54.5 25t-74 21.5q-43 11 -76.5 23.5t-56.5 29.5t-35 40.5t-12 55.5q0 56 22.5 100.5t61.5 75.5 t91.5 47.5t113.5 16.5q67 0 116.5 -21.5t82.5 -60.5l-45 -56q-20 34 -64 55t-104 21q-52 0 -89.5 -12t-62 -33t-36 -49.5t-11.5 -61.5q0 -24 10 -41t30 -29.5t50 -22t70 -19.5q44 -11 80 -23.5t61.5 -31t39.5 -44.5t14 -63q0 -57 -22.5 -100t-61.5 -71.5t-91.5 -43 t-113.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 468,
    d: "M197 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM172 -10q-58 0 -109 20t-83 58l40 46q67 -72 162 -72q66 0 108.5 30.5t42.5 81.5q0 18 -8 30t-24 21.5t-40 17.5t-55 16q-36 10 -62.5 19.5t-44 21.5t-26.5 28.5t-9 39.5q0 43 18.5 77t49 57.5t71 35.5t84.5 12 q57 0 99 -19.5t65 -51.5l-42 -40q-21 30 -57.5 45t-78.5 15q-28 0 -54 -7t-45.5 -21t-31 -35t-11.5 -50q0 -32 25.5 -45.5t79.5 -27.5q81 -20 123.5 -45.5t42.5 -77.5q0 -39 -17 -72t-47.5 -57t-73 -37.5t-92.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 586,
    d: "M148 -126q11 -7 32.5 -12.5t46.5 -5.5q64 0 64 43q0 16 -11.5 22t-29.5 6q-20 0 -43 -4.5t-37 -9.5l59 81q-151 5 -237 103l47 57q27 -41 83.5 -69.5t134.5 -28.5q91 0 144 37.5t53 108.5q0 26 -11.5 44.5t-34 33t-54.5 25t-74 21.5q-43 11 -76.5 23.5t-56.5 29.5 t-35 40.5t-12 55.5q0 56 22.5 100.5t61.5 75.5t91.5 47.5t113.5 16.5q67 0 116.5 -21.5t82.5 -60.5l-45 -56q-20 34 -64 55t-104 21q-52 0 -89.5 -12t-62 -33t-36 -49.5t-11.5 -61.5q0 -24 10 -41t30 -29.5t50 -22t70 -19.5q44 -11 80 -23.5t61.5 -31t39.5 -44.5t14 -63 q0 -54 -20 -95.5t-55.5 -70t-84 -44t-104.5 -18.5l-36 -46q9 4 19 5t18 1q29 0 45 -12.5t16 -36.5q0 -38 -29.5 -60t-85.5 -22q-27 0 -50 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 468,
    d: "M74 -126q11 -7 32.5 -12.5t46.5 -5.5q64 0 64 43q0 16 -11.5 22t-29.5 6q-20 0 -43 -4.5t-37 -9.5l56 78q-52 3 -97.5 22.5t-74.5 54.5l40 46q67 -72 162 -72q66 0 108.5 30.5t42.5 81.5q0 18 -8 30t-24 21.5t-40 17.5t-55 16q-36 10 -62.5 19.5t-44 21.5t-26.5 28.5 t-9 39.5q0 43 18.5 77t49 57.5t71 35.5t84.5 12q57 0 99 -19.5t65 -51.5l-42 -40q-21 30 -57.5 45t-78.5 15q-28 0 -54 -7t-45.5 -21t-31 -35t-11.5 -50q0 -32 25.5 -45.5t79.5 -27.5q81 -20 123.5 -45.5t42.5 -77.5q0 -38 -15.5 -69.5t-43.5 -55t-67 -38t-86 -16.5l-33 -42 q9 4 19 5t18 1q29 0 45 -12.5t16 -36.5q0 -38 -29.5 -60t-85.5 -22q-27 0 -50 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 585,
    d: "M305 913l43 20l67 -63l94 63l34 -20l-112 -86h-50zM241 -6q-159 0 -250 103l47 57q27 -41 83.5 -69.5t134.5 -28.5q91 0 144 37.5t53 108.5q0 26 -11.5 44.5t-34 33t-54.5 25t-74 21.5q-43 11 -76.5 23.5t-56.5 29.5t-35 40.5t-12 55.5q0 56 22.5 100.5t61.5 75.5 t91.5 47.5t113.5 16.5q67 0 116.5 -21.5t82.5 -60.5l-45 -56q-20 34 -64 55t-104 21q-52 0 -89.5 -12t-62 -33t-36 -49.5t-11.5 -61.5q0 -24 10 -41t30 -29.5t50 -22t70 -19.5q44 -11 80 -23.5t61.5 -31t39.5 -44.5t14 -63q0 -57 -22.5 -100t-61.5 -71.5t-91.5 -43 t-113.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 468,
    d: "M198 710l43 20l67 -63l94 63l34 -20l-112 -86h-50zM172 -10q-58 0 -109 20t-83 58l40 46q67 -72 162 -72q66 0 108.5 30.5t42.5 81.5q0 18 -8 30t-24 21.5t-40 17.5t-55 16q-36 10 -62.5 19.5t-44 21.5t-26.5 28.5t-9 39.5q0 43 18.5 77t49 57.5t71 35.5t84.5 12 q57 0 99 -19.5t65 -51.5l-42 -40q-21 30 -57.5 45t-78.5 15q-28 0 -54 -7t-45.5 -21t-31 -35t-11.5 -50q0 -32 25.5 -45.5t79.5 -27.5q81 -20 123.5 -45.5t42.5 -77.5q0 -39 -17 -72t-47.5 -57t-73 -37.5t-92.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 581,
    d: "M327 648h-238l13 62h547l-13 -62h-239l-138 -648h-10l-41 -51q9 4 19 5t18 1q29 0 45 -12.5t16 -36.5q0 -38 -29.5 -60t-85.5 -22q-27 0 -50 5.5t-40 13.5l24 31q11 -7 32.5 -12.5t46.5 -5.5q64 0 64 43q0 16 -11.5 22t-29.5 6q-20 0 -43 -4.5t-37 -9.5l63 87h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 321,
    d: "M36 -126q11 -7 32.5 -12.5t46.5 -5.5q64 0 64 43q0 16 -11.5 22t-29.5 6q-20 0 -43 -4.5t-37 -9.5l59 82q-31 4 -50 22.5t-19 51.5q0 11 3 25l79 373h-69l12 54h68l38 176h68l-38 -176h114l-12 -54h-113l-72 -339q-2 -11 -3.5 -17t-1.5 -11q0 -23 14 -33t34 -10 q27 0 50 9.5t30 13.5l6 -55q-11 -8 -38 -17.5t-61 -12.5l-37 -46q9 4 19 5t18 1q29 0 45 -12.5t16 -36.5q0 -38 -29.5 -60t-85.5 -22q-27 0 -50 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 582,
    d: "M291 897l43 20l67 -63l94 63l34 -20l-112 -86h-50zM328 648h-238l13 62h547l-13 -62h-239l-138 -648h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 321,
    d: "M291 637l76 93h72l-106 -110zM135 -6q-38 0 -62.5 18.5t-24.5 56.5q0 11 3 25l79 373h-69l12 54h68l38 176h68l-38 -176h114l-12 -54h-113l-72 -339q-2 -11 -3.5 -17t-1.5 -11q0 -23 14 -33t34 -10q27 0 50 9.5t30 13.5l6 -55q-13 -9 -46.5 -20t-73.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 617,
    d: "M86 405h208l52 243h-239l13 62h547l-13 -62h-239l-52 -243h208l-8 -39h-209l-77 -366h-69l78 366h-208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 322,
    d: "M38 353h68l24 114h-68l11 54h69l38 176h68l-38 -176h113l-11 -54h-114l-24 -114h113l-9 -46h-114l-36 -171q-6 -24 -6 -34q0 -23 14 -34t34 -11q13 0 26 3t24 6.5t19 7.5t11 6l6 -55q-14 -9 -47.5 -20t-72.5 -11q-38 0 -63 18.5t-25 56.5q0 11 3 25l45 213h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 724,
    d: "M298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5 t-104.5 -77.5t-138 -29zM525 825q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31 t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 569,
    d: "M159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23 t7.5 36q-46 -61 -108 -94.5t-127 -33.5zM398 638q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20 t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 724,
    d: "M298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5 t-104.5 -77.5t-138 -29zM336 849l10 47h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 569,
    d: "M159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23 t7.5 36q-46 -61 -108 -94.5t-127 -33.5zM207 662l10 47h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 724,
    d: "M298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5 t-104.5 -77.5t-138 -29zM467 851q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 569,
    d: "M159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23 t7.5 36q-46 -61 -108 -94.5t-127 -33.5zM341 664q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 724,
    d: "M403 839q0 35 26 56.5t61 21.5q27 0 42.5 -14.5t15.5 -38.5q0 -34 -25 -56t-62 -22q-27 0 -42.5 14.5t-15.5 38.5zM484 890q-18 0 -33 -13t-15 -33q0 -13 8.5 -22t22.5 -9q17 0 33 13t16 33q0 14 -9 22.5t-23 8.5zM298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5 t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5t-104.5 -77.5t-138 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 569,
    d: "M273 652q0 35 26 56.5t61 21.5q27 0 42.5 -14.5t15.5 -38.5q0 -34 -25 -56t-62 -22q-27 0 -42.5 14.5t-15.5 38.5zM354 703q-18 0 -33 -13t-15 -33q0 -13 8.5 -22t22.5 -9q17 0 33 13t16 33q0 14 -9 22.5t-23 8.5zM159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5 l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23t7.5 36q-46 -61 -108 -94.5t-127 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 724,
    d: "M298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5 t-104.5 -77.5t-138 -29zM390 807l-33 17l73 93h63zM511 807l-32 17l73 93h62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 569,
    d: "M159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23 t7.5 36q-46 -61 -108 -94.5t-127 -33.5zM259 620l-33 17l73 93h63zM380 620l-32 17l73 93h62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 724,
    d: "M238 -176q-30 7 -45 23t-15 38q0 28 21.5 54t69.5 57q-54 4 -91 24t-60 51.5t-33 72t-10 86.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358 q-15 -70 -42.5 -133.5t-70 -112t-100 -78t-130.5 -32.5q-52 -31 -72.5 -53t-20.5 -45q0 -30 42 -36l-26 -38v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 569,
    d: "M159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-55 -32 -77 -55t-22 -46q0 -30 42 -36l-26 -38q-30 7 -45 23t-15 38 q0 29 23 56t74 59q-25 7 -25 36q0 3 0.5 8t2 14t4 23t7.5 36q-46 -61 -108 -94.5t-127 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 997,
    d: "M486 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM95 710h75l108 -629l195 321l-53 303h66l40 -252l149 252h66l-182 -303l59 -321l374 629h77l-437 -710h-60l-66 351l-216 -351h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 755,
    d: "M317 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63zM53 521h70l84 -458q40 48 74 97.5t63 100.5l-60 260h70l38 -173q22 45 38.5 88t28.5 85h65q-19 -65 -47 -129.5t-65 -129.5l43 -199q88 112 149.5 229t92.5 229h66q-77 -263 -287 -521h-73l-40 184q-29 -47 -62.5 -93 t-72.5 -91h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 607,
    d: "M257 266l-166 444h77l137 -382l300 382h76l-356 -446l-56 -264h-69zM285 832l113 85h50l75 -85l-42 -21l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 489,
    d: "M-36 -169q31 5 53.5 12t40 20t33 32t34.5 48l33 49l-107 529h71l84 -458l41 67q43 70 73 123t51.5 97.5t36 85t26.5 85.5h67q-14 -48 -29 -89.5t-37.5 -88t-56 -104t-83.5 -136.5l-81 -129q-35 -55 -63.5 -92t-56 -60t-56.5 -33.5t-65 -12.5zM182 645l113 85h50l75 -85 l-42 -21l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 607,
    d: "M257 266l-166 444h77l137 -382l300 382h76l-356 -446l-56 -264h-69zM305 820l21 94h58l-21 -94h-58zM449 820l20 94h57l-19 -94h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 596,
    d: "M390 807l-42 17l76 93h71zM-24 55l580 593h-446l13 62h528l-12 -55l-574 -593h447l-13 -62h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 466,
    d: "M277 620l-42 17l76 93h71zM-26 46l419 424h-321l11 51h397l-9 -46l-417 -424h327l-12 -51h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 596,
    d: "M-24 55l580 593h-446l13 62h528l-12 -55l-574 -593h447l-13 -62h-535zM370 820l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 466,
    d: "M-26 46l419 424h-321l11 51h397l-9 -46l-417 -424h327l-12 -51h-404zM260 633l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 596,
    d: "M296 897l43 20l67 -63l94 63l34 -20l-112 -86h-50zM-24 55l580 593h-446l13 62h528l-12 -55l-574 -593h447l-13 -62h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 466,
    d: "M186 710l43 20l67 -63l94 63l34 -20l-112 -86h-50zM-26 46l419 424h-321l11 51h397l-9 -46l-417 -424h327l-12 -51h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 706,
    d: "M282 -6q-57 0 -104 21.5t-80 59.5t-51.5 89.5t-18.5 111.5q0 38 7 65t12 42h556l2 22t1 23q0 48 -14 89t-39 70.5t-60 46t-77 16.5q-34 0 -68 -10t-65 -28.5t-57 -44t-42 -56.5l-60 30q25 38 60.5 70t76.5 55t85.5 36t88.5 13q56 0 101.5 -22.5t78 -62t50 -92.5 t17.5 -114q0 -87 -34 -165.5t-90 -137t-128 -93t-148 -34.5zM295 57q49 0 96.5 20t87 55.5t69 84t43.5 105.5h-488q-6 -29 -6 -58q0 -42 12.5 -79.5t37.5 -66t62 -45t86 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 505,
    d: "M37 -181q-31 0 -57 9t-43 30l42 46q11 -14 28.5 -19t35.5 -5q16 0 33.5 7t32.5 19.5t26 29.5t15 37l92 433h-69l11 54h70l15 75q20 96 71 150.5t119 54.5q29 0 55 -9t43 -24l-30 -49q-11 11 -29 17t-38 6q-45 0 -76 -37t-46 -107l-16 -77h135l-12 -54h-135l-92 -431 q-8 -35 -26.5 -63.5t-43 -49t-54 -32t-57.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1286,
    d: "M985 897l43 20l67 -63l94 63l34 -20l-112 -86h-50zM666 55l580 593h-446l13 62h528l-12 -55l-574 -593h447l-13 -62h-535zM175 710h230q66 0 115 -21t81 -58t47.5 -86.5t15.5 -106.5q0 -94 -31 -174.5t-86 -139t-130 -91.5t-163 -33h-230zM267 62q75 0 135.5 30 t102.5 80.5t64.5 116.5t22.5 138q0 48 -12.5 89t-38 70t-63 45.5t-87.5 16.5h-160l-125 -586h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1156,
    d: "M875 710l43 20l67 -63l94 63l34 -20l-112 -86h-50zM664 46l419 424h-321l11 51h397l-9 -46l-417 -424h327l-12 -51h-404zM175 710h230q66 0 115 -21t81 -58t47.5 -86.5t15.5 -106.5q0 -94 -31 -174.5t-86 -139t-130 -91.5t-163 -33h-230zM267 62q75 0 135.5 30 t102.5 80.5t64.5 116.5t22.5 138q0 48 -12.5 89t-38 70t-63 45.5t-87.5 16.5h-160l-125 -586h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1064,
    d: "M784 710l43 20l67 -63l94 63l34 -20l-112 -86h-50zM572 46l419 424h-321l11 51h397l-9 -46l-417 -424h327l-12 -51h-404zM211 -10q-44 0 -78.5 17.5t-58.5 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92.5 72t109.5 27q62 0 103 -34.5t58 -83.5l68 318h68l-136 -641 q-2 -10 -2 -12q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-24 0 -36.5 11.5t-12.5 28.5q0 7 2 19.5t9 43.5q-40 -51 -96.5 -81t-110.5 -30zM239 50q24 0 52.5 10t55.5 27.5t48.5 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41.5t-43 28t-49 10q-45 0 -86 -22.5 t-71.5 -58t-48.5 -80.5t-18 -90q0 -35 10 -65.5t29 -53.5t45 -36.5t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1025,
    d: "M657 -11q-85 0 -137 44l31 56q17 -15 47.5 -26t71.5 -11q51 0 85.5 19.5t58.5 57.5t40.5 93.5t31.5 126.5l77 360h70l-77 -360q-17 -81 -38 -147.5t-54.5 -113.5t-83 -73t-123.5 -26zM175 710h69l-138 -648h388l-13 -62h-457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 777,
    d: "M454 -181q-32 0 -58 9t-43 30l43 46q11 -14 28.5 -19t35.5 -5q16 0 33 7t32 19.5t26 29.5t15 37l117 548h68l-116 -544q-8 -35 -26.5 -64t-43 -50t-54 -32.5t-57.5 -11.5zM727 730h68l-22 -100h-68zM175 710h69l-138 -648h388l-13 -62h-457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 483,
    d: "M161 -181q-32 0 -58 9t-43 30l43 46q11 -14 28.5 -19t35.5 -5q16 0 33 7t32 19.5t26 29.5t15 37l117 548h68l-116 -544q-8 -35 -26.5 -64t-43 -50t-54 -32.5t-57.5 -11.5zM434 730h68l-22 -100h-68zM107 -6q-37 0 -58 19t-21 54q0 6 1 13t3 15l134 635h68l-130 -612 q-1 -5 -1.5 -9t-0.5 -9q0 -44 47 -44q11 0 26 3t29 8l-2 -55q-20 -8 -47.5 -13t-47.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1208,
    d: "M840 -11q-85 0 -137 44l31 56q17 -15 47.5 -26t71.5 -11q51 0 85.5 19.5t58.5 57.5t40.5 93.5t31.5 126.5l77 360h70l-77 -360q-17 -81 -38 -147.5t-54.5 -113.5t-83 -73t-123.5 -26zM175 710h54l316 -591l125 590h69l-151 -709h-59l-313 580l-123 -580h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 960,
    d: "M637 -181q-32 0 -58 9t-43 30l43 46q11 -14 28.5 -19t35.5 -5q16 0 33 7t32 19.5t26 29.5t15 37l117 548h68l-116 -544q-8 -35 -26.5 -64t-43 -50t-54 -32.5t-57.5 -11.5zM910 730h68l-22 -100h-68zM175 710h54l316 -591l125 590h69l-151 -709h-59l-313 580l-123 -580 h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 779,
    d: "M456 -181q-32 0 -58 9t-43 30l43 46q11 -14 28.5 -19t35.5 -5q16 0 33 7t32 19.5t26 29.5t15 37l117 548h68l-116 -544q-8 -35 -26.5 -64t-43 -50t-54 -32.5t-57.5 -11.5zM729 730h68l-22 -100h-68zM119 521h63l-26 -118q21 28 48.5 51.5t58 40.5t63.5 26t66 9 q61 0 87 -33t26 -91q0 -23 -3.5 -47.5t-9.5 -53.5l-64 -305h-68l62 291q10 49 10 85q0 92 -78 92q-28 0 -58.5 -11t-59 -31t-52.5 -47.5t-40 -59.5l-67 -319h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 722,
    d: "M236 -176q-30 7 -45 23t-15 38q0 28 22 54.5t70 57.5q-54 6 -95 31.5t-69.5 65.5t-43 90t-14.5 104q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -78 -32 -153t-85.5 -134t-123 -96t-144.5 -41q-52 -31 -72.5 -53t-20.5 -45 q0 -30 42 -36zM310 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 573,
    d: "M178 -181q-30 7 -45 23t-15 38q0 27 21 53.5t69 56.5q-44 3 -78 21t-57.5 47.5t-36 68t-12.5 81.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -57 -21.5 -111t-58.5 -97t-86.5 -72.5t-105.5 -37.5q-54 -32 -75.5 -54.5 t-21.5 -45.5q0 -30 42 -36zM233 50q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1275,
    d: "M654 55l580 593h-446l13 62h528l-12 -55l-574 -593h447l-13 -62h-535zM175 710h230q66 0 115 -21t81 -58t47.5 -86.5t15.5 -106.5q0 -94 -31 -174.5t-86 -139t-130 -91.5t-163 -33h-230zM267 62q75 0 135.5 30t102.5 80.5t64.5 116.5t22.5 138q0 48 -12.5 89t-38 70 t-63 45.5t-87.5 16.5h-160l-125 -586h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1156,
    d: "M664 46l419 424h-321l11 51h397l-9 -46l-417 -424h327l-12 -51h-404zM175 710h230q66 0 115 -21t81 -58t47.5 -86.5t15.5 -106.5q0 -94 -31 -174.5t-86 -139t-130 -91.5t-163 -33h-230zM267 62q75 0 135.5 30t102.5 80.5t64.5 116.5t22.5 138q0 48 -12.5 89t-38 70 t-63 45.5t-87.5 16.5h-160l-125 -586h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1064,
    d: "M572 46l419 424h-321l11 51h397l-9 -46l-417 -424h327l-12 -51h-404zM211 -10q-44 0 -78.5 17.5t-58.5 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92.5 72t109.5 27q62 0 103 -34.5t58 -83.5l68 318h68l-136 -641q-2 -10 -2 -12q0 -17 19 -17l-13 -60 q-8 -1 -13.5 -1.5t-10.5 -0.5q-24 0 -36.5 11.5t-12.5 28.5q0 7 2 19.5t9 43.5q-40 -51 -96.5 -81t-110.5 -30zM239 50q24 0 52.5 10t55.5 27.5t48.5 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41.5t-43 28t-49 10q-45 0 -86 -22.5t-71.5 -58t-48.5 -80.5t-18 -90 q0 -35 10 -65.5t29 -53.5t45 -36.5t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 687,
    d: "M455 807l-42 17l76 93h71zM532 103q-115 -108 -237 -108q-58 0 -104 24.5t-78 66t-49 95t-17 111.5q0 80 33 156t88.5 135.5t127 95.5t149.5 36q49 0 87 -11.5t66 -32t45.5 -49t26.5 -62.5l-62 -36q-18 66 -64.5 97t-113.5 31q-64 0 -121 -31.5t-99.5 -82.5t-67.5 -114.5 t-25 -127.5q0 -49 14 -92t39.5 -75.5t61.5 -51.5t81 -19q57 0 115 28.5t119 89.5l26 119h-148l11 54h208l-74 -349h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 592,
    d: "M324 620l-42 17l76 93h71zM165 -223q-43 0 -75 8.5t-56 23.5t-40.5 37t-26.5 49l48 33q19 -50 62 -73.5t99 -23.5q36 0 70 10.5t62.5 31t49 52t29.5 73.5l22 103q-19 -25 -43 -45t-51 -34t-55 -21.5t-55 -7.5q-43 0 -76.5 17.5t-57 47t-35.5 68.5t-12 82q0 61 24 119 t64.5 103t93.5 72.5t112 27.5q64 0 103 -33.5t62 -84.5l23 109h60l-111 -523q-12 -55 -40 -96.5t-67 -69t-86 -41.5t-97 -14zM237 50q28 0 58 11t56 29.5t46 41.5t29 47l34 161q-4 28 -17 52t-31.5 41t-42.5 27t-50 10q-47 0 -88 -23t-71.5 -59.5t-48 -81t-17.5 -87.5 q0 -35 10 -65.5t29 -53.5t45.5 -36.5t58.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 651,
    d: "M455 812q20 -4 31 -17.5t11 -33.5q0 -24 -13 -42.5t-35 -27.5l125 -691h-74l-39 222h-299l-132 -222h-75l420 692q-23 14 -23 44q0 35 26 56.5t61 21.5q4 0 7 -0.5t7 -0.5l-40 15l76 90h71zM457 277l-58 351l-211 -351h269zM433 787q-18 0 -33 -13t-15 -33q0 -13 8.5 -22 t22.5 -9q17 0 33 13t16 33q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM377 770l-42 17l76 93h71zM283 652q0 35 26 56.5t61 21.5 q27 0 42.5 -14.5t15.5 -38.5q0 -34 -25 -56t-62 -22q-27 0 -42.5 14.5t-15.5 38.5zM364 703q-18 0 -33 -13t-15 -33q0 -13 8.5 -22t22.5 -9q17 0 33 13t16 33q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 923,
    d: "M573 807l-42 17l76 93h71zM503 710h459l-14 -62h-371l-53 -255h319l-14 -62h-319l-57 -269h379l-13 -62h-448l47 222h-244l-179 -222h-76zM427 284l73 342l-281 -342h208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 885,
    d: "M501 620l-42 17l76 93h71zM133 -10q-33 0 -58.5 10.5t-43.5 28.5t-27 42t-9 52q0 41 19 75t52 59t77.5 38.5t95.5 13.5q33 0 64.5 -5.5t57.5 -14.5q8 26 18 46.5t14 44.5q0 43 -28.5 71t-82.5 28q-38 0 -81 -16t-91 -46l-13 45q56 34 105.5 51t97.5 17q60 0 98 -27 t49 -77q42 47 96.5 75.5t115.5 28.5q46 0 82.5 -16.5t62 -45.5t39.5 -68t14 -84q0 -32 -5.5 -51.5t-9.5 -28.5h-427q-1 -8 -1.5 -16.5t-0.5 -17.5q0 -35 10.5 -64.5t30 -50.5t46.5 -33t60 -12q24 0 49 7t47.5 19t41.5 29.5t32 38.5l56 -16q-18 -29 -44 -52.5t-57.5 -41 t-66.5 -27t-71 -9.5q-66 0 -112.5 31.5t-68.5 83.5q-23 -31 -53 -53t-62 -35.5t-63 -20t-55 -6.5zM160 42q27 0 57 8.5t57.5 23.5t48 34.5t28.5 41.5q-4 16 -4 41q0 14 1.5 28.5t3.5 26.5q-25 10 -54 15t-57 5q-39 0 -71.5 -9.5t-56.5 -26.5t-37.5 -41t-13.5 -53 q0 -38 24 -66t74 -28zM788 282q2 10 2.5 20.5t0.5 19.5q0 67 -37.5 111t-106.5 44q-38 0 -73 -14.5t-64.5 -40.5t-52 -62t-33.5 -78h364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 722,
    d: "M713 710l-76 -90q30 -42 45.5 -93.5t15.5 -106.5q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36q-44 0 -80.5 13t-65.5 36l-37 -44h-77l73 86q-31 41 -47 93t-16 109q0 81 34 158t90.5 137t129 96t150.5 36q45 0 81.5 -14t65.5 -38l40 47h76zM117 294 q0 -43 10 -81.5t30 -69.5l394 465q-23 20 -51.5 31.5t-63.5 11.5q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5zM310 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 42 -10 79.5t-29 68.5l-393 -465q23 -19 51 -29.5t63 -10.5zM472 807l-42 17l76 93h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 573,
    d: "M77 53q-53 62 -53 155q0 63 25.5 121t68.5 102.5t99.5 71.5t117.5 27q35 0 65 -10.5t53 -29.5l31 33h46l-53 -56q54 -62 54 -156q0 -62 -25 -120t-68 -102.5t-99 -71.5t-118 -27q-36 0 -66.5 10.5t-53.5 29.5l-30 -31h-46zM233 50q42 0 83 20.5t73 55t52 80t20 96.5 q0 32 -9 61t-25 51l-280 -332q35 -32 86 -32zM94 216q0 -33 8.5 -61.5t24.5 -50.5l280 334q-17 15 -38.5 23.5t-46.5 8.5q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97zM349 620l-42 17l76 93h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM437 918h61l35 -93l-41 -17zM315 918h63l34 -93l-41 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM344 730h61l35 -93l-41 -17zM222 730h63l34 -93l-41 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 651,
    d: "M386 710h60l128 -710h-74l-39 222h-299l-132 -222h-75zM457 277l-58 351l-211 -351h269zM343 816q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    d: "M210 -10q-44 0 -78 17.5t-58 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q63 0 104 -34.5t58 -83.5l24 109h68l-92 -432q-2 -8 -2 -13q0 -16 19 -16l-13 -60q-8 -1 -15 -2t-12 -1q-23 2 -34.5 12.5t-11.5 27.5q0 8 2.5 21t8.5 43q-40 -51 -96.5 -81 t-111.5 -30zM238 50q25 0 54 10t55.5 27.5t48 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41t-43 28t-50 10.5q-45 0 -85.5 -22.5t-71 -58.5t-48.5 -81t-18 -90q0 -35 10 -65.5t29 -53t45 -36t58 -13.5zM256 629q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5 t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 582,
    d: "M426 918h61l35 -93l-41 -17zM304 918h63l34 -93l-41 -17zM175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 534,
    d: "M352 730h61l35 -93l-41 -17zM230 730h63l34 -93l-41 -17zM226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14 q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 582,
    d: "M330 816q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40zM175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 534,
    d: "M267 629q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40zM226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27 q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477 q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM234 918h61l35 -93l-41 -17zM112 918h63l34 -93l-41 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 213,
    d: "M172 730h61l35 -93l-41 -17zM50 730h63l34 -93l-41 -17zM119 521h68l-110 -521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM139 816q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 213,
    d: "M82 629q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40zM119 521h68l-110 -521h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 722,
    d: "M491 918h61l35 -93l-41 -17zM369 918h63l34 -93l-41 -17zM296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58 q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 573,
    d: "M357 730h61l35 -93l-41 -17zM235 730h63l34 -93l-41 -17zM220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50 q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 722,
    d: "M387 816q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40zM296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36 q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58q66 0 123.5 32t101 83.5t68.5 115t25 126.5q0 47 -13 90t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90 t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 573,
    d: "M266 629q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40zM220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27 q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50q42 0 83 20.5t73 55t52 80t20 96.5q0 35 -10 66t-28.5 53.5t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35 t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 628,
    d: "M419 918h61l35 -93l-41 -17zM297 918h63l34 -93l-41 -17zM24 0l151 710h285q37 0 67 -15.5t50 -41.5t31 -59.5t11 -68.5q0 -43 -16 -84.5t-43 -75.5t-63.5 -58.5t-77.5 -32.5l107 -274h-79l-102 262h-196l-56 -262h-69zM381 324q34 0 64.5 17t53 44.5t35.5 62t13 69.5 q0 27 -7.5 50.5t-21 41.5t-33 28.5t-42.5 10.5h-212l-69 -324h219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 343,
    d: "M262 730h61l35 -93l-41 -17zM140 730h63l34 -93l-41 -17zM119 521h64l-27 -125q39 57 88.5 90.5t100.5 35.5q8 0 13.5 -0.5t10.5 -1.5l-13 -59q-65 -2 -121 -38t-90 -99l-68 -324h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 628,
    d: "M325 816q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40zM24 0l151 710h285q37 0 67 -15.5t50 -41.5t31 -59.5t11 -68.5q0 -43 -16 -84.5t-43 -75.5t-63.5 -58.5 t-77.5 -32.5l107 -274h-79l-102 262h-196l-56 -262h-69zM381 324q34 0 64.5 17t53 44.5t35.5 62t13 69.5q0 27 -7.5 50.5t-21 41.5t-33 28.5t-42.5 10.5h-212l-69 -324h219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 343,
    d: "M161 630q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40zM119 521h64l-27 -125q39 57 88.5 90.5t100.5 35.5q8 0 13.5 -0.5t10.5 -1.5l-13 -59q-65 -2 -121 -38 t-90 -99l-68 -324h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 724,
    d: "M474 918h61l35 -93l-41 -17zM352 918h63l34 -93l-41 -17zM298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107 l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5t-104.5 -77.5t-138 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 569,
    d: "M344 730h61l35 -93l-41 -17zM222 730h63l34 -93l-41 -17zM159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5 t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23t7.5 36q-46 -61 -108 -94.5t-127 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 724,
    d: "M378 816q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40zM298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358 q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5t-104.5 -77.5t-138 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 569,
    d: "M248 629q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40zM159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99 q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23t7.5 36q-46 -61 -108 -94.5t-127 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 585,
    d: "M171 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM241 -6q-159 0 -250 103l47 57q27 -41 83.5 -69.5t134.5 -28.5q91 0 144 37.5t53 108.5q0 26 -11.5 44.5t-34 33t-54.5 25t-74 21.5q-43 11 -76.5 23.5t-56.5 29.5t-35 40.5t-12 55.5q0 56 22.5 100.5t61.5 75.5 t91.5 47.5t113.5 16.5q67 0 116.5 -21.5t82.5 -60.5l-45 -56q-20 34 -64 55t-104 21q-52 0 -89.5 -12t-62 -33t-36 -49.5t-11.5 -61.5q0 -24 10 -41t30 -29.5t50 -22t70 -19.5q44 -11 80 -23.5t61.5 -31t39.5 -44.5t14 -63q0 -57 -22.5 -100t-61.5 -71.5t-91.5 -43 t-113.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 468,
    d: "M105 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM172 -10q-58 0 -109 20t-83 58l40 46q67 -72 162 -72q66 0 108.5 30.5t42.5 81.5q0 18 -8 30t-24 21.5t-40 17.5t-55 16q-36 10 -62.5 19.5t-44 21.5t-26.5 28.5t-9 39.5q0 43 18.5 77t49 57.5t71 35.5t84.5 12 q57 0 99 -19.5t65 -51.5l-42 -40q-21 30 -57.5 45t-78.5 15q-28 0 -54 -7t-45.5 -21t-31 -35t-11.5 -50q0 -32 25.5 -45.5t79.5 -27.5q81 -20 123.5 -45.5t42.5 -77.5q0 -39 -17 -72t-47.5 -57t-73 -37.5t-92.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 582,
    d: "M156 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM328 648h-238l13 62h547l-13 -62h-239l-138 -648h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 321,
    d: "M64 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34zM135 -6q-38 0 -62.5 18.5t-24.5 56.5q0 11 3 25l79 373h-69l12 54h68l38 176h68l-38 -176h114l-12 -54h-113l-72 -339q-2 -11 -3.5 -17t-1.5 -11q0 -23 14 -33t34 -10q27 0 50 9.5t30 13.5l6 -55q-13 -9 -46.5 -20 t-73.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 213,
    d: "M-110 -181q-32 0 -57.5 9t-42.5 30l42 46q11 -14 28.5 -19t35.5 -5q16 0 33.5 7t32.5 19.5t26 29.5t15 37l116 548h68l-116 -544q-7 -35 -25.5 -64t-43.5 -50t-54.5 -32.5t-57.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 561,
    d: "M210 -10q-47 0 -83.5 15.5t-62 43.5t-39 65.5t-13.5 81.5q0 20 3 44t11 44h420q3 18 3 35q0 35 -10.5 64t-29 50t-44.5 32.5t-57 11.5q-24 0 -49 -7t-47.5 -19t-41.5 -29t-32 -38l-55 16q17 28 43 52t57.5 41t67 27t71.5 10q46 0 82.5 -17t62 -47t39 -70t13.5 -86 q0 -63 -25 -121t-67.5 -102.5t-98.5 -70.5t-118 -26zM222 42q36 0 70 14.5t62.5 41t50.5 62t33 77.5h-357q-3 -20 -3 -37q0 -71 39.5 -114.5t104.5 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 536,
    d: "M282 637l48 59l6 34h93l-106 -110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 316,
    d: "M57 645l113 85h50l75 -85l-42 -21l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 316,
    d: "M67 710l43 20l67 -63l94 63l34 -20l-112 -86h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 378,
    d: "M82 709h275l-10 -47h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 270,
    d: "M143 664q20 0 40 19t29 47h40q-5 -21 -16 -39.5t-26.5 -32t-34.5 -21.5t-39 -8q-35 0 -56 22t-21 56q0 11 3 23h42q-2 -10 -2 -15q0 -21 11.5 -36t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 156,
    d: "M51 633l21 97h62l-21 -97h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 236,
    d: "M66 652q0 35 26 56.5t61 21.5q27 0 42.5 -14.5t15.5 -38.5q0 -34 -25 -56t-62 -22q-27 0 -42.5 14.5t-15.5 38.5zM147 703q-18 0 -33 -13t-15 -33q0 -13 8.5 -22t22.5 -9q17 0 33 13t16 33q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 230,
    d: "M89 -175q-30 7 -45 23t-15 38q0 32 29 62.5t95 68.5l19 -17q-55 -32 -77 -55t-22 -46q0 -30 42 -36l-26 -38v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 387,
    d: "M256 638q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 312,
    d: "M75 620l-33 17l73 93h63zM196 620l-32 17l73 93h62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 312,
    d: "M183 730h61l35 -93l-41 -17zM61 730h63l34 -93l-41 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 270,
    d: "M57 629q4 21 15 39.5t26.5 32t34.5 21.5t39 8q35 0 55.5 -23.5t20.5 -56.5v-10.5t-2 -10.5h-40q1 6 1.5 11t0.5 10q0 45 -41 45q-30 0 -46.5 -19.5t-23.5 -46.5h-40v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 622,
    d: "M-20 53l273 657h57l271 -657v-53h-601v53zM505 62l-223 566l-225 -566h448z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 807,
    d: "M55 62h190q-85 45 -133.5 125t-48.5 178q0 69 25 132.5t68.5 111.5t103.5 77t131 29q70 0 130 -29t103.5 -77t68.5 -111.5t25 -132.5q0 -98 -48.5 -178t-133.5 -125h191v-62h-289v62q49 14 88 45t66 72.5t41.5 89.5t14.5 96q0 53 -18 104.5t-51.5 92t-81 65t-106.5 24.5 q-60 0 -107.5 -24.5t-81 -65t-51.5 -92t-18 -104.5q0 -48 14.5 -96t41.5 -89.5t66 -72.5t89 -45v-62h-289v62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 576,
    d: "M120 521h68l-63 -294q-5 -23 -7.5 -42t-2.5 -36q0 -99 87 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-92 -433q-2 -8 -2 -11q0 -17 20 -17l-14 -60q-30 0 -50.5 8.5t-20.5 31.5q0 5 3.5 28t10.5 50q-18 -27 -43 -50t-53.5 -40.5t-59 -27.5t-59.5 -10q-45 0 -68.5 23.5 t-28.5 61.5l-57 -287h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 671,
    d: "M501 -6q-45 0 -72 26.5t-27 74.5v364h-200v-459h-66v459h-80v62h522v-62h-110v-341q0 -29 16 -45.5t45 -16.5q11 0 26 3t28 8l12 -55q-19 -8 -46.5 -13t-47.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 690,
    d: "M196 -166l20 98h62l-20 -98h-62zM175 710h230q66 0 115 -21t81 -58t47.5 -86.5t15.5 -106.5q0 -94 -31 -174.5t-86 -139t-130 -91.5t-163 -33h-230zM267 62q75 0 135.5 30t102.5 80.5t64.5 116.5t22.5 138q0 48 -12.5 89t-38 70t-63 45.5t-87.5 16.5h-160l-125 -586h161z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    d: "M166 -166l20 98h62l-20 -98h-62zM211 -10q-44 0 -78.5 17.5t-58.5 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92.5 72t109.5 27q62 0 103 -34.5t58 -83.5l68 318h68l-136 -641q-2 -10 -2 -12q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-24 0 -36.5 11.5 t-12.5 28.5q0 7 2 19.5t9 43.5q-40 -51 -96.5 -81t-110.5 -30zM239 50q24 0 52.5 10t55.5 27.5t48.5 41t31.5 50.5l33 161q-3 27 -16 50.5t-32 41.5t-43 28t-49 10q-45 0 -86 -22.5t-71.5 -58t-48.5 -80.5t-18 -90q0 -35 10 -65.5t29 -53.5t45 -36.5t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 709,
    d: "M175 710h69l-67 -316h395l67 316h70l-151 -710h-70l71 332h-395l-71 -332h-69zM226 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 559,
    d: "M164 730h68l-70 -327q42 59 101.5 93t120.5 34q64 0 91.5 -35.5t27.5 -97.5q0 -39 -11 -92l-64 -305h-68l62 291q9 43 9 76q0 101 -85 101q-27 0 -56 -11.5t-56.5 -31.5t-51 -47t-38.5 -59l-67 -319h-68zM151 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 740,
    d: "M450 820l21 97h62l-21 -97h-62zM175 710h54l316 -591l125 590h69l-151 -709h-59l-313 580l-123 -580h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 559,
    d: "M311 633l21 97h62l-21 -97h-62zM119 521h63l-26 -118q21 28 48.5 51.5t58 40.5t63.5 26t66 9q61 0 87 -33t26 -91q0 -23 -3.5 -47.5t-9.5 -53.5l-64 -305h-68l62 291q10 49 10 85q0 92 -78 92q-28 0 -58.5 -11t-59 -31t-52.5 -47.5t-40 -59.5l-67 -319h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 628,
    d: "M24 0l151 710h285q37 0 67 -15.5t50 -41.5t31 -59.5t11 -68.5q0 -43 -16 -84.5t-43 -75.5t-63.5 -58.5t-77.5 -32.5l107 -274h-79l-102 262h-196l-56 -262h-69zM381 324q34 0 64.5 17t53 44.5t35.5 62t13 69.5q0 27 -7.5 50.5t-21 41.5t-33 28.5t-42.5 10.5h-212 l-69 -324h219zM187 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 343,
    d: "M119 521h64l-27 -125q39 57 88.5 90.5t100.5 35.5q8 0 13.5 -0.5t10.5 -1.5l-13 -59q-65 -2 -121 -38t-90 -99l-68 -324h-68zM-22 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 585,
    d: "M241 -6q-159 0 -250 103l47 57q27 -41 83.5 -69.5t134.5 -28.5q91 0 144 37.5t53 108.5q0 26 -11.5 44.5t-34 33t-54.5 25t-74 21.5q-43 11 -76.5 23.5t-56.5 29.5t-35 40.5t-12 55.5q0 56 22.5 100.5t61.5 75.5t91.5 47.5t113.5 16.5q67 0 116.5 -21.5t82.5 -60.5 l-45 -56q-20 34 -64 55t-104 21q-52 0 -89.5 -12t-62 -33t-36 -49.5t-11.5 -61.5q0 -24 10 -41t30 -29.5t50 -22t70 -19.5q44 -11 80 -23.5t61.5 -31t39.5 -44.5t14 -63q0 -57 -22.5 -100t-61.5 -71.5t-91.5 -43t-113.5 -14.5zM173 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 468,
    d: "M172 -10q-58 0 -109 20t-83 58l40 46q67 -72 162 -72q66 0 108.5 30.5t42.5 81.5q0 18 -8 30t-24 21.5t-40 17.5t-55 16q-36 10 -62.5 19.5t-44 21.5t-26.5 28.5t-9 39.5q0 43 18.5 77t49 57.5t71 35.5t84.5 12q57 0 99 -19.5t65 -51.5l-42 -40q-21 30 -57.5 45t-78.5 15 q-28 0 -54 -7t-45.5 -21t-31 -35t-11.5 -50q0 -32 25.5 -45.5t79.5 -27.5q81 -20 123.5 -45.5t42.5 -77.5q0 -39 -17 -72t-47.5 -57t-73 -37.5t-92.5 -13.5zM106 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 582,
    d: "M159 -166l20 98h62l-20 -98h-62zM328 648h-238l13 62h547l-13 -62h-239l-138 -648h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 321,
    d: "M65 -166l20 98h62l-20 -98h-62zM135 -6q-38 0 -62.5 18.5t-24.5 56.5q0 11 3 25l79 373h-69l12 54h68l38 176h68l-38 -176h114l-12 -54h-113l-72 -339q-2 -11 -3.5 -17t-1.5 -11q0 -23 14 -33t34 -10q27 0 50 9.5t30 13.5l6 -55q-13 -9 -46.5 -20t-73.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 997,
    d: "M95 710h75l108 -629l195 321l-53 303h66l40 -252l149 252h66l-182 -303l59 -321l374 629h77l-437 -710h-60l-66 351l-216 -351h-61zM528 917h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 755,
    d: "M53 521h70l84 -458q40 48 74 97.5t63 100.5l-60 260h70l38 -173q22 45 38.5 88t28.5 85h65q-19 -65 -47 -129.5t-65 -129.5l43 -199q88 112 149.5 229t92.5 229h66q-77 -263 -287 -521h-73l-40 184q-29 -47 -62.5 -93t-72.5 -91h-73zM373 730h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 997,
    d: "M589 807l-42 17l76 93h71zM95 710h75l108 -629l195 321l-53 303h66l40 -252l149 252h66l-182 -303l59 -321l374 629h77l-437 -710h-60l-66 351l-216 -351h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 755,
    d: "M423 620l-42 17l76 93h71zM53 521h70l84 -458q40 48 74 97.5t63 100.5l-60 260h70l38 -173q22 45 38.5 88t28.5 85h65q-19 -65 -47 -129.5t-65 -129.5l43 -199q88 112 149.5 229t92.5 229h66q-77 -263 -287 -521h-73l-40 184q-29 -47 -62.5 -93t-72.5 -91h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 997,
    d: "M493 820l21 94h58l-21 -94h-58zM637 820l20 94h57l-19 -94h-58zM95 710h75l108 -629l195 321l-53 303h66l40 -252l149 252h66l-182 -303l59 -321l374 629h77l-437 -710h-60l-66 351l-216 -351h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 755,
    d: "M324 633l21 94h58l-21 -94h-58zM468 633l20 94h57l-19 -94h-58zM53 521h70l84 -458q40 48 74 97.5t63 100.5l-60 260h70l38 -173q22 45 38.5 88t28.5 85h65q-19 -65 -47 -129.5t-65 -129.5l43 -199q88 112 149.5 229t92.5 229h66q-77 -263 -287 -521h-73l-40 184 q-29 -47 -62.5 -93t-72.5 -91h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 596,
    d: "M-24 55l580 593h-446l13 62h528l-12 -55l-574 -593h447l-13 -62h-535zM173 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 466,
    d: "M-26 46l419 424h-321l11 51h397l-9 -46l-417 -424h327l-12 -51h-404zM103 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 582,
    d: "M175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454zM183 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 534,
    d: "M226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7 t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5zM162 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 582,
    d: "M175 710h445l-13 -62h-376l-55 -256h328l-12 -59h-328l-58 -271h385l-13 -62h-454zM474 825q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5 t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 534,
    d: "M226 -10q-48 0 -85.5 17t-63 47t-39 70t-13.5 86q0 62 24 119.5t66 102t99.5 71.5t124.5 27q34 0 64.5 -9t53 -26.5t35.5 -44t13 -60.5q0 -77 -68 -116t-210 -39q-28 0 -60.5 1t-70.5 4q-1 -8 -1.5 -15t-0.5 -14q0 -34 9 -64.5t27 -54t45 -37t63 -13.5q24 0 49 7 t47.5 19.5t41.5 30.5t32 40l56 -17q-18 -29 -44 -53.5t-57.5 -42t-66 -27t-70.5 -9.5zM332 477q-45 0 -82 -16t-66 -42t-49 -60t-30 -70q36 -2 66.5 -3.5t58.5 -1.5q59 0 100 8t66 22t36 34t11 43q0 45 -33 65.5t-78 20.5zM411 638q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5 t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 245,
    d: "M175 709h69l-151 -709h-69zM-9 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 213,
    d: "M119 521h68l-110 -521h-68zM164 730h68l-21 -100h-68zM-24 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 722,
    d: "M236 -166l20 98h62l-20 -98h-62zM296 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t129 96t150.5 36q60 0 106 -25t77.5 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-89.5 -136t-128.5 -95.5t-150.5 -36zM310 58q66 0 123.5 32t101 83.5 t68.5 115t25 126.5q0 47 -13 90t-37.5 75.5t-60.5 51.5t-81 19q-66 0 -124 -32t-101.5 -83t-68.5 -114.5t-25 -127.5q0 -47 12.5 -90t37.5 -75.5t60.5 -51.5t82.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 573,
    d: "M158 -166l20 98h62l-20 -98h-62zM220 -10q-46 0 -82.5 17.5t-61.5 47t-38.5 69t-13.5 84.5q0 63 25.5 121t68.5 102.5t99 71.5t118 27q46 0 82 -17.5t61.5 -47t39 -69.5t13.5 -85q0 -62 -25.5 -120t-68 -102.5t-99 -71.5t-118.5 -27zM233 50q42 0 83 20.5t73 55t52 80 t20 96.5q0 35 -10 66t-28.5 53.5t-44 35.5t-56.5 13q-42 0 -82.5 -20.5t-73 -55.5t-52.5 -81t-20 -97q0 -35 10 -65.5t28.5 -53t44 -35t56.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 724,
    d: "M298 -5q-62 0 -105 18.5t-69 50.5t-37.5 74.5t-11.5 91.5q0 57 14 122l76 358h69l-76 -358q-6 -29 -9.5 -56.5t-3.5 -53.5q0 -39 8.5 -72.5t28 -58t51 -39t77.5 -14.5q63 0 110.5 25.5t81 67t54.5 94.5t32 107l76 358h69l-75 -358q-15 -72 -44 -137t-73.5 -113.5 t-104.5 -77.5t-138 -29zM229 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 569,
    d: "M159 -10q-122 0 -122 134q0 20 2.5 42.5t8.5 48.5l66 306h67l-62 -294q-10 -44 -10 -78q0 -99 86 -99q28 0 57 10t56 29t51 45t42 59l70 328h68l-91 -425q-3 -12 -3 -19q0 -17 19 -17l-13 -60q-8 -1 -13.5 -1.5t-10.5 -0.5q-23 0 -35 10.5t-12 28.5q0 3 0.5 8t2 14t4 23 t7.5 36q-46 -61 -108 -94.5t-127 -33.5zM143 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 607,
    d: "M257 266l-166 444h77l137 -382l300 382h76l-356 -446l-56 -264h-69zM339 917h70l38 -93l-49 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 489,
    d: "M-36 -169q31 5 53.5 12t40 20t33 32t34.5 48l33 49l-107 529h71l84 -458l41 67q43 70 73 123t51.5 97.5t36 85t26.5 85.5h67q-14 -48 -29 -89.5t-37.5 -88t-56 -104t-83.5 -136.5l-81 -129q-35 -55 -63.5 -92t-56 -60t-56.5 -33.5t-65 -12.5zM230 730h70l38 -93l-49 -17z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 607,
    d: "M257 266l-166 444h77l137 -382l300 382h76l-356 -446l-56 -264h-69zM454 825q-21 0 -35.5 6t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16 t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 489,
    d: "M-36 -169q31 5 53.5 12t40 20t33 32t34.5 48l33 49l-107 529h71l84 -458l41 67q43 70 73 123t51.5 97.5t36 85t26.5 85.5h67q-14 -48 -29 -89.5t-37.5 -88t-56 -104t-83.5 -136.5l-81 -129q-35 -55 -63.5 -92t-56 -60t-56.5 -33.5t-65 -12.5zM352 638q-21 0 -35.5 6 t-26.5 13.5t-24 14t-27 6.5t-26 -7t-17.5 -15.5t-10 -16t-3.5 -9.5h-42q1 5 8 20.5t20 31.5t33 28.5t47 12.5q20 0 33.5 -6.5t25.5 -14.5t24 -14.5t30 -6.5t30.5 7t19.5 16t10.5 16.5t3.5 9.5h42q-1 -5 -8 -20t-21 -31t-35 -28.5t-51 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 551
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 871
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 548,
    d: "M51 241l13 63h420l-13 -63h-420z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 862,
    d: "M51 241l13 63h734l-13 -63h-734z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 193,
    d: "M213 730l-39 -106h23l-21 -103h-67l22 103l47 106h35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 188,
    d: "M114 521l39 106h-23l21 103h67l-22 -103l-47 -106h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 225,
    d: "M1 -104l38 104h-24l22 102h67l-22 -102l-46 -104h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 308,
    d: "M213 730l-39 -106h23l-21 -103h-67l22 103l47 106h35zM327 730l-38 -106h23l-21 -103h-67l21 103l48 106h34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 303,
    d: "M115 521l38 107h-23l22 102h67l-22 -102l-47 -107h-35zM230 521l38 107h-23l21 102h67l-21 -102l-47 -107h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 341,
    d: "M1 -104l38 104h-24l22 102h67l-22 -102l-46 -104h-35zM116 -104l38 104h-23l22 102h67l-23 -102l-46 -104h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 395,
    d: "M74 -130l78 370h-125l13 62h125l101 473h65l-101 -473h125l-13 -62h-125l-78 -370h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 396,
    d: "M75 -130l61 289h-125l13 63h125l24 110h-125l13 63h125l81 380h65l-81 -380h125l-14 -63h-124l-24 -110h125l-13 -63h-125l-61 -289h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 341,
    d: "M266 361q0 -21 -9 -40t-24 -33.5t-34.5 -23t-39.5 -8.5q-30 0 -49 21t-19 53q0 21 9 40t24 33.5t34 23t39 8.5q32 0 50.5 -21.5t18.5 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 449,
    d: "M2 0l21 98h58l-21 -98h-58zM133 0l21 98h57l-21 -98h-57zM263 0l21 98h58l-21 -98h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1023,
    d: "M219 433q-54 0 -85.5 34t-31.5 83q0 34 15 65t40 54.5t56 37t64 13.5q54 0 85.5 -34t31.5 -84q0 -34 -15 -64.5t-40 -54t-56 -37t-64 -13.5zM228 472q21 0 41.5 10.5t36.5 28t26 40t10 46.5q0 35 -20.5 59t-53.5 24q-21 0 -41.5 -10.5t-36.5 -27.5t-26 -40t-10 -47 q0 -34 20.5 -58.5t53.5 -24.5zM447 -10q-54 0 -86 34t-32 84q0 34 15 64.5t40 54t56 37t64 13.5q54 0 85.5 -34t31.5 -84q0 -34 -15 -64.5t-39.5 -54t-55.5 -37t-64 -13.5zM454 30q21 0 42 10.5t37.5 27.5t26.5 39.5t10 46.5q0 35 -20.5 59.5t-53.5 24.5q-21 0 -42 -10.5 t-37.5 -28t-26.5 -40t-10 -46.5q0 -35 20.5 -59t53.5 -24zM783 -10q-54 0 -85.5 34t-31.5 84q0 34 15 64.5t40 54t56 37t64 13.5q54 0 85 -34t31 -84q0 -34 -15 -64.5t-39.5 -54t-55.5 -37t-64 -13.5zM791 30q21 0 42 10.5t37 27.5t26 39.5t10 46.5q0 35 -20.5 59.5 t-53.5 24.5q-21 0 -42 -10.5t-37 -28t-26 -40t-10 -46.5q0 -35 20 -59t54 -24zM13 27l669 687l28 -30l-669 -688z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 339,
    d: "M36 276l274 178l-12 -59l-210 -136l152 -134l-13 -59l-199 173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 339,
    d: "M285 239l-274 -173l13 59l210 134l-152 136l12 59l198 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 154,
    d: "M-260 27l669 687l28 -30l-669 -688z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 441,
    d: "M244 406q-38 0 -65.5 15t-45.5 38.5t-26.5 53t-8.5 59.5q0 41 18 83t49.5 76.5t73.5 56.5t90 22q38 0 65 -15t44.5 -39t26 -53.5t8.5 -58.5q0 -41 -17.5 -83.5t-48.5 -77t-73 -56t-90 -21.5zM145 577q0 -23 6.5 -46t20 -41t33.5 -29t48 -11q40 0 72 18.5t55 46.5t35.5 61 t12.5 62q0 24 -7 47t-20.5 41t-33.5 29t-47 11q-40 0 -72 -18.5t-55 -47t-35.5 -61.5t-12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 371,
    d: "M265 411l22 103h-216l9 42l283 254h31l-54 -253h56l-10 -43h-55l-21 -103h-45zM128 557h170l40 192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 363,
    d: "M260 665q54 0 88 -29t34 -76q0 -34 -15.5 -62t-41.5 -48.5t-59.5 -32t-70.5 -11.5q-47 0 -80.5 20t-44.5 55l35 25q11 -26 37.5 -42t64.5 -16q25 0 48.5 8t41 22t28 33.5t10.5 43.5q0 36 -26.5 55t-59.5 19q-29 0 -58.5 -13t-48.5 -34h-41q7 18 22 51.5t30 69t28 65.5 t18 42h214l-10 -44h-180l-58 -131q41 30 95 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 393,
    d: "M414 561q0 -32 -16 -61t-42 -51t-61 -34.5t-72 -12.5q-59 0 -93 35t-34 97q0 58 16 108t45 87.5t69.5 59t89.5 21.5q43 0 74 -18.5t42 -52.5l-34 -29q-7 26 -32 42t-60 16q-54 0 -96 -41.5t-59 -117.5q20 30 58 47.5t76 17.5q58 0 93.5 -32.5t35.5 -80.5zM234 443 q26 0 50.5 9t43.5 24t30.5 35t11.5 42q0 35 -27 58.5t-69 23.5q-26 0 -50.5 -9t-43.5 -24t-30.5 -34.5t-11.5 -40.5q0 -35 27 -59.5t69 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 342,
    d: "M360 766h-237l9 44h307l-309 -399h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 383,
    d: "M394 538q0 -29 -15.5 -53t-41 -41.5t-58.5 -27.5t-67 -10q-60 0 -94.5 30t-34.5 72q0 23 9.5 41.5t25.5 33t36 25t40 17.5q-23 9 -39.5 27t-16.5 44t15 47t38 36t52 23t56 8q23 0 44.5 -6t38 -17.5t26.5 -27.5t10 -36q0 -37 -27.5 -61.5t-65.5 -36.5q30 -11 49.5 -33 t19.5 -54zM349 537q0 16 -8 28.5t-21 21.5t-30 13.5t-34 4.5q-23 0 -45.5 -6.5t-40.5 -18t-29.5 -28t-11.5 -35.5q0 -16 8 -28.5t21.5 -21t30.5 -13t35 -4.5q22 0 44 6.5t40 17.5t29.5 27t11.5 36zM182 697q0 -13 7 -23.5t18.5 -17.5t26 -10.5t29.5 -3.5q18 0 37 5t35 14 t26.5 22t10.5 30q0 26 -25 40t-57 14q-20 0 -39.5 -5t-34.5 -14t-24.5 -22t-9.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 393,
    d: "M109 651q0 32 15.5 61t42 50.5t60.5 34.5t71 13q60 0 94 -35t34 -97q0 -58 -16 -108t-45 -87.5t-69.5 -59t-89.5 -21.5q-42 0 -73 19t-42 53l33 28q8 -26 33 -42t60 -16q54 0 95.5 41.5t58.5 117.5q-20 -29 -58 -47.5t-76 -18.5q-29 0 -52.5 9t-40 24t-26 36t-9.5 45z M289 769q-26 0 -50.5 -9t-43.5 -24t-30.5 -35t-11.5 -42q0 -34 27 -58t69 -24q25 0 49.5 9t43.5 24t30.5 34.5t11.5 40.5q0 35 -26.5 59.5t-68.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 441,
    d: "M140 -85q-39 0 -66.5 15t-45 38.5t-26 53t-8.5 59.5q0 41 18 83t49.5 76.5t73.5 56.5t90 22q38 0 65 -15t44.5 -39t26 -53.5t8.5 -58.5q0 -41 -18 -83.5t-48.5 -77t-72.5 -56t-90 -21.5zM40 86q0 -23 6.5 -46t20 -41t34 -29t48.5 -11q39 0 71.5 18.5t55 47t35 61 t12.5 61.5q0 24 -6.5 47t-20 41t-34 29t-47.5 11q-39 0 -71.5 -18.5t-55.5 -47t-35.5 -61.5t-12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 276,
    d: "M185 -36l-9 -44h-209l9 44h85l66 309q-7 -7 -20 -15t-29 -15.5t-32 -12.5t-29 -5l10 44q16 0 35.5 8.5t36 18.5t27.5 19t11 10h46l-77 -361h79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 377,
    d: "M-44 -80q8 39 21.5 67.5t33 50.5t45.5 38t59 28q26 9 53 18t49.5 21.5t36.5 30.5t14 45q0 26 -19.5 44t-61.5 18q-24 0 -44.5 -5.5t-37 -14t-29.5 -18.5t-22 -18l-22 32q5 5 19 16t35.5 22.5t51 20t64.5 8.5q60 0 88.5 -27t28.5 -69q0 -31 -12 -53.5t-33 -39.5t-51 -30 t-66 -25q-34 -11 -56 -25.5t-36 -30t-21 -31.5t-10 -29h231l-9 -44h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 375,
    d: "M99 -85q-26 0 -49.5 5.5t-41 16.5t-27.5 27.5t-10 39.5l32 28q0 -13 7 -26t20 -23.5t32.5 -17t45.5 -6.5q25 0 48 6t40.5 16.5t27.5 25t10 32.5q0 32 -33.5 49t-92.5 17h-22l9 40h21q66 0 105.5 19.5t39.5 57.5q0 28 -25.5 44.5t-61.5 16.5q-39 0 -70.5 -15.5 t-51.5 -40.5l-23 34q24 29 66 46t87 17q58 0 92.5 -26.5t34.5 -67.5q0 -40 -27.5 -66.5t-80.5 -37.5q38 -6 58.5 -29.5t20.5 -55.5q0 -30 -15.5 -53t-41 -39.5t-58 -25t-66.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 370,
    d: "M160 -80l22 103h-217l9 42l284 254h31l-54 -252h56l-10 -44h-55l-22 -103h-44zM23 67h170l40 191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 363,
    d: "M157 174q54 0 87.5 -29t33.5 -76q0 -34 -15.5 -62t-41 -48.5t-59.5 -32t-70 -11.5q-47 0 -80.5 20.5t-45.5 53.5l35 26q12 -26 38.5 -42t64.5 -16q25 0 48 8t41 22t28.5 33.5t10.5 43.5q0 36 -27 55t-60 19q-29 0 -58 -13t-49 -34h-41q7 18 22 51.5t30.5 69t28.5 65.5 t18 42h213l-10 -44h-179l-59 -130q40 29 96 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 392,
    d: "M309 73q0 -32 -15.5 -60.5t-42 -50.5t-60.5 -34.5t-71 -12.5q-59 0 -93 35t-34 97q0 58 16 108t45 87t69.5 58.5t89.5 21.5q42 0 73 -18.5t42 -52.5l-33 -29q-8 26 -33 42t-59 16q-55 0 -96.5 -41t-58.5 -118q20 30 58 48t76 18q58 0 92.5 -33t34.5 -81zM131 -44 q25 0 49.5 9t43.5 24t30.5 34.5t11.5 41.5q0 35 -26.5 59t-68.5 24q-26 0 -51 -9t-44 -24t-30.5 -34.5t-11.5 -41.5q0 -35 27.5 -59t69.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 341,
    d: "M256 275h-237l9 44h307l-309 -399h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 384,
    d: "M290 47q0 -29 -15.5 -53t-41 -41.5t-58.5 -27.5t-67 -10q-60 0 -94.5 30t-34.5 72q0 23 9.5 41.5t25.5 33.5t36 25.5t40 16.5q-23 9 -39.5 27t-16.5 44t15 47t38 36t52 23t56 8q23 0 44.5 -6t38.5 -17.5t27 -27.5t10 -36q0 -37 -28 -61.5t-66 -36.5q31 -11 50 -33t19 -54 zM245 46q0 16 -8 28.5t-21.5 21.5t-30 13.5t-34.5 4.5q-22 0 -44.5 -6.5t-40.5 -18t-29.5 -28t-11.5 -36.5q0 -15 8 -27.5t21.5 -21t30.5 -13t35 -4.5q22 0 44 6.5t40 17.5t29.5 27t11.5 36zM79 205q0 -26 25.5 -40t55.5 -14q18 0 37 5t34.5 14t26 22t10.5 30 q0 26 -24.5 40.5t-57.5 14.5q-20 0 -39.5 -5t-34.5 -14.5t-24 -23t-9 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 394,
    d: "M6 163q0 33 15.5 61.5t42 50.5t60.5 34.5t71 12.5q60 0 94 -35t34 -97q0 -57 -16 -107.5t-45 -87.5t-69.5 -58.5t-89.5 -21.5q-43 0 -74 18.5t-42 52.5l34 29q8 -26 32.5 -42t59.5 -16q54 0 96 41.5t59 116.5q-21 -29 -58.5 -47t-76.5 -18q-58 0 -92.5 32.5t-34.5 80.5z M185 281q-26 0 -50.5 -9t-43 -24t-30 -35t-11.5 -41q0 -35 26.5 -58.5t68.5 -23.5q26 0 50.5 9t43 24t30 34.5t11.5 40.5q0 34 -26.5 58.5t-68.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 530,
    d: "M156 1q-62 23 -96 79.5t-34 129.5q0 54 18.5 104.5t50.5 92t76 71.5t95 43l27 124h36l-25 -117q8 1 16.5 1.5t17.5 0.5q7 0 13.5 -0.5t12.5 -1.5l25 117h37l-26 -123q45 -13 74.5 -42.5t40.5 -73.5l-71 -21q-12 40 -44 62.5t-77 22.5q-43 0 -84 -20t-72.5 -54t-51 -80 t-19.5 -97q0 -36 10 -66.5t28.5 -53.5t44 -36t56.5 -13q23 0 47.5 7t46.5 19.5t40 28.5t27 34l62 -20q-26 -45 -71 -76.5t-100 -44.5l-24 -118h-37l24 112q-7 -1 -13.5 -1.5t-12.5 -0.5q-18 0 -34 3l-24 -113h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 591,
    d: "M53 0l28 134h-86l11 54h87l111 522h443l-13 -62h-374l-55 -261h315l-12 -58h-316l-30 -141h126l-11 -54h-127l-28 -134h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 468,
    d: "M69 393h78q-8 31 -16 60.5t-8 60.5q0 41 18 77.5t48 64t68.5 43.5t78.5 16q53 0 92.5 -28t58.5 -77l-48 -42q-14 42 -46 66t-70 24q-26 0 -51 -11t-44 -30.5t-30.5 -45.5t-11.5 -55q0 -30 9 -60.5t17 -62.5h178l-9 -43h-159q2 -12 3 -24t1 -25v-12h147l-9 -42h-143 q-4 -20 -13.5 -40.5t-26 -43.5t-41 -49.5t-60.5 -59.5q36 9 71 9q20 0 36.5 -3t31.5 -6t30.5 -6t32.5 -3q18 0 39 4.5t49 13.5l6 -52q-55 -26 -110 -26q-21 0 -39.5 3.5t-36.5 8t-37 8.5t-41 4q-23 0 -52 -4.5t-55 -12.5l-8 50q40 35 69 62.5t48 51.5t29.5 46t15.5 45h-110 l9 42h106v5q0 14 -2 28l-4 28h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 806,
    d: "M783 376h-81l-14 -62h83l-9 -43h-83l-57 -271h-60l-146 271h-232l-57 -271h-70l57 271h-83l9 43h83l13 62h-82l9 43h82l63 291h54l155 -291h224l62 290h70l-62 -290h81zM193 314h200l-34 62h-153zM473 314h146l13 62h-192zM215 419h121l-86 161zM578 119l32 152h-114z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1063,
    d: "M51 361h146l-13 69h-118l9 42h101l-44 238h75l40 -238h249l-41 233h67l41 -252l148 252h66l-140 -233h250l142 238h75l-146 -238h102l-9 -42h-119l-42 -69h146l-9 -43h-164l-194 -318h-62l-65 351l-216 -351h-61l-60 318h-163zM654 81l141 237h-185zM314 81l144 237h-184 zM602 361h219l41 69h-250l-17 -28zM504 430h-250l12 -69h218l25 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 763,
    d: "M155 416q19 58 55.5 112t86 95t111 66t131.5 25q91 0 145.5 -43t71.5 -112l-63 -34q-9 35 -26.5 59t-40.5 39t-50 21.5t-54 6.5q-53 0 -99.5 -19.5t-84.5 -51.5t-66.5 -75t-45.5 -89h321l-27 -43h-307q-7 -31 -9 -62h286l-27 -43h-258q4 -44 19 -82.5t39.5 -67t58.5 -45 t76 -16.5q28 0 59.5 7.5t62.5 24t60 41t53 59.5l51 -30q-25 -40 -60.5 -70.5t-76.5 -51.5t-84 -32t-82 -11q-56 0 -100 22.5t-75.5 60.5t-49.5 87.5t-21 103.5h-109l28 43h80q2 31 9 62h-68l27 43h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 453,
    d: "M468 556h-95q1 -8 1.5 -15.5t0.5 -15.5q0 -43 -16 -84.5t-43 -75.5t-63.5 -58.5t-78.5 -32.5l108 -274h-79l-128 324h61q34 0 64.5 17t53.5 44.5t36 62t13 69.5q0 17 -5 39h-205l9 42h180q-14 23 -35 36.5t-47 13.5h-88l14 62h375l-9 -43h-172q28 -28 42 -69h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 333,
    d: "M174 -6q-48 0 -74.5 26.5t-26.5 77.5v512q0 28 9 51.5t25 41t37.5 27.5t46.5 10q50 0 80.5 -36t30.5 -94q0 -39 -14 -87t-37.5 -96t-53.5 -92.5t-63 -75.5v-141q0 -29 18 -46t49 -17q12 0 27 4t29 9l12 -55q-20 -8 -46.5 -13.5t-48.5 -5.5zM246 604q0 39 -14 60t-40 21 t-42 -20.5t-16 -54.5v-278q22 27 42 62.5t35.5 73t25 73t9.5 63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1090,
    d: "M216 580l-123 -580h-70l151 710h54l316 -591l125 590h70l-151 -709h-60zM907 348q-33 0 -58.5 12t-43.5 32t-27 46.5t-9 56.5q0 42 17 81.5t46.5 69.5t68.5 48t83 18q32 0 57.5 -11.5t43.5 -31.5t27.5 -47t9.5 -58q0 -42 -17 -81t-46.5 -69t-68.5 -48t-83 -18zM827 502 q0 -45 24.5 -75.5t65.5 -30.5q27 0 53.5 13t47.5 35t33.5 51.5t12.5 61.5q0 45 -25 75.5t-65 30.5q-28 0 -54.5 -13t-47 -35t-33 -51t-12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 688,
    d: "M638 710h67l-61 -286h-47l46 217l-116 -175h-39l-42 175l-46 -217h-48l61 286h66l40 -187zM315 641q-8 14 -26.5 22.5t-43.5 8.5q-34 0 -50 -12t-16 -32q0 -23 61 -38q37 -10 60 -25.5t23 -48.5q0 -49 -37 -72.5t-91 -23.5q-68 0 -109 43l30 36q12 -15 35 -25.5t54 -10.5 t48.5 10t17.5 31q0 16 -15 24.5t-46 17.5q-36 10 -58.5 24.5t-22.5 44.5q0 24 10 42.5t27 31t40 19.5t49 7q56 0 89 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 699,
    d: "M363 664h-90l-51 -240h-48l50 240h-90l11 48h228zM416 710h67l39 -187l120 187h67l-61 -286h-48l46 217l-116 -175h-39l-42 175l-46 -217h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 807,
    d: "M55 62h190q-85 45 -133.5 125t-48.5 178q0 69 25 132.5t68.5 111.5t103.5 77t131 29q70 0 130 -29t103.5 -77t68.5 -111.5t25 -132.5q0 -98 -48.5 -178t-133.5 -125h191v-62h-289v62q49 14 88 45t66 72.5t41.5 89.5t14.5 96q0 53 -18 104.5t-51.5 92t-81 65t-106.5 24.5 q-60 0 -107.5 -24.5t-81 -65t-51.5 -92t-18 -104.5q0 -48 14.5 -96t41.5 -89.5t66 -72.5t89 -45v-62h-289v62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 610,
    d: "M302 22q69 0 116.5 22t76.5 53l22 -24q-35 -35 -87.5 -59t-127.5 -24q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59.5t54 -87.5t19.5 -107h-431v-150q30 -38 73 -60.5t94 -22.5zM302 499q-51 0 -94 -23t-73 -62v-125 h335v124q-31 40 -74.5 63t-93.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 820,
    d: "M39 27l669 687l28 -30l-669 -688zM266 371l-10 -45h-193l10 45h77l65 309q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l10 45q15 0 32.5 8t33 18t26 19t10.5 10h45l-77 -360h72zM563 -5q-26 0 -49.5 5.5t-41 17t-27.5 28t-10 38.5l32 28q0 -12 7 -25t20 -23.5 t32.5 -17.5t45.5 -7q25 0 48 6t40.5 16.5t27.5 25t10 32.5q0 32 -33 49t-93 17h-22l9 40h21q66 0 105.5 19.5t39.5 57.5q0 28 -25.5 44.5t-61.5 16.5q-39 0 -70.5 -15.5t-51.5 -40.5l-23 34q24 29 66 46t87 17q58 0 92.5 -26.5t34.5 -67.5q0 -40 -27.5 -66.5t-80.5 -37.5 q38 -6 58.5 -29.5t20.5 -55.5q0 -30 -15.5 -53t-41 -39.5t-58 -25t-66.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 835,
    d: "M47 327q8 39 21 67.5t32 50t44.5 37.5t57.5 28q25 10 52 19t48.5 21.5t35.5 30.5t14 45q0 26 -19.5 43.5t-60.5 17.5q-23 0 -42.5 -5.5t-36 -14t-29 -18t-20.5 -17.5l-23 31q5 5 18.5 16.5t35 23t50 20t62.5 8.5q59 0 86.5 -27t27.5 -69q0 -31 -11.5 -53.5t-32.5 -40 t-50 -30t-64 -24.5q-33 -11 -55 -25.5t-35.5 -30t-20 -31.5t-9.5 -30h220l-8 -43h-288zM91 27l669 687l28 -30l-669 -688zM577 -5q-26 0 -49.5 5.5t-41 17t-27.5 28t-10 38.5l32 28q0 -12 7 -25t20 -23.5t32.5 -17.5t45.5 -7q25 0 48 6t40.5 16.5t27.5 25t10 32.5 q0 32 -33 49t-93 17h-22l9 40h21q66 0 105.5 19.5t39.5 57.5q0 28 -25.5 44.5t-61.5 16.5q-39 0 -70.5 -15.5t-51.5 -40.5l-23 34q24 29 66 46t87 17q58 0 92.5 -26.5t34.5 -67.5q0 -40 -27.5 -66.5t-80.5 -37.5q38 -6 58.5 -29.5t20.5 -55.5q0 -30 -15.5 -53t-41 -39.5 t-58 -25t-66.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 820,
    d: "M49 27l669 687l28 -30l-669 -688zM265 371l-10 -45h-193l10 45h77l65 309q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l10 45q15 0 32.5 8t33 18t26 19t10.5 10h45l-77 -360h72zM562 -5q-60 0 -94.5 30t-34.5 72q0 23 9.5 41.5t25.5 33.5t36 25.5t40 16.5 q-23 9 -39.5 27t-16.5 44t15 47t38 36t52 23t56 8q23 0 44.5 -6t38.5 -17.5t27 -27.5t10 -36q0 -37 -28 -61.5t-66 -36.5q31 -11 50 -33t19 -54q0 -29 -15.5 -53t-41 -41.5t-58.5 -27.5t-67 -10zM574 39q22 0 44 6.5t40 17.5t29.5 27t11.5 36q0 16 -8 28.5t-21.5 21.5 t-30 13.5t-34.5 4.5q-22 0 -44.5 -6.5t-40.5 -18t-29.5 -28t-11.5 -36.5q0 -15 8 -27.5t21.5 -21t30.5 -13t35 -4.5zM614 231q18 0 37 5t34.5 14t26 22t10.5 30q0 26 -25 40.5t-57 14.5q-20 0 -39.5 -5t-34.5 -14.5t-24 -23t-9 -29.5q0 -26 25.5 -40t55.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 825,
    d: "M191 321q-54 0 -90.5 23t-38.5 66l34 29q0 -13 6.5 -26t19.5 -23.5t32.5 -17t45.5 -6.5q25 0 48 6t40.5 16.5t28 25t10.5 32.5q0 31 -34 48t-93 17h-22l8 41h22q67 0 105.5 19.5t38.5 57.5q0 28 -25 44.5t-61 16.5q-39 0 -70.5 -15.5t-51.5 -40.5l-23 34q23 29 65.5 46 t88.5 17q57 0 91.5 -26.5t34.5 -68.5q0 -40 -28 -66t-80 -37q37 -6 57.5 -29.5t20.5 -55.5q0 -30 -15.5 -53.5t-40.5 -40t-57.5 -25t-66.5 -8.5zM73 27l669 687l28 -30l-669 -688zM567 -5q-60 0 -94.5 30t-34.5 72q0 23 9.5 41.5t25.5 33.5t36 25.5t40 16.5q-23 9 -39.5 27 t-16.5 44t15 47t38 36t52 23t56 8q23 0 44.5 -6t38.5 -17.5t27 -27.5t10 -36q0 -37 -28 -61.5t-66 -36.5q31 -11 50 -33t19 -54q0 -29 -15.5 -53t-41 -41.5t-58.5 -27.5t-67 -10zM579 39q22 0 44 6.5t40 17.5t29.5 27t11.5 36q0 16 -8 28.5t-21.5 21.5t-30 13.5t-34.5 4.5 q-22 0 -44.5 -6.5t-40.5 -18t-29.5 -28t-11.5 -36.5q0 -15 8 -27.5t21.5 -21t30.5 -13t35 -4.5zM619 231q18 0 37 5t34.5 14t26 22t10.5 30q0 26 -25 40.5t-57 14.5q-20 0 -39.5 -5t-34.5 -14.5t-24 -23t-9 -29.5q0 -26 25.5 -40t55.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 832,
    d: "M248 585q54 0 88 -29t34 -76q0 -34 -15.5 -62t-41.5 -48.5t-59.5 -32t-70.5 -11.5q-47 0 -80.5 20t-44.5 55l35 25q11 -26 37.5 -42t64.5 -16q25 0 48.5 8t41 22t28 33.5t10.5 43.5q0 36 -26.5 55t-59.5 19q-29 0 -58.5 -13t-48.5 -34h-41q7 18 22 51.5t30 69t28 65.5 t18 42h214l-10 -44h-180l-58 -131q41 30 95 30zM71 27l669 687l28 -30l-669 -688zM573 -5q-60 0 -94.5 30t-34.5 72q0 23 9.5 41.5t25.5 33.5t36 25.5t40 16.5q-23 9 -39.5 27t-16.5 44t15 47t38 36t52 23t56 8q23 0 44.5 -6t38.5 -17.5t27 -27.5t10 -36q0 -37 -28 -61.5 t-66 -36.5q31 -11 50 -33t19 -54q0 -29 -15.5 -53t-41 -41.5t-58.5 -27.5t-67 -10zM585 39q22 0 44 6.5t40 17.5t29.5 27t11.5 36q0 16 -8 28.5t-21.5 21.5t-30 13.5t-34.5 4.5q-22 0 -44.5 -6.5t-40.5 -18t-29.5 -28t-11.5 -36.5q0 -15 8 -27.5t21.5 -21t30.5 -13t35 -4.5z M625 231q18 0 37 5t34.5 14t26 22t10.5 30q0 26 -25 40.5t-57 14.5q-20 0 -39.5 -5t-34.5 -14.5t-24 -23t-9 -29.5q0 -26 25.5 -40t55.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 811,
    d: "M6 27l669 687l28 -30l-669 -688zM554 -5q-60 0 -94.5 30t-34.5 72q0 23 9.5 41.5t25.5 33.5t36 25.5t40 16.5q-23 9 -39.5 27t-16.5 44t15 47t38 36t52 23t56 8q23 0 44.5 -6t38.5 -17.5t27 -27.5t10 -36q0 -37 -28 -61.5t-66 -36.5q31 -11 50 -33t19 -54 q0 -29 -15.5 -53t-41 -41.5t-58.5 -27.5t-67 -10zM566 39q22 0 44 6.5t40 17.5t29.5 27t11.5 36q0 16 -8 28.5t-21.5 21.5t-30 13.5t-34.5 4.5q-22 0 -44.5 -6.5t-40.5 -18t-29.5 -28t-11.5 -36.5q0 -15 8 -27.5t21.5 -21t30.5 -13t35 -4.5zM606 231q18 0 37 5t34.5 14 t26 22t10.5 30q0 26 -25 40.5t-57 14.5q-20 0 -39.5 -5t-34.5 -14.5t-24 -23t-9 -29.5q0 -26 25.5 -40t55.5 -14zM359 686h-237l9 44h307l-308 -399h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 563,
    d: "M251 -10q-48 0 -88 16t-69.5 43.5t-45.5 65t-16 80.5q0 47 19.5 90.5t53.5 76.5t78.5 52.5t94.5 19.5q63 0 109 -31t62 -87q3 23 4.5 51t1.5 51q0 66 -11.5 111.5t-32.5 73.5t-50.5 40t-66.5 12q-47 0 -89 -16t-63 -42l-38 41q32 38 84.5 57.5t110.5 19.5 q109 0 164.5 -74t55.5 -242q0 -101 -19.5 -177.5t-55 -128t-84.5 -77.5t-109 -26zM252 50q39 0 72.5 16t57.5 41.5t37.5 57.5t13.5 65q0 30 -12 57t-32.5 47.5t-48.5 32t-61 11.5q-36 0 -69 -14.5t-57.5 -38.5t-39.5 -56.5t-15 -68.5q0 -32 11.5 -59t32 -47.5t49 -32 t61.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 649,
    d: "M596 53v-53h-601v53l273 657h58zM520 62l-223 566l-225 -566h448z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 744,
    d: "M558 648h-334v-738h-66v738h-83v62h629v-62h-80v-738h-66v738z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 599,
    d: "M522 653h-350v-4l203 -280l-218 -301v-4h380v-64h-463v51l226 309l-220 304v46h442v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 550,
    d: "M72 267v56h403v-56h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 568,
    d: "M-62 30l682 684l34 -34l-681 -684z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 186,
    d: "M52 246l23 112h58l-23 -112h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 407,
    d: "M19 365h139l72 -303l118 728h66l-148 -790h-75l-90 314h-82v51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 692,
    d: "M212 517q29 0 50.5 -8.5t38.5 -22.5t30 -33t24 -40q11 21 24 40t30 33t38.5 22.5t50.5 8.5q36 0 64.5 -13t49 -35.5t31.5 -53t11 -64.5t-12 -64t-33 -52.5t-50 -35.5t-62 -13q-27 0 -48.5 8t-38 21.5t-29.5 31t-24 37.5q-11 -20 -23.5 -37.5t-29.5 -31t-39.5 -21.5 t-52.5 -8q-31 0 -59.5 13t-50 35.5t-34.5 53t-13 64.5t12 64t33 52.5t50 35.5t62 13zM212 241q23 0 41 8.5t32 23.5t25.5 35t22.5 42q-11 22 -22 42.5t-25.5 35.5t-32 24t-41.5 9q-18 0 -36 -6.5t-33 -19.5t-24 -34t-9 -49q0 -29 9 -49.5t24 -34.5t33 -20.5t36 -6.5z M498 241q18 0 36.5 6.5t32.5 20.5t23 34.5t9 49.5q0 28 -9 49t-23 34t-32.5 19.5t-36.5 6.5q-24 0 -42 -9.5t-32 -25t-24.5 -36.5t-20.5 -44q10 -21 21.5 -40.5t25.5 -33.5t31.5 -22.5t40.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 296,
    d: "M105 673q-1 10 -1 19v18q0 25 3.5 45t14 34.5t29 22.5t48.5 8q22 0 49.5 -6t48.5 -15l-17 -48q-14 6 -31 10t-28 4q-26 0 -41.5 -13t-15.5 -39v-7.5v-8.5t0.5 -13.5t1.5 -22.5l38 -684q2 -28 2 -35v-9q0 -48 -26 -74t-71 -26q-21 0 -48 6t-48 15l17 48q14 -6 30 -10 t28 -4q19 0 30 4.5t16.5 15.5t7 29.5t1.5 46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 442,
    d: "M366 324q-14 -15 -34 -26t-49 -11q-24 0 -42.5 6.5t-34.5 14.5t-31.5 14.5t-31.5 6.5q-19 0 -30 -7t-17 -16l-32 36q11 16 29.5 27t47.5 11q22 0 39.5 -6.5t33.5 -14.5t32 -14.5t36 -6.5t32.5 5.5t20.5 13.5zM366 207q-14 -14 -34 -24t-49 -10q-24 0 -42.5 6.5 t-34.5 14.5t-31.5 14.5t-31.5 6.5q-19 0 -30 -7t-17 -16l-32 36q11 16 29.5 27.5t47.5 11.5q22 0 39.5 -6.5t33.5 -14.5t32 -14.5t36 -6.5t32.5 5t20.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 476,
    d: "M81 358h174l66 116l35 -16l-57 -100h84v-49h-112l-37 -66h149v-49h-177l-66 -116l-34 15l57 101h-82v49h109l38 66h-147v49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 459,
    d: "M55 61v57h322v-57h-322zM54 383l318 159v-66l-219 -111l219 -109v-68l-318 157v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 478,
    d: "M71 118h322v-57h-322v57zM76 256l219 109l-219 111l-3 66l321 -159v-38l-318 -157v68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 506,
    d: "M303 730l186 -364l-186 -366h-73l-186 366l186 364h73zM425 354l-161 322l-151 -301l160 -322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 149,
    d: "M16 -199l32 74h-20l17 76h61l-16 -76l-40 -74h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 773,
    d: "M175 -10q-62 0 -111 22t-78 54l39 47q69 -71 160 -71q27 0 54 6.5t48.5 20t35.5 34t14 47.5q0 23 -10 37t-27 23t-40 14t-50 10q-32 6 -59.5 12.5t-47.5 18.5t-32 32.5t-12 54.5q0 45 20 78.5t52 55.5t70.5 33t76.5 11q31 0 61 -7.5t51 -23.5q-5 20 -8.5 38.5t-3.5 40.5 q0 30 9.5 60.5t31.5 54.5t58.5 39t90.5 15q65 0 89.5 -24t24.5 -70q0 -26 -6 -58.5t-14 -73.5h113l-12 -54h-112l-75 -354q-1 -5 -1.5 -8t-0.5 -6q0 -22 14 -32t35 -10q25 0 48 9.5t31 13.5l5 -55q-7 -3 -19.5 -8t-28 -10t-34 -9t-36.5 -4q-38 0 -63 18.5t-25 54.5 q0 10 2 20t4 22l76 358h-69l12 54h68q9 42 14 72.5t5 51.5q0 38 -16 51.5t-52 13.5q-38 0 -63.5 -11.5t-40.5 -30.5t-21.5 -43.5t-6.5 -50.5q0 -42 9.5 -73t14.5 -41l-41 -40q-23 35 -57.5 47t-68.5 12q-27 0 -53 -6t-46.5 -19t-33.5 -34t-13 -50q0 -25 10 -40.5t27.5 -24.5 t42 -14t53.5 -10t55.5 -11t47 -18t32.5 -32.5t12 -53.5q0 -44 -20.5 -77t-53.5 -55t-74 -33t-81 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 564,
    d: "M312 548h52l119 -548h-66l-36 165h-249l-106 -165h-67zM377 220l-56 250l-162 -250h218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 557,
    d: "M135 548h276q25 0 44.5 -9.5t32.5 -25.5t19.5 -36.5t6.5 -42.5q0 -49 -31 -91t-81 -62q38 -12 59 -42t21 -71q0 -37 -16.5 -68t-44 -53t-63 -34.5t-72.5 -12.5h-268zM297 54q23 0 45 9.5t39 26t27.5 37t10.5 43.5q0 32 -19.5 56.5t-54.5 24.5h-211l-41 -197h204zM334 302 q22 0 43 9t37 25t25.5 36.5t9.5 43.5q0 33 -19 54.5t-51 21.5h-194l-40 -190h189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 570,
    d: "M246 -5q-51 0 -90.5 20t-66.5 53t-41.5 75.5t-14.5 87.5q0 55 25 112t69.5 103.5t106 75.5t134.5 29q76 0 123.5 -33.5t62.5 -86.5l-56 -32q-8 27 -23 45t-34.5 29.5t-42.5 16t-45 4.5q-57 0 -104 -23.5t-81 -61t-52.5 -83.5t-18.5 -91q0 -37 11.5 -70.5t32.5 -58.5 t51.5 -39.5t68.5 -14.5q24 0 49.5 5.5t51 17.5t49 31t42.5 45l46 -29q-21 -30 -50.5 -54t-64 -40t-70 -24.5t-68.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 600,
    d: "M135 548h195q57 0 99.5 -16.5t70 -45.5t41 -68.5t13.5 -84.5q0 -72 -25.5 -133.5t-71 -105.5t-108 -69t-135.5 -25h-196zM225 56q62 0 111 21.5t83 58.5t52 85.5t18 101.5q0 37 -11 68t-32.5 53.5t-53.5 35t-74 12.5h-133l-92 -436h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 509,
    d: "M135 548h377l-11 -56h-316l-39 -187h275l-12 -52h-274l-42 -197h322l-12 -56h-385z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 498,
    d: "M135 548h374l-12 -56h-312l-40 -190h264l-12 -54h-264l-52 -248h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 701,
    d: "M300 -5q-60 0 -107 24.5t-79.5 65t-49.5 94t-17 111.5q0 80 33 156.5t89 136t129.5 96t153.5 36.5q85 0 142 -42t82 -111l-63 -45q-9 25 -24 49.5t-37 43.5t-51.5 30.5t-65.5 11.5q-65 0 -123 -32t-101.5 -83t-68.5 -115t-25 -127q0 -46 12.5 -89t36.5 -76t60 -52.5 t83 -19.5q48 0 92.5 19t82 51t66.5 73t45 85h-195l14 63h270l-10 -38q-17 -63 -53 -120.5t-86 -101t-110.5 -69t-124.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 593,
    d: "M439 76q-93 -80 -194 -80q-49 0 -88 19.5t-66.5 51.5t-42 74.5t-14.5 87.5q0 62 27 120t72 103t104.5 72t124.5 27q82 0 127.5 -33t62.5 -86l-56 -33q-15 50 -54.5 73t-93.5 23q-52 0 -98 -23t-80 -60.5t-53.5 -84t-19.5 -94.5q0 -37 11.5 -70t33 -57.5t52 -38.5 t67.5 -14q48 0 95.5 21.5t96.5 67.5l18 81h-124l9 48h178l-57 -271h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 617,
    d: "M135 548h62l-51 -239h329l50 239h62l-116 -548h-62l53 252h-328l-53 -252h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 226,
    d: "M135 547h62l-116 -547h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 413,
    d: "M83 -8q-74 0 -117 33l28 51q14 -11 40 -19.5t61 -8.5q42 0 70.5 14.5t47.5 42.5t31.5 69t24.5 95l59 278h63l-60 -278q-14 -63 -30.5 -114t-44 -87t-69 -56t-104.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 539,
    d: "M135 547h62l-66 -309l371 310h69l-282 -241l178 -307h-68l-157 270l-125 -102l-36 -168h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 469,
    d: "M135 548h62l-104 -492h311l-12 -56h-374z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 212,
    d: "M53 637l76 93h72l-106 -110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 726,
    d: "M135 548h65l139 -364l293 364h65l-117 -548h-62l92 435l-271 -335h-36l-130 335l-92 -435h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 642,
    d: "M135 548h48l274 -439l93 438h63l-116 -547h-54l-271 431l-91 -431h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 624,
    d: "M247 -4q-51 0 -91 19t-67.5 51t-42 73.5t-14.5 86.5q0 62 27.5 120.5t74 104t107 73t125.5 27.5q51 0 91 -19.5t67 -52t41 -74t14 -85.5q0 -62 -27.5 -120.5t-73.5 -103.5t-106 -72.5t-125 -27.5zM260 53q54 0 100.5 23.5t81 61t54.5 84t20 92.5q0 36 -11 68.5t-32 57.5 t-51.5 39.5t-68.5 14.5q-53 0 -100 -23.5t-82 -60.5t-55 -84t-20 -93q0 -36 11 -68.5t32 -57.5t51.5 -39.5t69.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 523,
    d: "M135 548h236q32 0 57.5 -12.5t43 -33t27 -47t9.5 -54.5q0 -37 -16.5 -73t-44.5 -64.5t-65.5 -46.5t-79.5 -18h-179l-42 -199h-63zM310 255q28 0 52.5 12t42.5 31.5t28.5 44.5t10.5 52q0 42 -24.5 69.5t-63.5 27.5h-171l-50 -237h175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 623,
    d: "M414 45q-38 -23 -80 -36t-87 -13q-51 0 -91 19t-67.5 51t-42 73.5t-14.5 86.5q0 62 28 120.5t74.5 104t106.5 73t125 27.5q51 0 91 -19.5t67 -52t41 -74t14 -85.5q0 -69 -34 -133.5t-89 -110.5l50 -76h-62zM260 53q34 0 65.5 10t58.5 27l-56 85h63l35 -53 q42 38 65.5 89.5t23.5 103.5q0 36 -11 68.5t-31.5 57t-50.5 39.5t-69 15q-53 0 -100 -23.5t-82 -61t-55 -84.5t-20 -93q0 -36 11 -68.5t32 -57.5t51.5 -39.5t69.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 550,
    d: "M135 548h241q33 0 58.5 -12.5t43 -33t27 -47t9.5 -54.5q0 -32 -12.5 -63.5t-34.5 -57t-51.5 -44t-63.5 -25.5l94 -211h-72l-89 199h-162l-42 -199h-63zM315 255q27 0 51.5 12t43 31.5t29.5 44.5t11 51q0 40 -24.5 69t-64.5 29h-176l-50 -237h180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 508,
    d: "M200 -5q-131 0 -211 78l42 52q24 -32 70.5 -53.5t112.5 -21.5q71 0 113.5 27t42.5 78q0 39 -37.5 58t-108.5 35q-36 8 -63.5 18t-46.5 24t-28.5 32.5t-9.5 44.5q0 44 18.5 78t50.5 57.5t75 36t93 12.5q110 0 168 -63l-39 -50q-19 26 -54.5 42t-86.5 16 q-84 0 -121.5 -31.5t-37.5 -79.5q0 -35 33.5 -52t100.5 -33q37 -9 67 -19t51.5 -24.5t33 -34.5t11.5 -49q0 -45 -18.5 -78.5t-51 -55.5t-76 -33t-93.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 509,
    d: "M264 492h-201l12 56h462l-12 -56h-199l-104 -492h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 624,
    d: "M248 -4q-53 0 -89.5 14.5t-59 40t-32.5 60t-10 73.5q0 21 2.5 43t7.5 44l59 277h62l-58 -277q-4 -20 -6.5 -38.5t-2.5 -36.5q0 -30 7 -56t23.5 -45.5t42.5 -30.5t65 -11q52 0 90 19t65 49.5t43.5 69.5t25.5 80l59 277h62l-59 -277q-12 -56 -35 -105.5t-59.5 -87.5 t-87 -60t-115.5 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 561,
    d: "M67 548h66l100 -461l293 461h67l-352 -548h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1009,
    d: "M100 710h77l50 -609l318 609h76l65 -609l308 609h79l-366 -710h-73l-75 597l-322 -597h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 857,
    d: "M66 548h68l104 -472l150 231l-49 237h59l37 -192l120 192h60l-150 -237l53 -231l304 472h68l-357 -548h-54l-61 264l-173 -264h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 529,
    d: "M224 270l-158 278h70l132 -233l230 233h70l-276 -278l153 -270h-69l-127 225l-223 -225h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 526,
    d: "M207 203l-145 345h68l119 -290l244 290h69l-293 -346l-43 -202h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 525,
    d: "M-18 49l473 443h-372l12 56h446l-11 -50l-468 -442h373l-12 -56h-451z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 596,
    d: "M209 -10q-44 0 -78.5 17.5t-58 47t-36 69t-12.5 83.5q0 64 25 122.5t66.5 103t94 71t108.5 26.5q62 0 103 -33.5t57 -85.5l23 106h68l-110 -517h-68l22 105q-38 -52 -91 -83.5t-113 -31.5zM237 50q29 0 56.5 10t52 27t45.5 40.5t37 50.5l34 158q-8 58 -45 96t-94 38 q-45 0 -86.5 -23t-72.5 -59t-49.5 -81t-18.5 -90q0 -34 9.5 -64.5t27.5 -53t44.5 -36t59.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 519,
    d: "M130 -10q-30 0 -55 10t-42.5 28t-27 42.5t-9.5 52.5q0 49 23 84.5t58.5 58t79 33t84.5 10.5q51 0 86.5 -9t52.5 -18l11 47q4 20 4 42q0 50 -28.5 79t-82.5 29q-38 0 -81 -16t-91 -46l-13 45q48 29 99 48.5t102 19.5q82 0 122.5 -40.5t40.5 -109.5q0 -29 -6 -57l-68 -323 h-66l17 82q-44 -48 -99.5 -70t-110.5 -22zM158 42q21 0 44 4.5t45.5 13.5t43.5 23t37 32q21 22 25 39l18 85q-30 14 -63.5 20.5t-66.5 6.5q-29 0 -60.5 -7t-57.5 -22.5t-43 -40t-17 -60.5q0 -42 27 -68t68 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 840,
    d: "M222 -10q-48 0 -84.5 18t-62 48.5t-38.5 70.5t-13 83q0 59 24 116.5t65.5 102.5t98 73t121.5 28q47 0 77 -11.5t53 -32.5q-6 18 -12 42.5t-6 50.5q0 34 12.5 64.5t35.5 53.5t56 36.5t75 13.5q36 0 60 -7t38.5 -20t20 -31.5t5.5 -41.5q0 -26 -5.5 -58t-13.5 -68h112 l-12 -54h-112l-75 -354q-1 -3 -1 -6.5v-5.5q0 -23 14 -33.5t34 -10.5q24 0 45.5 8.5t34.5 14.5l5 -55q-21 -9 -52 -20t-68 -11q-38 0 -62.5 18.5t-24.5 56.5q0 11 3 25l80 373h-69l11 54h69q7 32 12.5 61t5.5 53q0 34 -17 54.5t-63 20.5q-30 0 -52 -11.5t-37 -30t-22.5 -43 t-7.5 -50.5q0 -23 4.5 -48t10 -48.5t11 -42.5t7.5 -30l-70 -21q-14 45 -46.5 65t-78.5 20q-47 0 -87.5 -23t-71 -59t-48 -80.5t-17.5 -88.5q0 -35 10 -65.5t28.5 -53.5t44 -36.5t57.5 -13.5q20 0 43.5 6t46 17.5t41.5 28t30 37.5l62 -20q-18 -31 -44.5 -55t-58 -40.5 t-65.5 -25t-67 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 593,
    d: "M211 -10q-44 0 -78.5 17.5t-58.5 47.5t-36.5 69.5t-12.5 83.5q0 62 24 120t64 103t92 72t109 27q62 0 102 -34.5t60 -83.5l68 318h68l-155 -730h-68l20 97q-38 -48 -91 -77.5t-107 -29.5zM238 50q24 0 53.5 10t56.5 27.5t48.5 41t30.5 50.5l33 161q-3 27 -15.5 51 t-32 41.5t-43.5 27.5t-49 10q-45 0 -86 -22.5t-71.5 -58.5t-48.5 -80.5t-18 -89.5q0 -35 10 -65.5t28.5 -53.5t45 -36.5t58.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 570,
    d: "M502 229q0 -53 -24.5 -96.5t-64.5 -74.5t-91 -48.5t-105 -17.5q-44 0 -80 13.5t-61 37t-38.5 55.5t-13.5 69q0 42 16.5 76.5t42 61.5t56.5 45.5t61 29.5q-35 17 -58 49t-23 75q0 49 24 87t60.5 64.5t81.5 40.5t87 14q34 0 66 -10t57 -29t40 -47.5t15 -64.5 q0 -33 -12.5 -60.5t-33.5 -50t-47.5 -40t-54.5 -28.5q43 -17 71.5 -57t28.5 -94zM433 227q0 29 -12 52t-31.5 39t-44.5 24.5t-51 8.5q-34 0 -69.5 -12.5t-64 -35.5t-47 -55t-18.5 -71q0 -29 11.5 -52t31 -39t44.5 -24.5t51 -8.5q34 0 69.5 12.5t64.5 35.5t47.5 55t18.5 71z M187 507q0 -24 10.5 -43t27.5 -32t38.5 -20t43.5 -7q27 0 57.5 9.5t56 28t42 45t16.5 60.5q0 24 -9.5 42.5t-26 31t-38.5 19.5t-47 7q-31 0 -61.5 -10t-55 -28.5t-39.5 -44.5t-15 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 537,
    d: "M192 -10q-72 0 -121.5 37t-66.5 100l52 34q16 -50 55.5 -79.5t93.5 -29.5q40 0 77.5 15.5t66 43t45.5 65t17 80.5q0 60 -35 97.5t-92 37.5q-44 0 -87.5 -21t-75.5 -59h-63q4 8 17 41t31 77.5t37.5 94t36 91t27.5 68.5l11 27h327l-14 -63h-275l-101 -255q31 29 69 44 t80 15q40 0 72.5 -13.5t56 -37.5t36.5 -57.5t13 -73.5q0 -60 -24.5 -111.5t-65 -88.5t-92.5 -58t-108 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 363,
    d: "M243 585q54 0 88 -29t34 -76q0 -34 -15.5 -62t-41.5 -48.5t-59.5 -32t-70.5 -11.5q-47 0 -80.5 20t-44.5 55l35 25q11 -26 37.5 -42t64.5 -16q25 0 48.5 8t41 22t28 33.5t10.5 43.5q0 36 -26.5 55t-59.5 19q-29 0 -58.5 -13t-48.5 -34h-41q7 18 22 51.5t30 69t28 65.5 t18 42h214l-10 -44h-180l-58 -131q41 30 95 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 384,
    d: "M125 -5q-60 0 -94.5 30t-34.5 72q0 23 9.5 41.5t25.5 33.5t36 25.5t40 16.5q-23 9 -39.5 27t-16.5 44t15 47t38 36t52 23t56 8q23 0 44.5 -6t38.5 -17.5t27 -27.5t10 -36q0 -37 -28 -61.5t-66 -36.5q31 -11 50 -33t19 -54q0 -29 -15.5 -53t-41 -41.5t-58.5 -27.5t-67 -10 zM137 39q22 0 44 6.5t40 17.5t29.5 27t11.5 36q0 16 -8 28.5t-21.5 21.5t-30 13.5t-34.5 4.5q-22 0 -44.5 -6.5t-40.5 -18t-29.5 -28t-11.5 -36.5q0 -15 8 -27.5t21.5 -21t30.5 -13t35 -4.5zM177 231q18 0 37 5t34.5 14t26 22t10.5 30q0 26 -25 40.5t-57 14.5 q-20 0 -39.5 -5t-34.5 -14.5t-24 -23t-9 -29.5q0 -26 25.5 -40t55.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 546,
    d: "M292 0l40 190h-329l14 61l447 459h47l-97 -458h84l-14 -62h-84l-40 -190h-68zM352 252l75 352l-337 -352h262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 213,
    d: "M119 517h68l-155 -730h-68zM162 721h68l-19 -91h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 225,
    d: "M169 730h68l-155 -730h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 588,
    d: "M76 428q0 58 25 110t66 91.5t95 62.5t111 23q88 0 139 -59t51 -163q0 -99 -25.5 -189.5t-72 -160.5t-111 -111.5t-142.5 -41.5q-66 0 -112 35t-61 98l51 39q9 -51 45.5 -81t89.5 -30q42 0 80 20.5t70.5 60.5t58 97t41.5 131q-17 -29 -40.5 -53t-51 -41t-58.5 -26t-62 -9 q-42 0 -76.5 15t-59 41.5t-38 62.5t-13.5 78zM359 656q-40 0 -79 -17.5t-69.5 -47.5t-49 -69.5t-18.5 -82.5q0 -32 10 -59.5t28.5 -48t44 -32.5t56.5 -12q40 0 79 17.5t69.5 47.5t49.5 69t19 82q0 32 -10.5 60t-29 48.5t-44 32.5t-56.5 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 398,
    d: "M13 62h128l123 581q-10 -12 -30.5 -26.5t-44.5 -28t-48.5 -22.5t-43.5 -9l13 64q25 0 54.5 14.5t55 32.5t43 33.5t18.5 17.5h69l-139 -657h120l-13 -62h-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 260,
    d: "M256 371l-10 -45h-193l10 45h77l65 309q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l10 45q15 0 32.5 8t33 18t26 19t10.5 10h45l-77 -360h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 377,
    d: "M-27 0q8 39 21.5 67.5t33 50.5t45.5 38t59 28q26 9 53 18t49.5 21.5t36.5 30.5t14 45q0 26 -19.5 44t-61.5 18q-24 0 -44.5 -5.5t-37 -14t-29.5 -18.5t-22 -18l-22 32q5 5 19 16t35.5 22.5t51 20t64.5 8.5q60 0 88.5 -27t28.5 -69q0 -32 -11.5 -54t-32.5 -39t-51 -30 t-67 -25q-34 -11 -56 -25.5t-36 -30t-21 -31.5t-10 -29h231l-9 -44h-300v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 370,
    d: "M199 103h-217l9 42l284 254h31l-54 -252h56l-10 -44h-55l-22 -103h-44zM210 147l40 191l-210 -191h170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 375,
    d: "M116 -5q-26 0 -49.5 5.5t-41 17t-27.5 28t-10 38.5l32 28q0 -12 7 -25t20 -23.5t32.5 -17.5t45.5 -7q25 0 48 6t40.5 16.5t27.5 25t10 32.5q0 32 -33 49t-93 17h-22l9 40h21q66 0 105.5 19.5t39.5 57.5q0 28 -25.5 44.5t-61.5 16.5q-39 0 -70.5 -15.5t-51.5 -40.5l-23 34 q24 29 66 46t87 17q58 0 92.5 -26.5t34.5 -67.5q0 -40 -27.5 -66.5t-80.5 -37.5q38 -6 58.5 -29.5t20.5 -55.5q0 -30 -15.5 -53t-41 -39.5t-58 -25t-66.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 592,
    d: "M411 108q-48 -58 -102 -88t-111 -30q-42 0 -74.5 17.5t-54.5 46.5t-33.5 68t-11.5 82q0 64 25.5 123t67.5 104t96 72t111 27q58 0 100 -31.5t60 -79.5l21 102h61l-155 -734h-68zM232 50q28 0 55 10t52 26.5t46.5 39t39.5 47.5l35 166q-1 26 -11.5 49.5t-28.5 41.5 t-42.5 29t-51.5 11q-45 0 -87 -22.5t-74 -58.5t-51 -81.5t-19 -92.5q0 -34 9.5 -64t27 -52.5t43 -35.5t57.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 499,
    d: "M459 647h-360l13 63h469l-493 -710h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 340,
    d: "M342 686h-237l9 44h307l-308 -399h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 588,
    d: "M238 -10q-89 0 -139.5 59.5t-50.5 162.5q0 99 25.5 190t71.5 160.5t111 111t143 41.5q66 0 112 -35t61 -97l-52 -40q-10 51 -46 81.5t-89 30.5q-41 0 -79.5 -21t-71 -60.5t-58 -97.5t-41.5 -131q17 29 40.5 53t51.5 41t58.5 26t62.5 9q42 0 76.5 -15t58.5 -41.5 t37.5 -62.5t13.5 -78q0 -58 -25 -110t-66 -91.5t-94.5 -62.5t-110.5 -23zM251 50q40 0 79 17.5t69.5 47.5t49 69t18.5 82q0 32 -10 59.5t-28 48t-43.5 32.5t-56.5 12q-41 0 -79.5 -17.5t-69 -47.5t-49 -69t-18.5 -82q0 -32 10 -59.5t28.5 -48t44 -32.5t55.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 311,
    d: "M133 459h-73l13 62h73l37 176h70l-38 -176h118l-13 -62h-118l-97 -459h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 558,
    d: "M206 -9q-44 0 -79 11.5t-60.5 33t-39 52t-13.5 68.5l49 38q0 -61 39 -100t114 -39q39 0 75.5 12t64 33t44 49.5t16.5 61.5q0 59 -49.5 90.5t-139.5 31.5h-32l12 59h33q104 0 165.5 38.5t61.5 110.5q0 55 -35.5 86t-93.5 31q-29 0 -57 -8t-52.5 -21.5t-44.5 -32t-33 -39.5 l-37 46q19 27 46 48.5t58.5 36.5t66 23t68.5 8q43 0 77.5 -12.5t59 -34.5t37.5 -53t13 -68q0 -67 -43 -116.5t-127 -69.5q55 -11 85.5 -52t30.5 -97q0 -51 -24.5 -92.5t-64 -71t-89.5 -45.5t-102 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 374,
    d: "M185 321q-54 0 -90.5 23t-38.5 66l34 29q0 -13 6.5 -26t19.5 -23.5t32.5 -17t45.5 -6.5q25 0 48 6t40.5 16.5t28 25t10.5 32.5q0 31 -34 48t-93 17h-22l8 41h22q67 0 105.5 19.5t38.5 57.5q0 28 -25 44.5t-61 16.5q-39 0 -70.5 -15.5t-51.5 -40.5l-23 34q23 29 65.5 46 t88.5 17q57 0 91.5 -26.5t34.5 -68.5q0 -40 -28 -66t-80 -37q37 -6 57.5 -29.5t20.5 -55.5q0 -30 -15.5 -53.5t-40.5 -40t-57.5 -25t-66.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 556,
    d: "M-16 0q13 69 35.5 120.5t54 89.5t72 65.5t90.5 49.5q40 18 83 34.5t78.5 39.5t58 57t22.5 87q0 23 -7 43.5t-21 35.5t-36.5 24t-52.5 9q-36 0 -68 -11t-59 -27.5t-48 -35t-35 -33.5l-34 49q7 7 29 27t56.5 41t80 37.5t99.5 16.5q44 0 76.5 -13t53.5 -35.5t31.5 -52.5 t10.5 -63q0 -61 -23.5 -103.5t-60 -72.5t-82 -51.5t-88.5 -39.5q-57 -24 -95.5 -50t-63.5 -54t-38 -58.5t-20 -63.5h371l-13 -62h-457v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 374,
    d: "M42 327q8 39 21.5 67.5t33 50t45.5 37.5t59 28q26 10 53.5 19t50 21.5t36.5 30.5t14 45q0 26 -20 43.5t-62 17.5q-24 0 -44 -5.5t-37 -14t-29.5 -18t-21.5 -17.5l-23 31q5 5 19 16.5t36 23t51 20t64 8.5q60 0 88.5 -27t28.5 -69q0 -31 -12 -53.5t-33 -40t-51 -30 t-66 -24.5q-34 -11 -56 -25.5t-36 -30t-21 -31.5t-10 -30h226l-9 -43h-295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 565,
    d: "M164 -10q-71 0 -99 37t-28 96q0 21 3.5 43.5t8.5 48.5l65 306h68l-63 -294q-5 -22 -7.5 -42t-2.5 -37q0 -44 19.5 -71t69.5 -27q29 0 58.5 11.5t56.5 31t49.5 45.5t38.5 55l70 328h68l-111 -521h-66l25 114q-21 -29 -47 -52t-55 -39t-60 -24.5t-61 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 790,
    d: "M64 521h72l48 -436l222 436h66l37 -436l234 436h71l-285 -521h-72l-40 418l-218 -418h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 508,
    d: "M32 -213q1 1 14.5 24t32.5 55.5t40.5 68.5t39.5 65l-104 521h72l83 -458l264 458h65l-431 -734h-76v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 658,
    d: "M263 -10q-56 0 -96 25.5t-66 66.5t-38.5 91.5t-12.5 101.5q0 74 29 151.5t79 140.5t116.5 103t141.5 40q57 0 97 -26t65.5 -67t37.5 -92t12 -102q0 -49 -13 -100.5t-37 -99.5t-57.5 -90.5t-74 -74t-87 -50t-96.5 -18.5zM276 53q62 0 113.5 36.5t89 91t58 118.5t20.5 119 q0 43 -9 84t-28 73t-48 52t-69 20q-42 0 -79 -17.5t-68.5 -47t-56 -68t-42 -80.5t-26.5 -85t-9 -81q0 -42 8.5 -81t27 -68.5t48 -47.5t70.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 157,
    d: "M13 -166l20 98h62l-20 -98h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 441,
    d: "M157 -5q-39 0 -66.5 15t-45 38.5t-26 53t-8.5 59.5q0 41 18 83t49.5 76.5t73.5 56.5t90 22q38 0 65 -15t44.5 -39t26 -53.5t8.5 -58.5q0 -41 -18 -83.5t-48.5 -77t-72.5 -56t-90 -21.5zM166 39q39 0 71.5 18.5t55 47t35 61t12.5 61.5q0 24 -6.5 47t-20 41t-34 29 t-47.5 11q-39 0 -71.5 -18.5t-55.5 -47t-35.5 -61.5t-12.5 -62q0 -23 6.5 -46t20 -41t34 -29t48.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 275,
    d: "M-7 44h85l66 309q-7 -7 -20 -15t-29 -15.5t-32 -12.5t-29 -5l10 44q16 0 35.5 8.5t36 18.5t27.5 19t11 10h46l-77 -361h79l-9 -44h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 363,
    d: "M109 -5q-47 0 -80.5 20.5t-45.5 53.5l35 26q12 -26 38.5 -42t64.5 -16q25 0 48 8t41 22t28.5 33.5t10.5 43.5q0 36 -27 55t-60 19q-29 0 -58 -13t-49 -34h-41q7 18 22 51.5t30.5 69t28.5 65.5t18 42h213l-10 -44h-179l-59 -130q40 29 96 29q54 0 87.5 -29t33.5 -76 q0 -34 -15.5 -62t-41 -48.5t-59.5 -32t-70 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 393,
    d: "M137 -5q-59 0 -93 35t-34 97q0 58 16 108t45 87t69.5 58.5t89.5 21.5q42 0 73 -18.5t42 -52.5l-33 -29q-8 26 -33 42t-59 16q-55 0 -96.5 -41t-58.5 -118q20 30 58 48t76 18q58 0 92.5 -33t34.5 -81q0 -32 -15.5 -60.5t-42 -50.5t-60.5 -34.5t-71 -12.5zM148 36 q25 0 49.5 9t43.5 24t30.5 34.5t11.5 41.5q0 35 -26.5 59t-68.5 24q-26 0 -51 -9t-44 -24t-30.5 -34.5t-11.5 -41.5q0 -35 27.5 -59t69.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 341,
    d: "M273 355h-237l9 44h307l-309 -399h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 393,
    d: "M120 -5q-43 0 -74 18.5t-42 52.5l34 29q8 -26 32.5 -42t59.5 -16q54 0 96 41.5t59 116.5q-21 -29 -58.5 -47t-76.5 -18q-58 0 -92.5 32.5t-34.5 80.5q0 33 15.5 61.5t42 50.5t60.5 34.5t71 12.5q60 0 94 -35t34 -97q0 -57 -16 -107.5t-45 -87.5t-69.5 -58.5t-89.5 -21.5z M162 170q26 0 50.5 9t43 24t30 34.5t11.5 40.5q0 34 -26.5 58.5t-68.5 24.5q-26 0 -50 -9t-43 -24t-30.5 -35t-11.5 -41q0 -35 26.5 -58.5t68.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 441,
    d: "M227 326q-38 0 -65.5 15t-45.5 38.5t-26.5 53t-8.5 59.5q0 41 18 83t49.5 76.5t73.5 56.5t90 22q38 0 65 -15t44.5 -39t26 -53.5t8.5 -58.5q0 -41 -17.5 -83.5t-48.5 -77t-73 -56t-90 -21.5zM128 497q0 -23 6.5 -46t20 -41t33.5 -29t48 -11q40 0 72 18.5t55 46.5t35.5 61 t12.5 62q0 24 -6.5 47t-20 41t-34 29t-47.5 11q-40 0 -72 -18.5t-55 -47t-35.5 -61.5t-12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 371,
    d: "M248 331l22 103h-216l9 42l283 254h31l-54 -253h56l-10 -43h-55l-21 -103h-45zM111 477h170l40 192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 393,
    d: "M397 481q0 -32 -16 -61t-42 -51t-61 -34.5t-72 -12.5q-59 0 -93 35t-34 97q0 58 16 108t45 87.5t69.5 59t89.5 21.5q43 0 74 -18.5t42 -52.5l-34 -29q-7 26 -32 42t-60 16q-54 0 -96 -41.5t-59 -117.5q20 30 58 47.5t76 17.5q58 0 93.5 -32.5t35.5 -80.5zM217 363 q26 0 50.5 9t43.5 24t30.5 35t11.5 42q0 35 -27 58.5t-69 23.5q-26 0 -50.5 -9t-43.5 -24t-30.5 -34.5t-11.5 -40.5q0 -35 27 -59.5t69 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 383,
    d: "M377 458q0 -29 -15.5 -53t-40.5 -41.5t-58 -27.5t-67 -10q-30 0 -54 8t-41 22t-26 32.5t-9 39.5q0 23 10 41.5t26 33t36 25t40 17.5q-23 9 -40 27t-17 44t15 47t38.5 36t52.5 23t56 8q23 0 44 -6t37.5 -17.5t26.5 -27.5t10 -36q0 -37 -27 -61.5t-65 -36.5q30 -11 49 -33 t19 -54zM333 457q0 16 -8 28.5t-21.5 21.5t-30 13.5t-34.5 4.5q-23 0 -45.5 -6.5t-40.5 -18t-29.5 -28t-11.5 -35.5q0 -16 8.5 -28.5t22 -21t30.5 -13t35 -4.5q21 0 43.5 6.5t40.5 17.5t29.5 27t11.5 36zM166 617q0 -26 25.5 -40.5t55.5 -14.5q18 0 37 5t35 14t26.5 22 t10.5 30q0 26 -25 40t-57 14q-20 0 -39.5 -5t-34.5 -14t-24.5 -22t-9.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 393,
    d: "M92 571q0 32 16 61t42 50.5t60.5 34.5t71.5 13q59 0 93.5 -35t34.5 -97q0 -58 -16 -108t-45 -87.5t-69.5 -59t-89.5 -21.5q-43 0 -74 19t-42 53l34 28q7 -26 32 -42t60 -16q54 0 95.5 41.5t58.5 117.5q-10 -15 -25 -27t-33 -20.5t-37.5 -13.5t-38.5 -5q-29 0 -52.5 9 t-40 24t-26 36t-9.5 45zM272 689q-26 0 -50.5 -9t-43.5 -24t-30.5 -35t-11.5 -42q0 -34 27 -58t69 -24q25 0 49.5 9t44 24t31 34.5t11.5 40.5q0 35 -27 59.5t-69 24.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xD7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "X",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xD7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xB7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "=",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0177",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012B",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0166",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0142",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0141",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0110",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "T.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xA6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "|",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "|",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "a",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xA6",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "|",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xA6",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "|",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "q.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "d.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "a.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xE1",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "w",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "g",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "d",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "a",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "/",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "y.alt",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "y",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "four.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "|",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "|",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2120",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xA6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "|",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xA6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "|",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "|",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xA6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "five.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "bar",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "brokenbar",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "trademark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae,aeacute,a.alt2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "bar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "brokenbar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "six",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "zero",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "bar",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "brokenbar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bar",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "brokenbar",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "bar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "eth",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "brokenbar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "brokenbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "ae,aeacute,a.alt2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "question",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "ae,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quoteright,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "AE,AEacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "nine.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "ae,aeacute,a.alt2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -12
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayItalic);
export default __webpack_public_path__ + "static/media/Raleway-Italic.dc61719ec9208db6179d3e5785881fa4.svg";
export { ForwardRef as ReactComponent };